"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
/* eslint-disable */

/* prebid.js v4.4.0
Updated : 2021-04-13 */


!function (u) {
  var s = window.pbjsChunk;

  window.pbjsChunk = function (e, t, n) {
    for (var r, i, o, a = 0, c = []; a < e.length; a++) {
      i = e[a], d[i] && c.push(d[i][0]), d[i] = 0;
    }

    for (r in t) {
      Object.prototype.hasOwnProperty.call(t, r) && (u[r] = t[r]);
    }

    for (s && s(e, t, n); c.length;) {
      c.shift()();
    }

    if (n) for (a = 0; a < n.length; a++) {
      o = f(f.s = n[a]);
    }
    return o;
  };

  var n = {},
      d = {
    330: 0
  };

  function f(e) {
    if (n[e]) return n[e].exports;
    var t = n[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return u[e].call(t.exports, t, t.exports, f), t.l = !0, t.exports;
  }

  f.m = u, f.c = n, f.d = function (e, t, n) {
    f.o(e, t) || Object.defineProperty(e, t, {
      configurable: !1,
      enumerable: !0,
      get: n
    });
  }, f.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return f.d(t, "a", t), t;
  }, f.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, f.p = "", f.oe = function (e) {
    throw console.error(e), e;
  }, f(f.s = 845);
}({
  0: function _(e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n.d(t, "internal", function () {
      return R;
    }), n.d(t, "bind", function () {
      return B;
    }), t.getUniqueIdentifierStr = U, t.generateUUID = function e(t) {
      return t ? (t ^ D() >> t / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, e);
    }, t.getBidIdParameter = function (e, t) {
      if (t && t[e]) return t[e];
      return "";
    }, t.tryAppendQueryString = function (e, t, n) {
      if (n) return e + t + "=" + encodeURIComponent(n) + "&";
      return e;
    }, t.parseQueryStringParameters = function (e) {
      var t,
          n = "";

      for (t in e) {
        e.hasOwnProperty(t) && (n += t + "=" + encodeURIComponent(e[t]) + "&");
      }

      return n = n.replace(/&$/, "");
    }, t.transformAdServerTargetingObj = function (t) {
      return t && 0 < Object.getOwnPropertyNames(t).length ? ue(t).map(function (e) {
        return "".concat(e, "=").concat(encodeURIComponent(t[e]));
      }).join("&") : "";
    }, t.getAdUnitSizes = function (e) {
      if (e) {
        var t,
            n = [];
        return e.mediaTypes && e.mediaTypes.banner && Array.isArray(e.mediaTypes.banner.sizes) ? (t = e.mediaTypes.banner.sizes, Array.isArray(t[0]) ? n = t : n.push(t)) : Array.isArray(e.sizes) && (Array.isArray(e.sizes[0]) ? n = e.sizes : n.push(e.sizes)), n;
      }
    }, t.parseSizesInput = function (e) {
      var t = [];

      if ("string" == typeof e) {
        var n = e.split(","),
            r = /^(\d)+x(\d)+$/i;
        if (n) for (var i in n) {
          ee(n, i) && n[i].match(r) && t.push(n[i]);
        }
      } else if ("object" === y(e)) {
        var o = e.length;
        if (0 < o) if (2 === o && "number" == typeof e[0] && "number" == typeof e[1]) t.push(N(e));else for (var a = 0; a < o; a++) {
          t.push(N(e[a]));
        }
      }

      return t;
    }, t.parseGPTSingleSizeArray = N, t.parseGPTSingleSizeArrayToRtbSize = function (e) {
      if (k(e)) return {
        w: e[0],
        h: e[1]
      };
    }, t.getWindowTop = P, t.getWindowSelf = q, t.getWindowLocation = M, t.logMessage = G, t.logInfo = W, t.logWarn = L, t.logError = F, t.hasConsoleLogger = function () {
      return C;
    }, t.debugTurnedOn = V, t.createInvisibleIframe = function () {
      var e = document.createElement("iframe");
      return e.id = U(), e.height = 0, e.width = 0, e.border = "0px", e.hspace = "0", e.vspace = "0", e.marginWidth = "0", e.marginHeight = "0", e.style.border = "0", e.scrolling = "no", e.frameBorder = "0", e.src = "about:blank", e.style.display = "none", e;
    }, t.getParameterByName = function (e) {
      return Se(M().search)[e] || "";
    }, t.isA = H, t.isFn = K, t.isStr = J, t.isArray = Y, t.isNumber = Q, t.isPlainObject = $, t.isBoolean = function (e) {
      return H(e, O);
    }, t.isEmpty = X, t.isEmptyStr = function (e) {
      return J(e) && (!e || 0 === e.length);
    }, t._each = Z, t.contains = function (e, t) {
      if (X(e)) return !1;
      if (K(e.indexOf)) return -1 !== e.indexOf(t);
      var n = e.length;

      for (; n--;) {
        if (e[n] === t) return !0;
      }

      return !1;
    }, t._map = function (n, r) {
      if (X(n)) return [];
      if (K(n.map)) return n.map(r);
      var i = [];
      return Z(n, function (e, t) {
        i.push(r(e, t, n));
      }), i;
    }, t.hasOwn = ee, t.insertElement = te, t.triggerPixel = ne, t.callBurl = function (e) {
      var t = e.source,
          e = e.burl;
      t === h.S2S.SRC && e && R.triggerPixel(e);
    }, t.insertHtmlIntoIframe = function (e) {
      var t;
      e && ((t = document.createElement("iframe")).id = U(), t.width = 0, t.height = 0, t.hspace = "0", t.vspace = "0", t.marginWidth = "0", t.marginHeight = "0", t.style.display = "none", t.style.height = "0px", t.style.width = "0px", t.scrolling = "no", t.frameBorder = "0", t.allowtransparency = "true", R.insertElement(t, document, "body"), t.contentWindow.document.open(), t.contentWindow.document.write(e), t.contentWindow.document.close());
    }, t.insertUserSyncIframe = re, t.createTrackPixelHtml = function (e) {
      if (!e) return "";
      var t = encodeURI(e),
          e = '<div style="position:absolute;left:0px;top:0px;visibility:hidden;">';
      return e += '<img src="' + t + '"></div>';
    }, t.createTrackPixelIframeHtml = ie, t.getValueString = oe, t.uniques = ae, t.flatten = ce, t.getBidRequest = function (n, e) {
      var t;
      if (n) return e.some(function (e) {
        e = a()(e.bids, function (t) {
          return ["bidId", "adId", "bid_id"].some(function (e) {
            return t[e] === n;
          });
        });
        return e && (t = e), e;
      }), t;
    }, t.getKeys = ue, t.getValue = se, t.getKeyByValue = function (e, t) {
      for (var n in e) {
        if (e.hasOwnProperty(n) && e[n] === t) return n;
      }
    }, t.getBidderCodes = function () {
      return (0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : pbjs.adUnits).map(function (e) {
        return e.bids.map(function (e) {
          return e.bidder;
        }).reduce(ce, []);
      }).reduce(ce).filter(ae);
    }, t.isGptPubadsDefined = de, n.d(t, "getHighestCpm", function () {
      return fe;
    }), n.d(t, "getOldestHighestCpmBid", function () {
      return le;
    }), n.d(t, "getLatestHighestCpmBid", function () {
      return pe;
    }), t.shuffle = function (e) {
      var t = e.length;

      for (; 0 < t;) {
        var n = Math.floor(Math.random() * t),
            r = e[--t];
        e[t] = e[n], e[n] = r;
      }

      return e;
    }, t.adUnitsFilter = function (e, t) {
      return c()(e, t && t.adUnitCode);
    }, t.deepClone = be, t.inIframe = function () {
      try {
        return R.getWindowSelf() !== R.getWindowTop();
      } catch (e) {
        return !0;
      }
    }, t.isSafariBrowser = function () {
      return /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent);
    }, t.replaceAuctionPrice = function (e, t) {
      if (e) return e.replace(/\$\{AUCTION_PRICE\}/g, t);
    }, t.timestamp = function () {
      return new Date().getTime();
    }, t.hasDeviceAccess = function () {
      return !1 !== r.b.getConfig("deviceAccess");
    }, t.checkCookieSupport = ye, t.delayExecution = function (e, t) {
      if (t < 1) throw new Error("numRequiredCalls must be a positive number. Got ".concat(t));
      var n = 0;
      return function () {
        ++n === t && e.apply(this, arguments);
      };
    }, t.groupBy = function (e, n) {
      return e.reduce(function (e, t) {
        return (e[t[n]] = e[t[n]] || []).push(t), e;
      }, {});
    }, t.getDefinedParams = function (n, e) {
      return e.filter(function (e) {
        return n[e];
      }).reduce(function (e, t) {
        return b(e, g({}, t, n[t]));
      }, {});
    }, t.isValidMediaTypes = function (e) {
      var t = ["banner", "native", "video"];
      if (!Object.keys(e).every(function (e) {
        return c()(t, e);
      })) return !1;
      if (e.video && e.video.context) return c()(["instream", "outstream", "adpod"], e.video.context);
      return !0;
    }, t.getBidderRequest = function (e, t, n) {
      return a()(e, function (e) {
        return 0 < e.bids.filter(function (e) {
          return e.bidder === t && e.adUnitCode === n;
        }).length;
      }) || {
        start: null,
        auctionId: null
      };
    }, t.getUserConfiguredParams = function (e, t, n) {
      return e.filter(function (e) {
        return e.code === t;
      }).map(function (e) {
        return e.bids;
      }).reduce(ce, []).filter(function (e) {
        return e.bidder === n;
      }).map(function (e) {
        return e.params || {};
      });
    }, t.getOrigin = function () {
      return window.location.origin || window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
    }, t.getDNT = function () {
      return "1" === navigator.doNotTrack || "1" === window.doNotTrack || "1" === navigator.msDoNotTrack || "yes" === navigator.doNotTrack;
    }, t.isAdUnitCodeMatchingSlot = function (t) {
      return function (e) {
        return ve(t, e);
      };
    }, t.isSlotMatchingAdUnitCode = he, t.getGptSlotInfoForAdUnitCode = function (e) {
      var t;
      de() && (t = a()(window.googletag.pubads().getSlots(), he(e)));
      if (t) return {
        gptSlot: t.getAdUnitPath(),
        divId: t.getSlotElementId()
      };
      return {};
    }, t.unsupportedBidderMessage = function (e, t) {
      var n = Object.keys(e.mediaTypes || {
        banner: "banner"
      }).join(", ");
      return "\n    ".concat(e.code, " is a ").concat(n, " ad unit\n    containing bidders that don't support ").concat(n, ": ").concat(t, ".\n    This bidder won't fetch demand.\n  ");
    }, t.isInteger = me, t.convertCamelToUnderscore = function (e) {
      return e.replace(/(?:^|\.?)([A-Z])/g, function (e, t) {
        return "_" + t.toLowerCase();
      }).replace(/^_/, "");
    }, t.cleanObj = function (n) {
      return Object.keys(n).reduce(function (e, t) {
        return void 0 !== n[t] && (e[t] = n[t]), e;
      }, {});
    }, t.pick = function (o, a) {
      return "object" === y(o) ? a.reduce(function (e, t, n) {
        if ("function" == typeof t) return e;
        var r = t,
            i = t.match(/^(.+?)\sas\s(.+?)$/i);
        i && (t = i[1], r = i[2]);
        t = o[t];
        return void 0 !== (t = "function" == typeof a[n + 1] ? a[n + 1](t, e) : t) && (e[r] = t), e;
      }, {}) : {};
    }, t.transformBidderParamKeywords = function (e) {
      var r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "keywords",
          i = [];
      return Z(e, function (e, t) {
        if (Y(e)) {
          var n = [];
          Z(e, function (e) {
            !(e = oe(r + "." + t, e)) && "" !== e || n.push(e);
          }), e = n;
        } else {
          if (!J(e = oe(r + "." + t, e))) return;
          e = [e];
        }

        i.push({
          key: t,
          value: e
        });
      }), i;
    }, t.convertTypes = function (r, i) {
      return Object.keys(r).forEach(function (e) {
        var t, n;
        i[e] && (K(r[e]) ? i[e] = r[e](i[e]) : i[e] = (t = r[e], n = i[e], "string" === t ? n && n.toString() : "number" === t ? Number(n) : n), isNaN(i[e]) && delete i.key);
      }), i;
    }, t.isArrayOfNums = function (e, t) {
      return Y(e) && (!t || e.length === t) && e.every(me);
    }, t.fill = function (e, t) {
      for (var n = [], r = 0; r < t; r++) {
        var i = $(e) ? be(e) : e;
        n.push(i);
      }

      return n;
    }, t.chunk = function (e, t) {
      for (var n = [], r = 0; r < Math.ceil(e.length / t); r++) {
        var i = r * t,
            o = i + t;
        n.push(e.slice(i, o));
      }

      return n;
    }, t.getMinValueFromArray = function (e) {
      return Math.min.apply(Math, f(e));
    }, t.getMaxValueFromArray = function (e) {
      return Math.max.apply(Math, f(e));
    }, t.compareOn = function (n) {
      return function (e, t) {
        return e[n] < t[n] ? 1 : e[n] > t[n] ? -1 : 0;
      };
    }, t.parseQS = Se, t.formatQS = Ae, t.parseUrl = function (e, t) {
      var n = document.createElement("a");
      t && "noDecodeWholeURL" in t && t.noDecodeWholeURL ? n.href = e : n.href = decodeURIComponent(e);
      t = t && "decodeSearchAsString" in t && t.decodeSearchAsString;
      return {
        href: n.href,
        protocol: (n.protocol || "").replace(/:$/, ""),
        hostname: n.hostname,
        port: +n.port,
        pathname: n.pathname.replace(/^(?!\/)/, "/"),
        search: t ? n.search : R.parseQS(n.search || ""),
        hash: (n.hash || "").replace(/^#/, ""),
        host: n.host || window.location.host
      };
    }, t.buildUrl = function (e) {
      return (e.protocol || "http") + "://" + (e.host || e.hostname + (e.port ? ":".concat(e.port) : "")) + (e.pathname || "") + (e.search ? "?".concat(R.formatQS(e.search || "")) : "") + (e.hash ? "#".concat(e.hash) : "");
    }, t.deepEqual = Ee, t.mergeDeep = Te, t.cyrb53Hash = function (e) {
      for (var t, n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, r = function r(e, t) {
        if (K(Math.imul)) return Math.imul(e, t);
        var n = (4194303 & e) * (t |= 0);
        return 4290772992 & e && (n += (4290772992 & e) * t | 0), 0 | n;
      }, i = 3735928559 ^ n, o = 1103547991 ^ n, a = 0; a < e.length; a++) {
        t = e.charCodeAt(a), i = r(i ^ t, 2654435761), o = r(o ^ t, 1597334677);
      }

      return i = r(i ^ i >>> 16, 2246822507) ^ r(o ^ o >>> 13, 3266489909), (4294967296 * (2097151 & (o = r(o ^ o >>> 16, 2246822507) ^ r(i ^ i >>> 13, 3266489909))) + (i >>> 0)).toString();
    };
    var r = n(3),
        i = n(161),
        o = n.n(i),
        i = n(10),
        a = n.n(i),
        i = n(12),
        c = n.n(i),
        u = n(162);
    n.d(t, "deepAccess", function () {
      return u.a;
    });
    var s = n(163);

    function d(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              r = !0,
              i = !1,
              o = void 0;

          try {
            for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            i = !0, o = e;
          } finally {
            try {
              r || null == c.return || c.return();
            } finally {
              if (i) throw o;
            }
          }

          return n;
        }
      }(e, t) || l(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function f(e) {
      return function (e) {
        if (Array.isArray(e)) return p(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || l(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function l(e, t) {
      if (e) {
        if ("string" == typeof e) return p(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Map" === (n = "Object" === n && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? p(e, t) : void 0;
      }
    }

    function p(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    function g(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function b() {
      return (b = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n,
              r = arguments[t];

          for (n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function y(e) {
      return (y = "function" == typeof Symbol && "symbol" == (0, _typeof2.default)(Symbol.iterator) ? function (e) {
        return (0, _typeof2.default)(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : (0, _typeof2.default)(e);
      })(e);
    }

    n.d(t, "deepSetValue", function () {
      return s.a;
    });

    var v,
        h = n(5),
        m = "Array",
        S = "String",
        A = "Function",
        E = "Number",
        T = "Object",
        O = "Boolean",
        I = Object.prototype.toString,
        n = Boolean(window.console),
        C = Boolean(n && window.console.log),
        j = Boolean(n && window.console.info),
        w = Boolean(n && window.console.warn),
        _ = Boolean(n && window.console.error),
        R = {
      checkCookieSupport: ye,
      createTrackPixelIframeHtml: ie,
      getWindowSelf: q,
      getWindowTop: P,
      getWindowLocation: M,
      insertUserSyncIframe: re,
      insertElement: te,
      isFn: K,
      triggerPixel: ne,
      logError: F,
      logWarn: L,
      logMessage: G,
      logInfo: W,
      parseQS: Se,
      formatQS: Ae,
      deepEqual: Ee
    },
        n = {},
        B = function (e, t) {
      return t;
    }.bind(null, 1, n)() === n ? Function.prototype.bind : function (e) {
      var t = this,
          n = Array.prototype.slice.call(arguments, 1);
      return function () {
        return t.apply(e, n.concat(Array.prototype.slice.call(arguments)));
      };
    },
        x = (v = 0, function () {
      return ++v;
    });

    function U() {
      return x() + Math.random().toString(16).substr(2);
    }

    function D() {
      return window && window.crypto && window.crypto.getRandomValues ? crypto.getRandomValues(new Uint8Array(1))[0] % 16 : 16 * Math.random();
    }

    function N(e) {
      if (k(e)) return e[0] + "x" + e[1];
    }

    function k(e) {
      return Y(e) && 2 === e.length && !isNaN(e[0]) && !isNaN(e[1]);
    }

    function P() {
      return window.top;
    }

    function q() {
      return window.self;
    }

    function M() {
      return window.location;
    }

    function G() {
      V() && C && console.log.apply(console, z(arguments, "MESSAGE:"));
    }

    function W() {
      V() && j && console.info.apply(console, z(arguments, "INFO:"));
    }

    function L() {
      V() && w && console.warn.apply(console, z(arguments, "WARNING:"));
    }

    function F() {
      V() && _ && console.error.apply(console, z(arguments, "ERROR:"));
    }

    function z(e, t) {
      return e = [].slice.call(e), t && e.unshift(t), e.unshift("display: inline-block; color: #fff; background: #3b88c3; padding: 1px 4px; border-radius: 3px;"), e.unshift("%cPrebid"), e;
    }

    function V() {
      return !!r.b.getConfig("debug");
    }

    function H(e, t) {
      return I.call(e) === "[object " + t + "]";
    }

    function K(e) {
      return H(e, A);
    }

    function J(e) {
      return H(e, S);
    }

    function Y(e) {
      return H(e, m);
    }

    function Q(e) {
      return H(e, E);
    }

    function $(e) {
      return H(e, T);
    }

    function X(e) {
      if (!e) return !0;
      if (Y(e) || J(e)) return !(0 < e.length);

      for (var t in e) {
        if (hasOwnProperty.call(e, t)) return !1;
      }

      return !0;
    }

    function Z(e, t) {
      if (!X(e)) {
        if (K(e.forEach)) return e.forEach(t, this);
        var n = 0,
            r = e.length;
        if (0 < r) for (; n < r; n++) {
          t(e[n], n, e);
        } else for (n in e) {
          hasOwnProperty.call(e, n) && t.call(this, e[n], n);
        }
      }
    }

    function ee(e, t) {
      return e.hasOwnProperty ? e.hasOwnProperty(t) : void 0 !== e[t] && e.constructor.prototype[t] !== e[t];
    }

    function te(e, t, n, r) {
      t = t || document, n = n ? t.getElementsByTagName(n) : t.getElementsByTagName("head");

      try {
        if ((n = n.length ? n : t.getElementsByTagName("body")).length) {
          var n = n[0],
              i = r ? null : n.firstChild;
          return n.insertBefore(e, i);
        }
      } catch (e) {}
    }

    function ne(e, t) {
      var n = new Image();
      t && R.isFn(t) && (n.addEventListener("load", t), n.addEventListener("error", t)), n.src = e;
    }

    function re(e, t) {
      var n = R.createTrackPixelIframeHtml(e, !1, "allow-scripts allow-same-origin"),
          e = document.createElement("div");
      e.innerHTML = n;
      e = e.firstChild;
      t && R.isFn(t) && (e.addEventListener("load", t), e.addEventListener("error", t)), R.insertElement(e, document, "html", !0);
    }

    function ie(e) {
      var t = !(1 < arguments.length && void 0 !== arguments[1]) || arguments[1],
          n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : "";
      return e ? (t && (e = encodeURI(e)), n = n && 'sandbox="'.concat(n, '"'), "<iframe ".concat(n, ' id="').concat(U(), '"\n      frameborder="0"\n      allowtransparency="true"\n      marginheight="0" marginwidth="0"\n      width="0" hspace="0" vspace="0" height="0"\n      style="height:0px;width:0px;display:none;"\n      scrolling="no"\n      src="').concat(e, '">\n    </iframe>')) : "";
    }

    function oe(e, t, n) {
      return null == t ? n : J(t) ? t : Q(t) ? t.toString() : void R.logWarn("Unsuported type for param: " + e + " required type: String");
    }

    function ae(e, t, n) {
      return n.indexOf(e) === t;
    }

    function ce(e, t) {
      return e.concat(t);
    }

    function ue(e) {
      return Object.keys(e);
    }

    function se(e, t) {
      return e[t];
    }

    function de() {
      if (window.googletag && K(window.googletag.pubads) && K(window.googletag.pubads().getSlots)) return !0;
    }

    var fe = ge("timeToRespond", function (e, t) {
      return t < e;
    }),
        le = ge("responseTimestamp", function (e, t) {
      return t < e;
    }),
        pe = ge("responseTimestamp", function (e, t) {
      return e < t;
    });

    function ge(n, r) {
      return function (e, t) {
        return e.cpm === t.cpm ? r(e[n], t[n]) ? t : e : e.cpm < t.cpm ? t : e;
      };
    }

    function be(e) {
      return o()(e);
    }

    function ye() {
      if (window.navigator.cookieEnabled || document.cookie.length) return !0;
    }

    var ve = function ve(e, t) {
      return e.getAdUnitPath() === t || e.getSlotElementId() === t;
    };

    function he(t) {
      return function (e) {
        return ve(e, t);
      };
    }

    function me(e) {
      return Number.isInteger ? Number.isInteger(e) : "number" == typeof e && isFinite(e) && Math.floor(e) === e;
    }

    function Se(e) {
      return e ? e.replace(/^\?/, "").split("&").reduce(function (e, t) {
        var n = d(t.split("="), 2),
            t = n[0],
            n = n[1];
        return /\[\]$/.test(t) ? (e[t = t.replace("[]", "")] = e[t] || [], e[t].push(n)) : e[t] = n || "", e;
      }, {}) : {};
    }

    function Ae(e) {
      return Object.keys(e).map(function (t) {
        return Array.isArray(e[t]) ? e[t].map(function (e) {
          return "".concat(t, "[]=").concat(e);
        }).join("&") : "".concat(t, "=").concat(e[t]);
      }).join("&");
    }

    function Ee(e, t) {
      if (e === t) return !0;
      if ("object" !== y(e) || null === e || "object" !== y(t) || null === t) return !1;
      if (Object.keys(e).length !== Object.keys(t).length) return !1;

      for (var n in e) {
        if (!t.hasOwnProperty(n)) return !1;
        if (!Ee(e[n], t[n])) return !1;
      }

      return !0;
    }

    function Te(e) {
      for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) {
        n[r - 1] = arguments[r];
      }

      if (!n.length) return e;
      var i = n.shift();
      if ($(e) && $(i)) for (var o in i) {
        $(i[o]) ? (e[o] || b(e, g({}, o, {})), Te(e[o], i[o])) : Y(i[o]) && e[o] ? Y(e[o]) && (e[o] = e[o].concat(i[o])) : b(e, g({}, o, i[o]));
      }
      return Te.apply(void 0, [e].concat(n));
    }
  },
  1: function _(e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n.d(t, "storage", function () {
      return g;
    }), t.registerBidder = function (r) {
      var n = Array.isArray(r.supportedMediaTypes) ? {
        supportedMediaTypes: r.supportedMediaTypes
      } : void 0;

      function i(e) {
        var t = T(e);
        o.default.registerBidAdapter(t, e.code, n);
      }

      i(r), Array.isArray(r.aliases) && r.aliases.forEach(function (e) {
        var t,
            n = e;
        Object(h.isPlainObject)(e) && (n = e.code, t = e.gvlid), o.default.aliasRegistry[n] = r.code, i(S({}, r, {
          code: n,
          gvlid: t
        }));
      });
    }, t.newBidder = T, n.d(t, "registerSyncInner", function () {
      return O;
    }), t.preloadBidderMappingFile = I, t.getIabSubCategory = function (t, e) {
      var n = o.default.getBidAdapter(t);

      if (n.getSpec().getMappingFileInfo) {
        var r = n.getSpec().getMappingFileInfo(),
            n = r.localStorageKey || n.getBidderCode(),
            n = g.getDataFromLocalStorage(n);

        if (n) {
          try {
            n = JSON.parse(n);
          } catch (e) {
            Object(h.logError)("Failed to parse ".concat(t, " mapping data stored in local storage"));
          }

          return n.mapping[e] || null;
        }
      }
    }, t.isValid = C;
    var r = n(89),
        o = n(7),
        a = n(3),
        b = n(32),
        c = n(45),
        u = n(36),
        s = n(33),
        t = n(5),
        y = n.n(t),
        t = n(9),
        v = n.n(t),
        t = n(12),
        d = n.n(t),
        f = n(4),
        h = n(0),
        i = n(2),
        t = n(13),
        n = n(8);

    function l(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              r = !0,
              i = !1,
              o = void 0;

          try {
            for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            i = !0, o = e;
          } finally {
            try {
              r || null == c.return || c.return();
            } finally {
              if (i) throw o;
            }
          }

          return n;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return p(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Map" === (n = "Object" === n && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? p(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function p(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    function m(e) {
      return (m = "function" == typeof Symbol && "symbol" == (0, _typeof2.default)(Symbol.iterator) ? function (e) {
        return (0, _typeof2.default)(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : (0, _typeof2.default)(e);
      })(e);
    }

    function S() {
      return (S = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n,
              r = arguments[t];

          for (n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var g = Object(n.a)("bidderFactory"),
        A = ["requestId", "cpm", "ttl", "creativeId", "netRevenue", "currency"],
        E = 1;

    function T(l) {
      return S(new r.a(l.code), {
        getSpec: function getSpec() {
          return Object.freeze(l);
        },
        registerSyncs: p,
        callBids: function callBids(o, a, e, n, c, r) {
          var u, s, d, t, f;

          function i() {
            e(), v.a.emit(y.a.EVENTS.BIDDER_DONE, o), p(s, o.gdprConsent, o.uspConsent);
          }

          Array.isArray(o.bids) && (u = {}, s = [], 0 !== (t = o.bids.filter(g)).length ? (d = {}, t.forEach(function (e) {
            (d[e.bidId] = e).adUnitCode || (e.adUnitCode = e.placementCode);
          }), (t = l.buildRequests(t, o)) && 0 !== t.length ? (Array.isArray(t) || (t = [t]), f = Object(h.delayExecution)(r(i), t.length), t.forEach(function (i) {
            switch (i.method) {
              case "GET":
                n("".concat(i.url).concat(function (e) {
                  if (e) return "?".concat("object" === m(e) ? Object(h.parseQueryStringParameters)(e) : e);
                  return "";
                }(i.data)), {
                  success: r(e),
                  error: t
                }, void 0, S({
                  method: "GET",
                  withCredentials: !0
                }, i.options));
                break;

              case "POST":
                n(i.url, {
                  success: r(e),
                  error: t
                }, "string" == typeof i.data ? i.data : JSON.stringify(i.data), S({
                  method: "POST",
                  contentType: "text/plain",
                  withCredentials: !0
                }, i.options));
                break;

              default:
                Object(h.logWarn)("Skipping invalid request from ".concat(l.code, ". Request type ").concat(i.type, " must be GET or POST")), f();
            }

            function e(e, t) {
              c(l.code);

              try {
                e = JSON.parse(e);
              } catch (e) {}

              var n;
              e = {
                body: e,
                headers: {
                  get: t.getResponseHeader.bind(t)
                }
              }, s.push(e);

              try {
                n = l.interpretResponse(e, i);
              } catch (e) {
                return Object(h.logError)("Bidder ".concat(l.code, " failed to interpret the server's response. Continuing without bids"), null, e), void f();
              }

              function r(e) {
                var t,
                    n = d[e.requestId];
                n ? (e.originalCpm = e.cpm, e.originalCurrency = e.currency, e.meta = e.meta || S({}, e[n.bidder]), t = S(Object(b.a)(y.a.STATUS.GOOD, n), e), n = n.adUnitCode, t = t, u[n] = !0, C(n, t, [o]) && a(n, t)) : Object(h.logWarn)("Bidder ".concat(l.code, " made bid for unknown request ID: ").concat(e.requestId, ". Ignoring."));
              }

              n && (Object(h.isArray)(n) ? n.forEach(r) : r(n)), f(n);
            }

            function t(e) {
              c(l.code), Object(h.logError)("Server call for ".concat(l.code, " failed: ").concat(e, ". Continuing without bids.")), f();
            }
          })) : i()) : i());
        }
      });

      function p(e, t, n) {
        O(l, e, t, n);
      }

      function g(e) {
        return !!l.isBidRequestValid(e) || (Object(h.logWarn)("Invalid bid sent to bidder ".concat(l.code, ": ").concat(JSON.stringify(e))), !1);
      }
    }

    var O = Object(t.b)("async", function (t, e, n, r) {
      var i = a.b.getConfig("userSync.aliasSyncEnabled");
      !t.getUserSyncs || !i && o.default.aliasRegistry[t.code] || (i = a.b.getConfig("userSync.filterSettings"), (r = t.getUserSyncs({
        iframeEnabled: !(!i || !i.iframe && !i.all),
        pixelEnabled: !(!i || !i.image && !i.all)
      }, e, n, r)) && (r = !Array.isArray(r) ? [r] : r).forEach(function (e) {
        c.a.registerSync(e.type, t.code, e.url);
      }));
    }, "registerSyncs");

    function I(e, t) {
      if (!a.b.getConfig("adpod.brandCategoryExclusion")) return e.call(this, t);
      t.filter(function (e) {
        return Object(h.deepAccess)(e, "mediaTypes.video.context") === i.a;
      }).map(function (e) {
        return e.bids.map(function (e) {
          return e.bidder;
        });
      }).reduce(h.flatten, []).filter(h.uniques).forEach(function (n) {
        var e = o.default.getBidAdapter(n);

        if (e.getSpec().getMappingFileInfo) {
          var t = e.getSpec().getMappingFileInfo(),
              r = t.refreshInDays || E,
              i = t.localStorageKey || e.getSpec().code,
              e = g.getDataFromLocalStorage(i);

          try {
            (!(e = e ? JSON.parse(e) : void 0) || Object(h.timestamp)() > e.lastUpdated + 24 * r * 60 * 60 * 1e3) && Object(f.a)(t.url, {
              success: function success(e) {
                try {
                  e = JSON.parse(e);
                  var t = {
                    lastUpdated: Object(h.timestamp)(),
                    mapping: e.mapping
                  };
                  g.setDataInLocalStorage(i, JSON.stringify(t));
                } catch (e) {
                  Object(h.logError)("Failed to parse ".concat(n, " bidder translation mapping file"));
                }
              },
              error: function error() {
                Object(h.logError)("Failed to load ".concat(n, " bidder translation file"));
              }
            });
          } catch (e) {
            Object(h.logError)("Failed to parse ".concat(n, " bidder translation mapping file"));
          }
        }
      }), e.call(this, t);
    }

    function C(e, t, n) {
      function r(e) {
        return "Invalid bid from ".concat(t.bidderCode, ". Ignoring bid: ").concat(e);
      }

      return e ? t ? (i = Object.keys(t), A.every(function (e) {
        return d()(i, e) && !d()([void 0, null], t[e]);
      }) ? "native" !== t.mediaType || Object(u.f)(t, n) ? "video" !== t.mediaType || Object(s.d)(t, n) ? !("banner" === t.mediaType && !function (e, t, n) {
        if ((t.width || 0 === parseInt(t.width, 10)) && (t.height || 0 === parseInt(t.height, 10))) return t.width = parseInt(t.width, 10), t.height = parseInt(t.height, 10), 1;

        if (n = Object(h.getBidderRequest)(n, t.bidderCode, e), e = n && n.bids && n.bids[0] && n.bids[0].sizes, 1 === (n = Object(h.parseSizesInput)(e)).length) {
          e = l(n[0].split("x"), 2), n = e[0], e = e[1];
          return t.width = parseInt(n, 10), t.height = parseInt(e, 10), 1;
        }
      }(e, t, n)) || (Object(h.logError)(r("Banner bids require a width and height")), !1) : (Object(h.logError)(r("Video bid does not have required vastUrl or renderer property")), !1) : (Object(h.logError)(r("Native bid missing some required properties.")), !1) : (Object(h.logError)(r("Bidder ".concat(t.bidderCode, " is missing required params. Check http://prebid.org/dev-docs/bidder-adapter-1.html for list of params."))), !1)) : (Object(h.logWarn)("Some adapter tried to add an undefined bid for ".concat(e, ".")), !1) : (Object(h.logWarn)("No adUnitCode was supplied to addBidResponse."), !1);
      var i;
    }

    Object(t.a)("checkAdUnitSetup").before(I);
  },
  10: function _(e, t, n) {
    n = n(95);
    e.exports = n;
  },
  100: function _(e, t, n) {
    var r = n(24),
        i = n(101),
        o = n(19)("species");

    e.exports = function (e, t) {
      var n;
      return new (void 0 === (n = i(e) && ("function" == typeof (n = e.constructor) && (n === Array || i(n.prototype)) || r(n) && null === (n = n[o])) ? void 0 : n) ? Array : n)(0 === t ? 0 : t);
    };
  },
  101: function _(e, t, n) {
    var r = n(43);

    e.exports = Array.isArray || function (e) {
      return "Array" == r(e);
    };
  },
  102: function _(e, t, n) {
    var r = n(21),
        i = n(29);

    e.exports = function (t, n) {
      try {
        i(r, t, n);
      } catch (e) {
        r[t] = n;
      }

      return n;
    };
  },
  103: function _(e, t, n) {
    var r = n(43),
        n = n(21);
    e.exports = "process" == r(n.process);
  },
  104: function _(e, t, n) {
    var r,
        i,
        o = n(21),
        n = n(105),
        o = o.process,
        o = o && o.versions,
        o = o && o.v8;
    o ? i = (r = o.split("."))[0] + r[1] : n && (!(r = n.match(/Edge\/(\d+)/)) || 74 <= r[1]) && (r = n.match(/Chrome\/(\d+)/)) && (i = r[1]), e.exports = i && +i;
  },
  105: function _(e, t, n) {
    n = n(23);
    e.exports = n("navigator", "userAgent") || "";
  },
  106: function _(e, t, n) {
    n = n(74);
    e.exports = n && !Symbol.sham && "symbol" == (0, _typeof2.default)(Symbol.iterator);
  },
  107: function _(e, t, n) {
    n(108);
    n = n(52);
    e.exports = n("Array", "includes");
  },
  108: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(75).includes,
        n = n(51);
    r({
      target: "Array",
      proto: !0
    }, {
      includes: function includes(e) {
        return i(this, e, 1 < arguments.length ? arguments[1] : void 0);
      }
    }), n("includes");
  },
  109: function _(e, t, n) {
    var r = n(58),
        i = Math.max,
        o = Math.min;

    e.exports = function (e, t) {
      e = r(e);
      return e < 0 ? i(e + t, 0) : o(e, t);
    };
  },
  11: function _(e, t, n) {
    "use strict";

    t.a = r, t.c = function (e) {
      return !(!e || !e.url);
    }, t.b = function (e, t) {
      e.render(t);
    };
    var u = n(40),
        s = n(0),
        t = n(10),
        d = n.n(t),
        f = "outstream";

    function r(e) {
      var t = this,
          n = e.url,
          r = e.config,
          i = e.id,
          o = e.callback,
          a = e.loaded,
          c = e.adUnitCode;
      this.url = n, this.config = r, this.handlers = {}, this.id = i, this.loaded = a, this.cmd = [], this.push = function (e) {
        "function" == typeof e ? t.loaded ? e.call() : t.cmd.push(e) : s.logError("Commands given to Renderer.push must be wrapped in a function");
      }, this.callback = o || function () {
        t.loaded = !0, t.process();
      }, this.render = function () {
        var t, e;
        t = c, e = pbjs.adUnits, (e = d()(e, function (e) {
          return e.code === t;
        })) && e.renderer && e.renderer.url && e.renderer.render ? s.logWarn("External Js not loaded by Renderer since renderer url and callback is already defined on adUnit ".concat(c)) : Object(u.a)(n, f, this.callback), this._render ? this._render.apply(this, arguments) : s.logWarn("No render function was provided, please use .setRender on the renderer");
      }.bind(this);
    }

    r.install = function (e) {
      return new r({
        url: e.url,
        config: e.config,
        id: e.id,
        callback: e.callback,
        loaded: e.loaded,
        adUnitCode: e.adUnitCode
      });
    }, r.prototype.getConfig = function () {
      return this.config;
    }, r.prototype.setRender = function (e) {
      this._render = e;
    }, r.prototype.setEventHandlers = function (e) {
      this.handlers = e;
    }, r.prototype.handleVideoEvent = function (e) {
      var t = e.id,
          e = e.eventName;
      "function" == typeof this.handlers[e] && this.handlers[e](), s.logMessage("Prebid Renderer event for id ".concat(t, " type ").concat(e));
    }, r.prototype.process = function () {
      for (; 0 < this.cmd.length;) {
        try {
          this.cmd.shift().call();
        } catch (e) {
          s.logError("Error processing Renderer command: ", e);
        }
      }
    };
  },
  110: function _(e, t, n) {
    n(111), n(128), n(86), n(130);
    n = n(44);
    e.exports = n.Set;
  },
  111: function _(e, t, n) {
    "use strict";

    var r = n(112),
        n = n(117);
    e.exports = r("Set", function (e) {
      return function () {
        return e(this, arguments.length ? arguments[0] : void 0);
      };
    }, n);
  },
  112: function _(e, t, n) {
    "use strict";

    var f = n(14),
        l = n(21),
        p = n(77),
        g = n(27),
        b = n(29),
        y = n(17),
        v = n(80),
        h = n(24),
        m = n(64),
        S = n(31).f,
        A = n(56).forEach,
        E = n(30),
        n = n(54),
        T = n.set,
        O = n.getterFor;

    e.exports = function (n, e, t) {
      var o,
          a,
          r = -1 !== n.indexOf("Map"),
          c = -1 !== n.indexOf("Weak"),
          i = r ? "set" : "add",
          u = l[n],
          s = u && u.prototype,
          d = {};
      return E && "function" == typeof u && (c || s.forEach && !g(function () {
        new u().entries().next();
      })) ? (o = e(function (e, t) {
        T(v(e, o, n), {
          type: n,
          collection: new u()
        }), null != t && y(t, e[i], {
          that: e,
          AS_ENTRIES: r
        });
      }), a = O(n), A(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function (r) {
        var i = "add" == r || "set" == r;
        r in s && (!c || "clear" != r) && b(o.prototype, r, function (e, t) {
          var n = a(this).collection;
          if (!i && c && !h(e)) return "get" == r && void 0;
          t = n[r](0 === e ? 0 : e, t);
          return i ? this : t;
        });
      }), c || S(o.prototype, "size", {
        configurable: !0,
        get: function get() {
          return a(this).collection.size;
        }
      })) : (o = t.getConstructor(e, n, r, i), p.REQUIRED = !0), m(o, n, !1, !0), d[n] = o, f({
        global: !0,
        forced: !0
      }, d), c || t.setStrong(o, n, r), o;
    };
  },
  113: function _(e, t, n) {
    n = n(27);
    e.exports = !n(function () {
      return Object.isExtensible(Object.preventExtensions({}));
    });
  },
  114: function _(e, t, n) {
    "use strict";

    var r = n(63),
        i = n(62);
    e.exports = r ? {}.toString : function () {
      return "[object " + i(this) + "]";
    };
  },
  115: function _(e, t, n) {
    var r = n(21),
        n = n(116),
        r = r.WeakMap;
    e.exports = "function" == typeof r && /native code/.test(n(r));
  },
  116: function _(e, t, n) {
    var n = n(59),
        r = Function.toString;
    "function" != typeof n.inspectSource && (n.inspectSource = function (e) {
      return r.call(e);
    }), e.exports = n.inspectSource;
  },
  117: function _(e, t, n) {
    "use strict";

    var s = n(31).f,
        d = n(81),
        f = n(122),
        l = n(22),
        p = n(80),
        g = n(17),
        a = n(66),
        c = n(127),
        b = n(30),
        y = n(77).fastKey,
        n = n(54),
        v = n.set,
        h = n.getterFor;
    e.exports = {
      getConstructor: function getConstructor(e, n, r, i) {
        function o(e, t, n) {
          var r,
              i = c(e),
              o = u(e, t);
          return o ? o.value = n : (i.last = o = {
            index: r = y(t, !0),
            key: t,
            value: n,
            previous: n = i.last,
            next: void 0,
            removed: !1
          }, i.first || (i.first = o), n && (n.next = o), b ? i.size++ : e.size++, "F" !== r && (i.index[r] = o)), e;
        }

        var a = e(function (e, t) {
          p(e, a, n), v(e, {
            type: n,
            index: d(null),
            first: void 0,
            last: void 0,
            size: 0
          }), b || (e.size = 0), null != t && g(t, e[i], {
            that: e,
            AS_ENTRIES: r
          });
        }),
            c = h(n),
            u = function u(e, t) {
          var n,
              r = c(e),
              e = y(t);
          if ("F" !== e) return r.index[e];

          for (n = r.first; n; n = n.next) {
            if (n.key == t) return n;
          }
        };

        return f(a.prototype, {
          clear: function clear() {
            for (var e = c(this), t = e.index, n = e.first; n;) {
              n.removed = !0, n.previous && (n.previous = n.previous.next = void 0), delete t[n.index], n = n.next;
            }

            e.first = e.last = void 0, b ? e.size = 0 : this.size = 0;
          },
          delete: function _delete(e) {
            var t,
                n = c(this),
                r = u(this, e);
            return r && (t = r.next, e = r.previous, delete n.index[r.index], r.removed = !0, e && (e.next = t), t && (t.previous = e), n.first == r && (n.first = t), n.last == r && (n.last = e), b ? n.size-- : this.size--), !!r;
          },
          forEach: function forEach(e) {
            for (var t, n = c(this), r = l(e, 1 < arguments.length ? arguments[1] : void 0, 3); t = t ? t.next : n.first;) {
              for (r(t.value, t.key, this); t && t.removed;) {
                t = t.previous;
              }
            }
          },
          has: function has(e) {
            return !!u(this, e);
          }
        }), f(a.prototype, r ? {
          get: function get(e) {
            e = u(this, e);
            return e && e.value;
          },
          set: function set(e, t) {
            return o(this, 0 === e ? 0 : e, t);
          }
        } : {
          add: function add(e) {
            return o(this, e = 0 === e ? 0 : e, e);
          }
        }), b && s(a.prototype, "size", {
          get: function get() {
            return c(this).size;
          }
        }), a;
      },
      setStrong: function setStrong(e, t, n) {
        var r = t + " Iterator",
            i = h(t),
            o = h(r);
        a(e, t, function (e, t) {
          v(this, {
            type: r,
            target: e,
            state: i(e),
            kind: t,
            last: void 0
          });
        }, function () {
          for (var e = o(this), t = e.kind, n = e.last; n && n.removed;) {
            n = n.previous;
          }

          return e.target && (e.last = n = n ? n.next : e.state.first) ? "keys" == t ? {
            value: n.key,
            done: !1
          } : "values" == t ? {
            value: n.value,
            done: !1
          } : {
            value: [n.key, n.value],
            done: !1
          } : {
            value: e.target = void 0,
            done: !0
          };
        }, n ? "entries" : "values", !n, !0), c(t);
      }
    };
  },
  118: function _(e, t, n) {
    var r = n(30),
        a = n(31),
        c = n(15),
        u = n(119);
    e.exports = r ? Object.defineProperties : function (e, t) {
      c(e);

      for (var n, r = u(t), i = r.length, o = 0; o < i;) {
        a.f(e, n = r[o++], t[n]);
      }

      return e;
    };
  },
  119: function _(e, t, n) {
    var r = n(120),
        i = n(82);

    e.exports = Object.keys || function (e) {
      return r(e, i);
    };
  },
  12: function _(e, t, n) {
    n = n(107);
    e.exports = n;
  },
  120: function _(e, t, n) {
    var a = n(28),
        c = n(48),
        u = n(75).indexOf,
        s = n(53);

    e.exports = function (e, t) {
      var n,
          r = c(e),
          i = 0,
          o = [];

      for (n in r) {
        !a(s, n) && a(r, n) && o.push(n);
      }

      for (; t.length > i;) {
        a(r, n = t[i++]) && (~u(o, n) || o.push(n));
      }

      return o;
    };
  },
  121: function _(e, t, n) {
    n = n(23);
    e.exports = n("document", "documentElement");
  },
  122: function _(e, t, n) {
    var i = n(83);

    e.exports = function (e, t, n) {
      for (var r in t) {
        n && n.unsafe && e[r] ? e[r] = t[r] : i(e, r, t[r], n);
      }

      return e;
    };
  },
  123: function _(e, t, n) {
    "use strict";

    function r() {
      return this;
    }

    var i = n(84).IteratorPrototype,
        o = n(81),
        a = n(47),
        c = n(64),
        u = n(38);

    e.exports = function (e, t, n) {
      t += " Iterator";
      return e.prototype = o(i, {
        next: a(1, n)
      }), c(e, t, !1, !0), u[t] = r, e;
    };
  },
  124: function _(e, t, n) {
    n = n(27);
    e.exports = !n(function () {
      function e() {}

      return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
    });
  },
  125: function _(e, t, n) {
    var i = n(15),
        o = n(126);
    e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
      var n,
          r = !1,
          e = {};

      try {
        (n = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(e, []), r = e instanceof Array;
      } catch (e) {}

      return function (e, t) {
        return i(e), o(t), r ? n.call(e, t) : e.__proto__ = t, e;
      };
    }() : void 0);
  },
  126: function _(e, t, n) {
    var r = n(24);

    e.exports = function (e) {
      if (!r(e) && null !== e) throw TypeError("Can't set " + String(e) + " as a prototype");
      return e;
    };
  },
  127: function _(e, t, n) {
    "use strict";

    var r = n(23),
        i = n(31),
        o = n(19),
        a = n(30),
        c = o("species");

    e.exports = function (e) {
      var t = r(e),
          e = i.f;
      a && t && !t[c] && e(t, c, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    };
  },
  128: function _(e, t) {},
  129: function _(e, t, n) {
    var a = n(58),
        c = n(49),
        n = function n(o) {
      return function (e, t) {
        var n,
            r = String(c(e)),
            i = a(t),
            e = r.length;
        return i < 0 || e <= i ? o ? "" : void 0 : (t = r.charCodeAt(i)) < 55296 || 56319 < t || i + 1 === e || (n = r.charCodeAt(i + 1)) < 56320 || 57343 < n ? o ? r.charAt(i) : t : o ? r.slice(i, i + 2) : n - 56320 + (t - 55296 << 10) + 65536;
      };
    };

    e.exports = {
      codeAt: n(!1),
      charAt: n(!0)
    };
  },
  13: function _(e, t, n) {
    "use strict";

    n.d(t, "b", function () {
      return i;
    }), n.d(t, "a", function () {
      return o;
    }), t.d = function (e, t) {
      var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 15;
      0 === e.getHooks({
        hook: t
      }).length && e.before(t, n);
    }, t.c = function (e, t) {
      i("async", function (e) {
        e.forEach(function (e) {
          return t.apply(void 0, function (e) {
            if (Array.isArray(e)) return r(e);
          }(e = e) || function (e) {
            if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
          }(e) || function (e, t) {
            if (e) {
              if ("string" == typeof e) return r(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Map" === (n = "Object" === n && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(e, t) : void 0;
            }
          }(e) || function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }());
        });
      }, e)([]);
    }, t.e = function (e) {
      for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) {
        n[r - 1] = arguments[r];
      }

      o(e).before(function (e, t) {
        t.push(n), e(t);
      });
    };
    t = n(164), t = n.n(t);

    function r(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var i = t()({
      ready: t.a.SYNC | t.a.ASYNC | t.a.QUEUE
    }),
        o = i.get;
  },
  130: function _(e, t, n) {
    n(131);
    var r,
        i = n(132),
        o = n(21),
        a = n(62),
        c = n(29),
        u = n(38),
        s = n(19)("toStringTag");

    for (r in i) {
      var d = o[r],
          d = d && d.prototype;
      d && a(d) !== s && c(d, s, r), u[r] = u.Array;
    }
  },
  131: function _(e, t, n) {
    "use strict";

    var r = n(48),
        i = n(51),
        o = n(38),
        a = n(54),
        n = n(66),
        c = "Array Iterator",
        u = a.set,
        s = a.getterFor(c);
    e.exports = n(Array, "Array", function (e, t) {
      u(this, {
        type: c,
        target: r(e),
        index: 0,
        kind: t
      });
    }, function () {
      var e = s(this),
          t = e.target,
          n = e.kind,
          r = e.index++;
      return !t || r >= t.length ? {
        value: e.target = void 0,
        done: !0
      } : "keys" == n ? {
        value: r,
        done: !1
      } : "values" == n ? {
        value: t[r],
        done: !1
      } : {
        value: [r, t[r]],
        done: !1
      };
    }, "values"), o.Arguments = o.Array, i("keys"), i("values"), i("entries");
  },
  132: function _(e, t) {
    e.exports = {
      CSSRuleList: 0,
      CSSStyleDeclaration: 0,
      CSSValueList: 0,
      ClientRectList: 0,
      DOMRectList: 0,
      DOMStringList: 0,
      DOMTokenList: 1,
      DataTransferItemList: 0,
      FileList: 0,
      HTMLAllCollection: 0,
      HTMLCollection: 0,
      HTMLFormElement: 0,
      HTMLSelectElement: 0,
      MediaList: 0,
      MimeTypeArray: 0,
      NamedNodeMap: 0,
      NodeList: 1,
      PaintRequestList: 0,
      Plugin: 0,
      PluginArray: 0,
      SVGLengthList: 0,
      SVGNumberList: 0,
      SVGPathSegList: 0,
      SVGPointList: 0,
      SVGStringList: 0,
      SVGTransformList: 0,
      SourceBufferList: 0,
      StyleSheetList: 0,
      TextTrackCueList: 0,
      TextTrackList: 0,
      TouchList: 0
    };
  },
  133: function _(e, t, n) {
    n(14)({
      target: "Set",
      stat: !0
    }, {
      from: n(134)
    });
  },
  134: function _(e, t, n) {
    "use strict";

    var c = n(18),
        u = n(22),
        s = n(17);

    e.exports = function (e) {
      var t,
          n,
          r,
          i,
          o = arguments.length,
          a = 1 < o ? arguments[1] : void 0;
      return c(this), (t = void 0 !== a) && c(a), null == e ? new this() : (n = [], t ? (r = 0, i = u(a, 2 < o ? arguments[2] : void 0, 2), s(e, function (e) {
        n.push(i(e, r++));
      })) : s(e, n.push, {
        that: n
      }), new this(n));
    };
  },
  135: function _(e, t, n) {
    n(14)({
      target: "Set",
      stat: !0
    }, {
      of: n(136)
    });
  },
  136: function _(e, t, n) {
    "use strict";

    e.exports = function () {
      for (var e = arguments.length, t = new Array(e); e--;) {
        t[e] = arguments[e];
      }

      return new this(t);
    };
  },
  137: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(138);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      addAll: function addAll() {
        return o.apply(this, arguments);
      }
    });
  },
  138: function _(e, t, n) {
    "use strict";

    var i = n(15),
        o = n(18);

    e.exports = function () {
      for (var e = i(this), t = o(e.add), n = 0, r = arguments.length; n < r; n++) {
        t.call(e, arguments[n]);
      }

      return e;
    };
  },
  139: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(140);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      deleteAll: function deleteAll() {
        return o.apply(this, arguments);
      }
    });
  },
  14: function _(e, t, n) {
    "use strict";

    function g(r) {
      function e(e, t, n) {
        if (this instanceof r) {
          switch (arguments.length) {
            case 0:
              return new r();

            case 1:
              return new r(e);

            case 2:
              return new r(e, t);
          }

          return new r(e, t, n);
        }

        return r.apply(this, arguments);
      }

      return e.prototype = r.prototype, e;
    }

    var b = n(21),
        y = n(97).f,
        v = n(99),
        h = n(44),
        m = n(22),
        S = n(29),
        A = n(28);

    e.exports = function (e, t) {
      var n,
          r,
          i,
          o,
          a,
          c = e.target,
          u = e.global,
          s = e.stat,
          d = e.proto,
          f = u ? b : s ? b[c] : (b[c] || {}).prototype,
          l = u ? h : h[c] || (h[c] = {}),
          p = l.prototype;

      for (n in t) {
        o = !v(u ? n : c + (s ? "." : "#") + n, e.forced) && f && A(f, n), r = l[n], o && (i = e.noTargetGet ? (a = y(f, n)) && a.value : f[n]), a = o && i ? i : t[n], o && (0, _typeof2.default)(r) == (0, _typeof2.default)(a) || (o = e.bind && o ? m(a, b) : e.wrap && o ? g(a) : d && "function" == typeof a ? m(Function.call, a) : a, (e.sham || a && a.sham || r && r.sham) && S(o, "sham", !0), l[n] = o, d && (A(h, o = c + "Prototype") || S(h, o, {}), h[o][n] = a, e.real && p && !p[n] && S(p, n, a)));
      }
    };
  },
  140: function _(e, t, n) {
    "use strict";

    var a = n(15),
        c = n(18);

    e.exports = function () {
      for (var e, t = a(this), n = c(t.delete), r = !0, i = 0, o = arguments.length; i < o; i++) {
        e = n.call(t, arguments[i]), r = r && e;
      }

      return !!r;
    };
  },
  141: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(15),
        a = n(22),
        c = n(35),
        u = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      every: function every(e) {
        var n = o(this),
            t = c(n),
            r = a(e, 1 < arguments.length ? arguments[1] : void 0, 3);
        return !u(t, function (e, t) {
          if (!r(e, e, n)) return t();
        }, {
          IS_ITERATOR: !0,
          INTERRUPTED: !0
        }).stopped;
      }
    });
  },
  142: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(23),
        a = n(15),
        c = n(18),
        u = n(39),
        s = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      difference: function difference(e) {
        var t = a(this),
            n = new (u(t, o("Set")))(t),
            r = c(n.delete);
        return s(e, function (e) {
          r.call(n, e);
        }), n;
      }
    });
  },
  143: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        a = n(23),
        c = n(15),
        u = n(18),
        s = n(22),
        d = n(39),
        f = n(35),
        l = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      filter: function filter(e) {
        var t = c(this),
            n = f(t),
            r = s(e, 1 < arguments.length ? arguments[1] : void 0, 3),
            i = new (d(t, a("Set")))(),
            o = u(i.add);
        return l(n, function (e) {
          r(e, e, t) && o.call(i, e);
        }, {
          IS_ITERATOR: !0
        }), i;
      }
    });
  },
  144: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(15),
        a = n(22),
        c = n(35),
        u = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      find: function find(e) {
        var n = o(this),
            t = c(n),
            r = a(e, 1 < arguments.length ? arguments[1] : void 0, 3);
        return u(t, function (e, t) {
          if (r(e, e, n)) return t(e);
        }, {
          IS_ITERATOR: !0,
          INTERRUPTED: !0
        }).result;
      }
    });
  },
  145: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(23),
        a = n(15),
        c = n(18),
        u = n(39),
        s = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      intersection: function intersection(e) {
        var t = a(this),
            n = new (u(t, o("Set")))(),
            r = c(t.has),
            i = c(n.add);
        return s(e, function (e) {
          r.call(t, e) && i.call(n, e);
        }), n;
      }
    });
  },
  146: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(15),
        a = n(18),
        c = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      isDisjointFrom: function isDisjointFrom(e) {
        var n = o(this),
            r = a(n.has);
        return !c(e, function (e, t) {
          if (!0 === r.call(n, e)) return t();
        }, {
          INTERRUPTED: !0
        }).stopped;
      }
    });
  },
  147: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(23),
        a = n(15),
        c = n(18),
        u = n(87),
        s = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      isSubsetOf: function isSubsetOf(e) {
        var t = u(this),
            n = a(e),
            r = n.has;
        return "function" != typeof r && (n = new (o("Set"))(e), r = c(n.has)), !s(t, function (e, t) {
          if (!1 === r.call(n, e)) return t();
        }, {
          IS_ITERATOR: !0,
          INTERRUPTED: !0
        }).stopped;
      }
    });
  },
  148: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(15),
        a = n(18),
        c = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      isSupersetOf: function isSupersetOf(e) {
        var n = o(this),
            r = a(n.has);
        return !c(e, function (e, t) {
          if (!1 === r.call(n, e)) return t();
        }, {
          INTERRUPTED: !0
        }).stopped;
      }
    });
  },
  149: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(15),
        a = n(35),
        c = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      join: function join(e) {
        var t = o(this),
            n = a(t),
            t = void 0 === e ? "," : String(e),
            e = [];
        return c(n, e.push, {
          that: e,
          IS_ITERATOR: !0
        }), e.join(t);
      }
    });
  },
  15: function _(e, t, n) {
    var r = n(24);

    e.exports = function (e) {
      if (!r(e)) throw TypeError(String(e) + " is not an object");
      return e;
    };
  },
  150: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        a = n(23),
        c = n(15),
        u = n(18),
        s = n(22),
        d = n(39),
        f = n(35),
        l = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      map: function map(e) {
        var t = c(this),
            n = f(t),
            r = s(e, 1 < arguments.length ? arguments[1] : void 0, 3),
            i = new (d(t, a("Set")))(),
            o = u(i.add);
        return l(n, function (e) {
          o.call(i, r(e, e, t));
        }, {
          IS_ITERATOR: !0
        }), i;
      }
    });
  },
  151: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(15),
        a = n(18),
        c = n(35),
        u = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      reduce: function reduce(t) {
        var n = o(this),
            e = c(n),
            r = arguments.length < 2,
            i = r ? void 0 : arguments[1];
        if (a(t), u(e, function (e) {
          i = r ? (r = !1, e) : t(i, e, e, n);
        }, {
          IS_ITERATOR: !0
        }), r) throw TypeError("Reduce of empty set with no initial value");
        return i;
      }
    });
  },
  152: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(15),
        a = n(22),
        c = n(35),
        u = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      some: function some(e) {
        var n = o(this),
            t = c(n),
            r = a(e, 1 < arguments.length ? arguments[1] : void 0, 3);
        return u(t, function (e, t) {
          if (r(e, e, n)) return t();
        }, {
          IS_ITERATOR: !0,
          INTERRUPTED: !0
        }).stopped;
      }
    });
  },
  153: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(23),
        a = n(15),
        c = n(18),
        u = n(39),
        s = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      symmetricDifference: function symmetricDifference(e) {
        var t = a(this),
            n = new (u(t, o("Set")))(t),
            r = c(n.delete),
            i = c(n.add);
        return s(e, function (e) {
          r.call(n, e) || i.call(n, e);
        }), n;
      }
    });
  },
  154: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(16),
        o = n(23),
        a = n(15),
        c = n(18),
        u = n(39),
        s = n(17);
    r({
      target: "Set",
      proto: !0,
      real: !0,
      forced: i
    }, {
      union: function union(e) {
        var t = a(this),
            t = new (u(t, o("Set")))(t);
        return s(e, c(t.add), {
          that: t
        }), t;
      }
    });
  },
  155: function _(e, t, n) {
    n(86), n(156);
    n = n(44);
    e.exports = n.Array.from;
  },
  156: function _(e, t, n) {
    var r = n(14),
        i = n(157);
    r({
      target: "Array",
      stat: !0,
      forced: !n(160)(function (e) {
        Array.from(e);
      })
    }, {
      from: i
    });
  },
  157: function _(e, t, n) {
    "use strict";

    var p = n(22),
        g = n(57),
        b = n(158),
        y = n(78),
        v = n(50),
        h = n(159),
        m = n(61);

    e.exports = function (e) {
      var t,
          n,
          r,
          i,
          o,
          a,
          c = g(e),
          u = "function" == typeof this ? this : Array,
          s = arguments.length,
          d = 1 < s ? arguments[1] : void 0,
          f = void 0 !== d,
          e = m(c),
          l = 0;
      if (f && (d = p(d, 2 < s ? arguments[2] : void 0, 2)), null == e || u == Array && y(e)) for (n = new u(t = v(c.length)); l < t; l++) {
        a = f ? d(c[l], l) : c[l], h(n, l, a);
      } else for (o = (i = e.call(c)).next, n = new u(); !(r = o.call(i)).done; l++) {
        a = f ? b(i, d, [r.value, l], !0) : r.value, h(n, l, a);
      }
      return n.length = l, n;
    };
  },
  158: function _(e, t, n) {
    var i = n(15),
        o = n(79);

    e.exports = function (t, e, n, r) {
      try {
        return r ? e(i(n)[0], n[1]) : e(n);
      } catch (e) {
        throw o(t), e;
      }
    };
  },
  159: function _(e, t, n) {
    "use strict";

    var r = n(55),
        i = n(31),
        o = n(47);

    e.exports = function (e, t, n) {
      t = r(t);
      t in e ? i.f(e, t, o(0, n)) : e[t] = n;
    };
  },
  16: function _(e, t) {
    e.exports = !0;
  },
  160: function _(e, t, n) {
    var i = n(19)("iterator"),
        o = !1;

    try {
      var r = 0,
          a = {
        next: function next() {
          return {
            done: !!r++
          };
        },
        return: function _return() {
          o = !0;
        }
      };
      a[i] = function () {
        return this;
      }, Array.from(a, function () {
        throw 2;
      });
    } catch (e) {}

    e.exports = function (e, t) {
      if (!t && !o) return !1;
      var n = !1;

      try {
        var r = {};
        r[i] = function () {
          return {
            next: function next() {
              return {
                done: n = !0
              };
            }
          };
        }, e(r);
      } catch (e) {}

      return n;
    };
  },
  161: function _(e, t) {
    e.exports = function e(t) {
      var n = Array.isArray(t) ? [] : {};

      for (var r in t) {
        var i = t[r];
        n[r] = i && "object" == (0, _typeof2.default)(i) ? e(i) : i;
      }

      return n;
    };
  },
  162: function _(e, t, n) {
    "use strict";

    t.a = function (e, t, n, r, i) {
      for (t = t.split ? t.split(".") : t, r = 0; r < t.length; r++) {
        e = e ? e[t[r]] : i;
      }

      return e === i ? n : e;
    };
  },
  163: function _(e, t, n) {
    "use strict";

    t.a = function (e, t, n) {
      for (var r, i = 0, o = (t = t.split ? t.split(".") : t).length, a = e; i < o; ++i) {
        r = a[t[i]], a = a[t[i]] = i === o - 1 ? n : null != r ? r : !~t[i + 1].indexOf(".") && -1 < +t[i + 1] ? [] : {};
      }
    };
  },
  164: function _(e, t) {
    h.SYNC = 1, h.ASYNC = 2, h.QUEUE = 4;
    var g = "fun-hooks";
    var n = Object.freeze({
      useProxy: !0,
      ready: 0
    }),
        b = new WeakMap(),
        r = "2,1,0" === [1].reduce(function (e, t, n) {
      return [e, t, n];
    }, 2).toString() ? Array.prototype.reduce : function (e, t) {
      var n,
          r = Object(this),
          i = r.length >>> 0,
          o = 0;
      if (t) n = t;else {
        for (; o < i && !(o in r);) {
          o++;
        }

        n = r[o++];
      }

      for (; o < i;) {
        o in r && (n = e(n, r[o], o, r)), o++;
      }

      return n;
    };

    function y(e, t) {
      return Array.prototype.slice.call(e, t);
    }

    var v = Object.assign || function (e) {
      return r.call(y(arguments, 1), function (t, n) {
        return n && Object.keys(n).forEach(function (e) {
          t[e] = n[e];
        }), t;
      }, e);
    };

    function h(u) {
      var s,
          e = {},
          f = [];

      function t(e, t) {
        return "function" == typeof e ? a.call(null, "sync", e, t) : "string" == typeof e && "function" == typeof t ? a.apply(null, arguments) : "object" == (0, _typeof2.default)(e) ? function (r, e, i) {
          var t = !0;
          void 0 === e && (e = Object.getOwnPropertyNames(r), t = !1);
          var o = {},
              n = ["constructor"];

          for (; (e = e.filter(function (e) {
            return !("function" != typeof r[e] || -1 !== n.indexOf(e) || e.match(/^_/));
          })).forEach(function (e) {
            var t = e.split(":"),
                n = t[0],
                e = t[1] || "sync";
            o[n] || (t = r[n], o[n] = r[n] = a(e, t, i ? [i, n] : void 0));
          }), r = Object.getPrototypeOf(r), t && r;) {
            ;
          }

          return o;
        }.apply(null, arguments) : void 0;
      }

      function l(o) {
        var a = Array.isArray(o) ? o : o.split(".");
        return r.call(a, function (t, n, e) {
          var r = t[n],
              i = !1;
          return r || (e === a.length - 1 ? (s || f.push(function () {
            i || console.warn(g + ": referenced '" + o + "' but it was never created");
          }), t[n] = p(function (e) {
            t[n] = e, i = !0;
          })) : t[n] = {});
        }, e);
      }

      function p(r) {
        var o = [],
            a = [],
            c = function c() {},
            e = {
          before: function before(e, t) {
            return n.call(this, o, "before", e, t);
          },
          after: function after(e, t) {
            return n.call(this, a, "after", e, t);
          },
          getHooks: function getHooks(n) {
            var e = o.concat(a);
            "object" == (0, _typeof2.default)(n) && (e = e.filter(function (t) {
              return Object.keys(n).every(function (e) {
                return t[e] === n[e];
              });
            }));

            try {
              v(e, {
                remove: function remove() {
                  return e.forEach(function (e) {
                    e.remove();
                  }), this;
                }
              });
            } catch (e) {
              console.error("error adding `remove` to array, did you modify Array.prototype?");
            }

            return e;
          },
          removeAll: function removeAll() {
            return this.getHooks().remove();
          }
        };

        return b.set(e.after, {
          install: function install(e, t, n) {
            this.type = e, (c = n)(o, a), r && r(t);
          }
        }), e;

        function n(t, e, n, r) {
          var i = {
            hook: n,
            type: e,
            priority: r || 10,
            remove: function remove() {
              var e = t.indexOf(i);
              -1 !== e && (t.splice(e, 1), c(o, a));
            }
          };
          return t.push(i), t.sort(function (e, t) {
            return t.priority - e.priority;
          }), c(o, a), this;
        }
      }

      function a(d, e, t) {
        var n = e.after && b.get(e.after);

        if (n) {
          if (n.type !== d) throw g + ": recreated hookable with different type";
          return e;
        }

        var r,
            i,
            o = t ? l(t) : p(),
            a = {
          get: function get(e, t) {
            return o[t] || Reflect.get.apply(Reflect, arguments);
          }
        };
        return s || f.push(c), u.useProxy && "function" == typeof Proxy && Proxy.revocable ? i = new Proxy(e, a) : v(i = function i() {
          return a.apply ? a.apply(e, this, y(arguments)) : e.apply(this, arguments);
        }, o), b.get(i.after).install(d, i, function (e, t) {
          var u,
              s = [];
          r = e.length || t.length ? (e.forEach(n), u = s.push(void 0) - 1, t.forEach(n), function (t, n, e) {
            var r,
                i = 0,
                o = "async" === d && "function" == typeof e[e.length - 1] && e.pop();

            function a(e) {
              "sync" === d ? r = e : o && o.apply(null, arguments);
            }

            function c(e) {
              if (s[i]) {
                var t = y(arguments);
                return c.bail = a, t.unshift(c), s[i++].apply(n, t);
              }

              "sync" === d ? r = e : o && o.apply(null, arguments);
            }

            return s[u] = function () {
              var e = y(arguments, 1);
              "async" === d && o && (delete c.bail, e.push(c));
              e = t.apply(n, e);
              "sync" === d && c(e);
            }, c.apply(null, e), r;
          }) : void 0;

          function n(e) {
            s.push(e.hook);
          }

          c();
        }), i;

        function c() {
          !s && ("sync" !== d || u.ready & h.SYNC) && ("async" !== d || u.ready & h.ASYNC) ? "sync" !== d && u.ready & h.QUEUE ? a.apply = function () {
            var e = arguments;
            f.push(function () {
              i.apply(e[1], e[2]);
            });
          } : a.apply = function () {
            throw g + ": hooked function not ready";
          } : a.apply = r;
        }
      }

      return (u = v({}, n, u)).ready ? t.ready = function () {
        s = !0, function (e) {
          for (var t; t = e.shift();) {
            t();
          }
        }(f);
      } : s = !0, t.get = l, t;
    }

    e.exports = h;
  },
  17: function _(e, t, n) {
    function y(e, t) {
      this.stopped = e, this.result = t;
    }

    var v = n(15),
        h = n(78),
        m = n(50),
        S = n(22),
        A = n(61),
        E = n(79);

    e.exports = function (e, t, n) {
      function r(e) {
        return o && E(o), new y(!0, e);
      }

      function i(e) {
        return l ? (v(e), g ? b(e[0], e[1], r) : b(e[0], e[1])) : g ? b(e, r) : b(e);
      }

      var o,
          a,
          c,
          u,
          s,
          d,
          f = n && n.that,
          l = !(!n || !n.AS_ENTRIES),
          p = !(!n || !n.IS_ITERATOR),
          g = !(!n || !n.INTERRUPTED),
          b = S(t, f, 1 + l + g);
      if (p) o = e;else {
        if ("function" != typeof (p = A(e))) throw TypeError("Target is not iterable");

        if (h(p)) {
          for (a = 0, c = m(e.length); a < c; a++) {
            if ((u = i(e[a])) && u instanceof y) return u;
          }

          return new y(!1);
        }

        o = p.call(e);
      }

      for (s = o.next; !(d = s.call(o)).done;) {
        try {
          u = i(d.value);
        } catch (e) {
          throw E(o), e;
        }

        if ("object" == (0, _typeof2.default)(u) && u && u instanceof y) return u;
      }

      return new y(!1);
    };
  },
  18: function _(e, t) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(String(e) + " is not a function");
      return e;
    };
  },
  19: function _(e, t, n) {
    var r = n(21),
        i = n(73),
        o = n(28),
        a = n(60),
        c = n(74),
        n = n(106),
        u = i("wks"),
        s = r.Symbol,
        d = n ? s : s && s.withoutSetter || a;

    e.exports = function (e) {
      return o(u, e) && (c || "string" == typeof u[e]) || (c && o(s, e) ? u[e] = s[e] : u[e] = d("Symbol." + e)), u[e];
    };
  },
  2: function _(e, t, n) {
    "use strict";

    n.d(t, "c", function () {
      return r;
    }), n.d(t, "d", function () {
      return i;
    }), n.d(t, "b", function () {
      return o;
    }), n.d(t, "a", function () {
      return a;
    });
    var r = "native",
        i = "video",
        o = "banner",
        a = "adpod";
  },
  20: function _(e, t, n) {
    "use strict";

    t.a = function () {
      return window.pbjs;
    }, window.pbjs = window.pbjs || {}, window.pbjs.cmd = window.pbjs.cmd || [], window.pbjs.que = window.pbjs.que || [], window._pbjsGlobals = window._pbjsGlobals || [], window._pbjsGlobals.push("pbjs");
  },
  21: function _(n, e, t) {
    !function (e) {
      function t(e) {
        return e && e.Math == Math && e;
      }

      n.exports = t("object" == (typeof globalThis === "undefined" ? "undefined" : (0, _typeof2.default)(globalThis)) && globalThis) || t("object" == (typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) && window) || t("object" == (typeof self === "undefined" ? "undefined" : (0, _typeof2.default)(self)) && self) || t("object" == (0, _typeof2.default)(e) && e) || function () {
        return this;
      }() || Function("return this")();
    }.call(e, t(34));
  },
  218: function _(e, t, n) {
    n(219);
    n = n(52);
    e.exports = n("Array", "findIndex");
  },
  219: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(56).findIndex,
        o = n(51),
        n = "findIndex",
        a = !0;
    n in [] && Array(1)[n](function () {
      a = !1;
    }), r({
      target: "Array",
      proto: !0,
      forced: a
    }, {
      findIndex: function findIndex(e) {
        return i(this, e, 1 < arguments.length ? arguments[1] : void 0);
      }
    }), o(n);
  },
  22: function _(e, t, n) {
    var o = n(18);

    e.exports = function (r, i, e) {
      if (o(r), void 0 === i) return r;

      switch (e) {
        case 0:
          return function () {
            return r.call(i);
          };

        case 1:
          return function (e) {
            return r.call(i, e);
          };

        case 2:
          return function (e, t) {
            return r.call(i, e, t);
          };

        case 3:
          return function (e, t, n) {
            return r.call(i, e, t, n);
          };
      }

      return function () {
        return r.apply(i, arguments);
      };
    };
  },
  226: function _(e, t, n) {
    "use strict";

    t.a = function () {
      window.addEventListener("message", i, !1);
    };

    var r = n(9),
        l = n.n(r),
        p = n(36),
        t = n(5),
        g = (n.n(t), n(0)),
        b = n(26),
        r = n(10),
        y = n.n(r),
        v = n(11),
        r = n(12),
        h = n.n(r),
        m = t.EVENTS.BID_WON;

    function i(e) {
      var t,
          n,
          r,
          i,
          o,
          a,
          c,
          u,
          s,
          d = e.message ? "message" : "data",
          f = {};

      try {
        f = JSON.parse(e[d]);
      } catch (e) {
        return;
      }

      f && f.adId && ((t = y()(b.a.getBidsReceived(), function (e) {
        return e.adId === f.adId;
      })) && "Prebid Request" === f.message && (r = e, i = (n = t).adId, o = n.ad, a = n.adUrl, c = n.width, u = n.height, s = n.renderer, d = n.cpm, Object(v.c)(s) ? Object(v.b)(s, n) : i && (function (e) {
        var r = e.adId,
            i = e.adUnitCode,
            t = e.width,
            n = e.height;

        function o(e) {
          var t,
              n = (t = r, n = i, window.googletag ? function (n) {
            return y()(window.googletag.pubads().getSlots(), function (t) {
              return y()(t.getTargetingKeys(), function (e) {
                return h()(t.getTargeting(e), n);
              });
            }).getSlotElementId();
          }(t) : window.apntag ? function (e) {
            e = window.apntag.getTag(e);
            return e && e.targetId;
          }(n) : n),
              n = document.getElementById(n);
          return n && n.querySelector(e);
        }

        ["div", "iframe"].forEach(function (e) {
          e = o(e + ':not([style*="display: none"])');
          e ? ((e = e.style).width = t + "px", e.height = n + "px") : Object(g.logWarn)("Unable to locate matching page element for adUnitCode ".concat(i, ".  Can't resize it to ad's dimensions.  Please review setup."));
        });
      }(n), r.source.postMessage(JSON.stringify({
        message: "Prebid Response",
        ad: Object(g.replaceAuctionPrice)(o, d),
        adUrl: Object(g.replaceAuctionPrice)(a, d),
        adId: i,
        width: c,
        height: u
      }), r.origin)), b.a.addWinningBid(t), l.a.emit(m, t)), t && "Prebid Native" === f.message && ("assetRequest" !== f.action ? "click" !== Object(p.b)(f, t) && (b.a.addWinningBid(t), l.a.emit(m, t)) : (t = Object(p.c)(f, t), e.source.postMessage(JSON.stringify(t), e.origin))));
    }
  },
  227: function _(e, t, n) {
    "use strict";

    t.a = function (e) {
      var t;

      try {
        e = e || window.sessionStorage, t = JSON.parse(e.getItem(u));
      } catch (e) {}

      t && p(t, !0);
    };

    var r,
        i,
        o = n(3),
        a = n(0),
        c = n(41),
        u = "pbjs:debugging";

    function s(e) {
      Object(a.logMessage)("DEBUG: " + e);
    }

    function d(e) {
      Object(a.logWarn)("DEBUG: " + e);
    }

    function f(e) {
      r = function (e, t, n) {
        b(this.bidders, n.bidderCode) ? d("bidder '".concat(n.bidderCode, "' excluded from auction by bidder overrides")) : (Array.isArray(this.bids) && this.bids.forEach(function (e) {
          g(e, n.bidderCode, t) || y(e, n, "bidder");
        }), e(t, n));
      }.bind(e), c.c.before(r, 5), i = function (e, t) {
        var r = this,
            t = t.filter(function (e) {
          return !b(r.bidders, e.bidderCode) || (d("bidRequest '".concat(e.bidderCode, "' excluded from auction by bidder overrides")), !1);
        });
        Array.isArray(r.bidRequests) && t.forEach(function (n) {
          r.bidRequests.forEach(function (t) {
            n.bids.forEach(function (e) {
              g(t, n.bidderCode, e.adUnitCode) || y(t, e, "bidRequest");
            });
          });
        });
        e(t);
      }.bind(e), c.e.before(i, 5);
    }

    function l() {
      c.c.getHooks({
        hook: r
      }).remove(), c.e.getHooks({
        hook: i
      }).remove();
    }

    function p(e, t) {
      t = 1 < arguments.length && void 0 !== t && t;
      o.b.setConfig({
        debug: !0
      }), l(), f(e), s("bidder overrides enabled".concat(t ? " from session" : ""));
    }

    function g(e, t, n) {
      return e.bidder && e.bidder !== t || !(!e.adUnitCode || e.adUnitCode === n);
    }

    function b(e, t) {
      return Array.isArray(e) && -1 === e.indexOf(t);
    }

    function y(n, e, r) {
      return Object.keys(n).filter(function (e) {
        return -1 === ["adUnitCode", "bidder"].indexOf(e);
      }).reduce(function (e, t) {
        return s("bidder overrides changed '".concat(e.adUnitCode, "/").concat(e.bidderCode, "' ").concat(r, ".").concat(t, " from '").concat(e[t], ".js' to '").concat(n[t], "'")), e[t] = n[t], e;
      }, e);
    }

    function v(e) {
      if (e.enabled) {
        try {
          window.sessionStorage.setItem(u, JSON.stringify(e));
        } catch (e) {}

        p(e);
      } else {
        l(), s("bidder overrides disabled");

        try {
          window.sessionStorage.removeItem(u);
        } catch (e) {}
      }
    }

    o.b.getConfig("debugging", function (e) {
      return v(e.debugging);
    });
  },
  23: function _(e, t, n) {
    function r(e) {
      return "function" == typeof e ? e : void 0;
    }

    var i = n(44),
        o = n(21);

    e.exports = function (e, t) {
      return arguments.length < 2 ? r(i[e]) || r(o[e]) : i[e] && i[e][t] || o[e] && o[e][t];
    };
  },
  24: function _(e, t) {
    e.exports = function (e) {
      return "object" == (0, _typeof2.default)(e) ? null !== e : "function" == typeof e;
    };
  },
  25: function _(e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return i;
    });
    var r = n(3);

    var i = function i() {
      return window, {
        canonicalUrl: null,
        numIframes: 0,
        reachedTop: !0,
        referer: e = r.b.getConfig("pageUrl") || window.location.href,
        stack: [e]
      };
      var e;
    };
  },
  26: function _(e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return s;
    });
    var r = n(0),
        a = n(41),
        t = n(10),
        i = n.n(t),
        o = n(5);
    var c,
        u,
        s = (c = [], (u = {
      addWinningBid: function addWinningBid(t) {
        var e = i()(c, function (e) {
          return e.getAuctionId() === t.auctionId;
        });
        e ? (t.status = o.BID_STATUS.RENDERED, e.addWinningBid(t)) : Object(r.logWarn)("Auction not found when adding winning bid");
      },
      getAllWinningBids: function getAllWinningBids() {
        return c.map(function (e) {
          return e.getWinningBids();
        }).reduce(r.flatten, []);
      },
      getBidsRequested: function getBidsRequested() {
        return c.map(function (e) {
          return e.getBidRequests();
        }).reduce(r.flatten, []);
      },
      getNoBids: function getNoBids() {
        return c.map(function (e) {
          return e.getNoBids();
        }).reduce(r.flatten, []);
      },
      getBidsReceived: function getBidsReceived() {
        return c.map(function (e) {
          if (e.getAuctionStatus() === a.a) return e.getBidsReceived();
        }).reduce(r.flatten, []).filter(function (e) {
          return e;
        });
      },
      getAdUnits: function getAdUnits() {
        return c.map(function (e) {
          return e.getAdUnits();
        }).reduce(r.flatten, []);
      },
      getAdUnitCodes: function getAdUnitCodes() {
        return c.map(function (e) {
          return e.getAdUnitCodes();
        }).reduce(r.flatten, []).filter(r.uniques);
      }
    }).createAuction = function (e) {
      var t = e.adUnits,
          n = e.adUnitCodes,
          r = e.callback,
          i = e.cbTimeout,
          o = e.labels,
          e = e.auctionId,
          o = Object(a.k)({
        adUnits: t,
        adUnitCodes: n,
        callback: r,
        cbTimeout: i,
        labels: o,
        auctionId: e
      });
      return e = o, c.push(e), o;
    }, u.findBidByAdId = function (t) {
      return i()(c.map(function (e) {
        return e.getBidsReceived();
      }).reduce(r.flatten, []), function (e) {
        return e.adId === t;
      });
    }, u.getStandardBidderAdServerTargeting = function () {
      return Object(a.j)()[o.JSON_MAPPING.ADSERVER_TARGETING];
    }, u.setStatusForBids = function (e, t) {
      var n = u.findBidByAdId(e);
      n && (n.status = t), !n || t !== o.BID_STATUS.BID_TARGETING_SET || (t = i()(c, function (e) {
        return e.getAuctionId() === n.auctionId;
      })) && t.setBidTargeting(n);
    }, u.getLastAuctionId = function () {
      return c.length && c[c.length - 1].getAuctionId();
    }, u);
  },
  27: function _(e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  },
  28: function _(e, t) {
    var n = {}.hasOwnProperty;

    e.exports = function (e, t) {
      return n.call(e, t);
    };
  },
  29: function _(e, t, n) {
    var r = n(30),
        i = n(31),
        o = n(47);
    e.exports = r ? function (e, t, n) {
      return i.f(e, t, o(1, n));
    } : function (e, t, n) {
      return e[t] = n, e;
    };
  },
  3: function _(e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return p;
    }), n.d(t, "b", function () {
      return E;
    });
    var r = n(46),
        t = n(10),
        a = n.n(t),
        t = n(12),
        i = n.n(t),
        t = n(76),
        o = n.n(t),
        c = n(0);

    function u() {
      return (u = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n,
              r = arguments[t];

          for (n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var s = n(88),
        d = n(0),
        n = n(5),
        f = "TRUE" === d.getParameterByName(n.DEBUG_MODE).toUpperCase(),
        l = window.location.origin,
        p = "random",
        g = {};
    g[p] = !0, g.fixed = !0;
    var b = p,
        y = {
      LOW: "low",
      MEDIUM: "medium",
      HIGH: "high",
      AUTO: "auto",
      DENSE: "dense",
      CUSTOM: "custom"
    };
    var v,
        h,
        m,
        S,
        A,
        E = (S = [], A = null, T(), {
      getCurrentBidder: function getCurrentBidder() {
        return A;
      },
      getConfig: function getConfig() {
        if (arguments.length <= 1 && "function" != typeof (arguments.length <= 0 ? void 0 : arguments[0])) {
          var e = arguments.length <= 0 ? void 0 : arguments[0];
          return e ? d.deepAccess(O(), e) : O();
        }

        return function (e, t) {
          "string" != typeof e && (t = e, e = "*");

          if ("function" == typeof t) {
            var n = {
              topic: e,
              callback: t
            };
            return S.push(n), function () {
              S.splice(S.indexOf(n), 1);
            };
          }

          d.logError("listener must be a function");
        }.apply(void 0, arguments);
      },
      setConfig: function setConfig(n) {
        var e, r;
        d.isPlainObject(n) ? (e = Object.keys(n), r = {}, e.forEach(function (e) {
          var t = n[e];
          d.isPlainObject(v[e]) && d.isPlainObject(t) && (t = u({}, v[e], t)), r[e] = h[e] = t;
        }), I(r)) : d.logError("setConfig options must be an object");
      },
      setDefaults: function setDefaults(e) {
        d.isPlainObject(v) ? (u(v, e), u(h, e)) : d.logError("defaults must be an object");
      },
      resetConfig: T,
      runWithBidder: C,
      callbackWithBidder: function callbackWithBidder(o) {
        return function (i) {
          return function () {
            if ("function" == typeof i) {
              for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                n[r] = arguments[r];
              }

              return C(o, (e = d.bind).call.apply(e, [i, this].concat(n)));
            }

            d.logWarn("config.callbackWithBidder callback is not a function");
          };
        };
      },
      setBidderConfig: function setBidderConfig(r) {
        try {
          !function (e) {
            if (!d.isPlainObject(e)) throw "setBidderConfig bidder options must be an object";
            if (!Array.isArray(e.bidders) || !e.bidders.length) throw "setBidderConfig bidder options must contain a bidders list with at least 1 bidder";
            if (!d.isPlainObject(e.config)) throw "setBidderConfig bidder options must contain a config object";
          }(r), r.bidders.forEach(function (n) {
            m[n] || (m[n] = {}), Object.keys(r.config).forEach(function (e) {
              var t = r.config[e];
              d.isPlainObject(t) ? m[n][e] = u({}, m[n][e] || {}, t) : m[n][e] = t;
            });
          });
        } catch (e) {
          d.logError(e);
        }
      },
      getBidderConfig: function getBidderConfig() {
        return m;
      }
    });

    function T() {
      v = {};
      var n = {
        _debug: f,

        get debug() {
          return this._debug;
        },

        set debug(e) {
          this._debug = e;
        },

        _bidderTimeout: 3e3,

        get bidderTimeout() {
          return this._bidderTimeout;
        },

        set bidderTimeout(e) {
          this._bidderTimeout = e;
        },

        _publisherDomain: l,

        get publisherDomain() {
          return this._publisherDomain;
        },

        set publisherDomain(e) {
          this._publisherDomain = e;
        },

        _priceGranularity: y.MEDIUM,

        set priceGranularity(e) {
          o(e) && ("string" == typeof e ? this._priceGranularity = i(e) ? e : y.MEDIUM : d.isPlainObject(e) && (this._customPriceBucket = e, this._priceGranularity = y.CUSTOM, d.logMessage("Using custom price granularity")));
        },

        get priceGranularity() {
          return this._priceGranularity;
        },

        _customPriceBucket: {},

        get customPriceBucket() {
          return this._customPriceBucket;
        },

        _mediaTypePriceGranularity: {},

        get mediaTypePriceGranularity() {
          return this._mediaTypePriceGranularity;
        },

        set mediaTypePriceGranularity(n) {
          var r = this;
          this._mediaTypePriceGranularity = Object.keys(n).reduce(function (e, t) {
            return o(n[t]) ? "string" == typeof n ? e[t] = i(n[t]) ? n[t] : r._priceGranularity : d.isPlainObject(n) && (e[t] = n[t], d.logMessage("Using custom price granularity for ".concat(t))) : d.logWarn("Invalid price granularity for media type: ".concat(t)), e;
          }, {});
        },

        _sendAllBids: !0,

        get enableSendAllBids() {
          return this._sendAllBids;
        },

        set enableSendAllBids(e) {
          this._sendAllBids = e;
        },

        _useBidCache: !1,

        get useBidCache() {
          return this._useBidCache;
        },

        set useBidCache(e) {
          this._useBidCache = e;
        },

        _deviceAccess: !0,

        get deviceAccess() {
          return this._deviceAccess;
        },

        set deviceAccess(e) {
          this._deviceAccess = e;
        },

        _bidderSequence: b,

        get bidderSequence() {
          return this._bidderSequence;
        },

        set bidderSequence(e) {
          g[e] ? this._bidderSequence = e : d.logWarn("Invalid order: ".concat(e, ". Bidder Sequence was not set."));
        },

        _timeoutBuffer: 400,

        get timeoutBuffer() {
          return this._timeoutBuffer;
        },

        set timeoutBuffer(e) {
          this._timeoutBuffer = e;
        },

        _disableAjaxTimeout: !1,

        get disableAjaxTimeout() {
          return this._disableAjaxTimeout;
        },

        set disableAjaxTimeout(e) {
          this._disableAjaxTimeout = e;
        }

      };

      function i(t) {
        return a()(Object.keys(y), function (e) {
          return t === y[e];
        });
      }

      function o(e) {
        if (e) {
          if ("string" == typeof e) i(e) || d.logWarn("Prebid Warning: setPriceGranularity was called with invalid setting, using `medium` as default.");else if (d.isPlainObject(e) && !Object(r.b)(e)) return void d.logError("Invalid custom price value passed to `setPriceGranularity()`");
          return 1;
        }

        d.logError("Prebid Error: no value passed to `setPriceGranularity()`");
      }

      h && I(Object.keys(h).reduce(function (e, t) {
        return h[t] !== n[t] && (e[t] = n[t] || {}), e;
      }, {})), h = n, m = {};
    }

    function O() {
      if (A && m && d.isPlainObject(m[A])) {
        var n = m[A],
            e = new o.a(Object.keys(h).concat(Object.keys(n)));
        return s(e).reduce(function (e, t) {
          return void 0 === n[t] ? e[t] = h[t] : void 0 !== h[t] && d.isPlainObject(n[t]) ? e[t] = Object(c.mergeDeep)({}, h[t], n[t]) : e[t] = n[t], e;
        }, {});
      }

      return u({}, h);
    }

    function I(r) {
      var t = Object.keys(r);
      S.filter(function (e) {
        return i()(t, e.topic);
      }).forEach(function (e) {
        var t, n;
        e.callback((t = {}, n = e.topic, e = r[e.topic], n in t ? Object.defineProperty(t, n, {
          value: e,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[n] = e, t));
      }), S.filter(function (e) {
        return "*" === e.topic;
      }).forEach(function (e) {
        return e.callback(r);
      });
    }

    function C(e, t) {
      A = e;

      try {
        return t();
      } finally {
        A = null;
      }
    }
  },
  30: function _(e, t, n) {
    n = n(27);
    e.exports = !n(function () {
      return 7 != Object.defineProperty({}, 1, {
        get: function get() {
          return 7;
        }
      })[1];
    });
  },
  31: function _(e, t, n) {
    var r = n(30),
        i = n(71),
        o = n(15),
        a = n(55),
        c = Object.defineProperty;
    t.f = r ? c : function (e, t, n) {
      if (o(e), t = a(t, !0), o(n), i) try {
        return c(e, t, n);
      } catch (e) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
      return "value" in n && (e[t] = n.value), e;
    };
  },
  32: function _(e, t, n) {
    "use strict";

    t.a = function (e, t) {
      return new r(e, t);
    };

    var i = n(0);

    function r(e, t) {
      var n = t && t.src || "client",
          r = e || 0;
      this.bidderCode = t && t.bidder || "", this.width = 0, this.height = 0, this.statusMessage = function () {
        switch (r) {
          case 0:
            return "Pending";

          case 1:
            return "Bid available";

          case 2:
            return "Bid returned empty or error response";

          case 3:
            return "Bid timed out";
        }
      }(), this.adId = i.getUniqueIdentifierStr(), this.requestId = t && t.bidId, this.mediaType = "banner", this.source = n, this.getStatusCode = function () {
        return r;
      }, this.getSize = function () {
        return this.width + "x" + this.height;
      };
    }
  },
  33: function _(e, t, n) {
    "use strict";

    n.d(t, "b", function () {
      return a;
    }), n.d(t, "a", function () {
      return r;
    }), t.d = function (e, t) {
      var n = Object(i.getBidRequest)(e.requestId, t),
          r = n && Object(i.deepAccess)(n, "mediaTypes.video"),
          t = r && Object(i.deepAccess)(r, "context");
      return c(e, n, r, t);
    }, n.d(t, "c", function () {
      return c;
    });
    n(7);
    var i = n(0),
        o = n(3),
        t = n(12),
        n = (n.n(t), n(13)),
        a = "outstream",
        r = "instream";
    var c = Object(n.b)("sync", function (e, t, n, r) {
      return !t || n && r !== a ? o.b.getConfig("cache.url") || !e.vastXml || e.vastUrl ? !(!e.vastUrl && !e.vastXml) : (Object(i.logError)('\n        This bid contains only vastXml and will not work when a prebid cache url is not specified.\n        Try enabling prebid cache with pbjs.setConfig({ cache: {url: "..."} });\n      '), !1) : r !== a || !(!e.renderer && !t.renderer);
    }, "checkVideoBidSetup");
  },
  34: function _(e, t) {
    var n = function () {
      return this;
    }();

    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == (typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) && (n = window);
    }

    e.exports = n;
  },
  348: function _(e, t, n) {
    n = n(349);
    e.exports = n;
  },
  349: function _(e, t, n) {
    n(350);
    n = n(52);
    e.exports = n("String", "includes");
  },
  35: function _(e, t, n) {
    var r = n(16),
        n = n(87);
    e.exports = r ? n : function (e) {
      return Set.prototype.values.call(e);
    };
  },
  350: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(351),
        o = n(49);
    r({
      target: "String",
      proto: !0,
      forced: !n(353)("includes")
    }, {
      includes: function includes(e) {
        return !!~String(o(this)).indexOf(i(e), 1 < arguments.length ? arguments[1] : void 0);
      }
    });
  },
  351: function _(e, t, n) {
    var r = n(352);

    e.exports = function (e) {
      if (r(e)) throw TypeError("The method doesn't accept regular expressions");
      return e;
    };
  },
  352: function _(e, t, n) {
    var r = n(24),
        i = n(43),
        o = n(19)("match");

    e.exports = function (e) {
      var t;
      return r(e) && (void 0 !== (t = e[o]) ? !!t : "RegExp" == i(e));
    };
  },
  353: function _(e, t, n) {
    var r = n(19)("match");

    e.exports = function (t) {
      var n = /./;

      try {
        "/./"[t](n);
      } catch (e) {
        try {
          return n[r] = !1, "/./"[t](n);
        } catch (e) {}
      }

      return !1;
    };
  },
  36: function _(e, t, n) {
    "use strict";

    n.d(t, "e", function () {
      return o;
    }), n.d(t, "a", function () {
      return u;
    }), t.g = function (e) {
      if (e && e.type && function (e) {
        return !(!e || !i()(Object.keys(s), e)) || (Object(a.logError)("".concat(e, " nativeParam is not supported")), !1);
      }(e.type)) return s[e.type];
      return e;
    }, t.f = function (t, e) {
      e = Object(a.getBidRequest)(t.requestId, e);
      if (!e) return !1;
      if (!Object(a.deepAccess)(t, "native.clickUrl")) return !1;
      if (Object(a.deepAccess)(t, "native.image") && (!Object(a.deepAccess)(t, "native.image.height") || !Object(a.deepAccess)(t, "native.image.width"))) return !1;
      if (Object(a.deepAccess)(t, "native.icon") && (!Object(a.deepAccess)(t, "native.icon.height") || !Object(a.deepAccess)(t, "native.icon.width"))) return !1;
      var n = e.nativeParams;
      if (!n) return !0;
      var e = Object.keys(n).filter(function (e) {
        return n[e].required;
      }),
          r = Object.keys(t.native).filter(function (e) {
        return t.native[e];
      });
      return e.every(function (e) {
        return i()(r, e);
      });
    }, t.b = function (e, t) {
      var n;
      "click" === e.action ? n = t.native && t.native.clickTrackers : (n = t.native && t.native.impressionTrackers, t.native && t.native.javascriptTrackers && Object(a.insertHtmlIntoIframe)(t.native.javascriptTrackers));
      return (n || []).forEach(a.triggerPixel), e.action;
    }, t.d = function (r, i) {
      var o = {};
      return Object.keys(r.native).forEach(function (e) {
        var t = c.NATIVE_KEYS[e],
            n = d(r.native[e]);
        Object(a.deepAccess)(i, "mediaTypes.native.".concat(e, ".sendId")) && (n = "".concat(t, ":").concat(r.adId)), t && n && (o[t] = n);
      }), o;
    }, t.c = function (e, n) {
      var r = {
        message: "assetResponse",
        adId: e.adId,
        assets: []
      };
      return e.assets.forEach(function (e) {
        var t = Object(a.getKeyByValue)(c.NATIVE_KEYS, e),
            e = d(n.native[t]);
        r.assets.push({
          key: t,
          value: e
        });
      }), r;
    };
    var a = n(0),
        t = n(12),
        i = n.n(t);

    function r(e) {
      return (r = "function" == typeof Symbol && "symbol" == (0, _typeof2.default)(Symbol.iterator) ? function (e) {
        return (0, _typeof2.default)(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : (0, _typeof2.default)(e);
      })(e);
    }

    var c = n(5),
        o = [],
        u = Object.keys(c.NATIVE_KEYS).map(function (e) {
      return c.NATIVE_KEYS[e];
    }),
        s = {
      image: {
        image: {
          required: !0
        },
        title: {
          required: !0
        },
        sponsoredBy: {
          required: !0
        },
        clickUrl: {
          required: !0
        },
        body: {
          required: !1
        },
        icon: {
          required: !1
        }
      }
    };

    function d(e) {
      return "object" === r(e) && e.url ? e.url : e;
    }
  },
  38: function _(e, t) {
    e.exports = {};
  },
  39: function _(e, t, n) {
    var r = n(15),
        i = n(18),
        o = n(19)("species");

    e.exports = function (e, t) {
      var n,
          e = r(e).constructor;
      return void 0 === e || null == (n = r(e)[o]) ? t : i(n);
    };
  },
  4: function _(e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return r;
    }), t.b = i;
    var l = n(3);

    function p() {
      return (p = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n,
              r = arguments[t];

          for (n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function g(e) {
      return (g = "function" == typeof Symbol && "symbol" == (0, _typeof2.default)(Symbol.iterator) ? function (e) {
        return (0, _typeof2.default)(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : (0, _typeof2.default)(e);
      })(e);
    }

    var b = n(0),
        y = 4,
        r = i();

    function i() {
      var s = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 3e3,
          e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          d = e.request,
          f = e.done;
      return function (e, t, n) {
        var r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {};

        try {
          var i,
              o = r.method || (n ? "POST" : "GET"),
              a = document.createElement("a");
          a.href = e;
          var c,
              u = "object" === g(t) && null !== t ? t : {
            success: function success() {
              b.logMessage("xhr success");
            },
            error: function error(e) {
              b.logError("xhr error", null, e);
            }
          };
          "function" == typeof t && (u.success = t), (i = new window.XMLHttpRequest()).onreadystatechange = function () {
            var e;
            i.readyState === y && ("function" == typeof f && f(a.origin), 200 <= (e = i.status) && e < 300 || 304 === e ? u.success(i.responseText, i) : u.error(i.statusText, i));
          }, l.b.getConfig("disableAjaxTimeout") || (i.ontimeout = function () {
            b.logError("  xhr timeout after ", i.timeout, "ms");
          }), "GET" === o && n && (p((c = b.parseUrl(e, r)).search, n), e = b.buildUrl(c)), i.open(o, e, !0), l.b.getConfig("disableAjaxTimeout") || (i.timeout = s), r.withCredentials && (i.withCredentials = !0), b._each(r.customHeaders, function (e, t) {
            i.setRequestHeader(t, e);
          }), r.preflight && i.setRequestHeader("X-Requested-With", "XMLHttpRequest"), i.setRequestHeader("Content-Type", r.contentType || "text/plain"), "function" == typeof d && d(a.origin), "POST" === o && n ? i.send(n) : i.send();
        } catch (e) {
          b.logError("xhr construction", e);
        }
      };
    }
  },
  40: function _(e, t, n) {
    "use strict";

    t.a = function (r, e, t) {
      if (e && r) {
        if (i()(c, e)) return a[r] ? (t && "function" == typeof t && (a[r].loaded ? t() : a[r].callbacks.push(t)), a[r].tag) : (a[r] = {
          loaded: !1,
          tag: null,
          callbacks: []
        }, t && "function" == typeof t && a[r].callbacks.push(t), o.logWarn("module ".concat(e, " is loading external JavaScript")), function (e, t) {
          var n = document.createElement("script");
          n.type = "text/javascript", n.async = !0, (a[r].tag = n).readyState ? n.onreadystatechange = function () {
            "loaded" !== n.readyState && "complete" !== n.readyState || (n.onreadystatechange = null, t());
          } : n.onload = function () {
            t();
          };
          return n.src = e, o.insertElement(n), n;
        }(r, function () {
          a[r].loaded = !0;

          try {
            for (var e = 0; e < a[r].callbacks.length; e++) {
              a[r].callbacks[e]();
            }
          } catch (e) {
            o.logError("Error executing callback", "adloader.js:loadExternalScript", e);
          }
        }));
        o.logError("".concat(e, " not whitelisted for loading external JavaScript"));
      } else o.logError("cannot load external script without url and moduleCode");
    };

    var t = n(12),
        i = n.n(t),
        o = n(0),
        a = {},
        c = ["criteo", "outstream", "adagio", "browsi"];
  },
  41: function _(e, t, n) {
    "use strict";

    n.d(t, "b", function () {
      return G;
    }), n.d(t, "a", function () {
      return W;
    }), t.k = function (e) {
      var t,
          i,
          g,
          b,
          o = e.adUnits,
          n = e.adUnitCodes,
          r = e.callback,
          a = e.cbTimeout,
          c = e.labels,
          e = e.auctionId,
          y = o,
          u = c,
          s = n,
          v = [],
          d = [],
          f = [],
          l = e || N.generateUUID(),
          p = r,
          h = a,
          m = [],
          S = new Set();

      function A() {
        return {
          auctionId: l,
          timestamp: t,
          auctionEnd: i,
          auctionStatus: g,
          adUnits: y,
          adUnitCodes: s,
          labels: u,
          bidderRequests: v,
          noBids: f,
          bidsReceived: d,
          winningBids: m,
          timeout: h
        };
      }

      function E(t, e) {
        var n, r;
        e && clearTimeout(b), void 0 === i && (n = [], t && (N.logMessage("Auction ".concat(l, " timedOut")), r = S, (n = v.map(function (e) {
          return (e.bids || []).filter(function (e) {
            return !r.has(e.bidder);
          });
        }).reduce(C.flatten, []).map(function (e) {
          return {
            bidId: e.bidId,
            bidder: e.bidder,
            adUnitCode: e.adUnitCode,
            auctionId: e.auctionId
          };
        })).length && P.emit(q.EVENTS.BID_TIMEOUT, n)), g = W, i = Date.now(), P.emit(q.EVENTS.AUCTION_END, A()), J(y, function () {
          try {
            null != p && (e = d.filter(N.bind.call(C.adUnitsFilter, this, s)).reduce(X, {}), p.apply(pbjs, [e, t, l]), p = null);
          } catch (e) {
            N.logError("Error executing bidsBackHandler", null, e);
          } finally {
            n.length && k.callTimedOutBidders(o, n, h);
            var e = _.b.getConfig("userSync") || {};
            e.enableOverride || D(e.syncDelay);
          }
        }));
      }

      function T() {
        N.logInfo("Bids Received for Auction with id: ".concat(l), d), g = W, E(!1, !0);
      }

      function O(e) {
        S.add(e);
      }

      function I(s) {
        var d = this;
        s.forEach(function (e) {
          e = e, v = v.concat(e);
        });
        var f = {},
            e = {
          bidRequests: s,
          run: function run() {
            var e;
            e = E.bind(null, !0), e = setTimeout(e, h), b = e, g = G, P.emit(q.EVENTS.AUCTION_INIT, A());
            var t,
                n,
                r,
                i,
                o,
                a,
                c = (t = T, n = d, r = 0, i = !1, o = new Set(), a = {}, {
              addBidResponse: function addBidResponse(e, t) {
                a[t.requestId] = !0, r++, "video" === (t = function (e) {
                  var t = e.adUnitCode,
                      n = e.bid,
                      r = e.bidderRequest,
                      i = e.auctionId,
                      e = r.start,
                      i = U({}, n, {
                    auctionId: i,
                    responseTimestamp: Object(C.timestamp)(),
                    requestTimestamp: e,
                    cpm: parseFloat(n.cpm) || 0,
                    bidder: n.bidderCode,
                    adUnitCode: t
                  });
                  i.timeToRespond = i.responseTimestamp - i.requestTimestamp, P.emit(q.EVENTS.BID_ADJUSTMENT, i);
                  e = r.bids && R()(r.bids, function (e) {
                    return e.adUnitCode == t;
                  }), r = e && e.renderer;
                  r && r.url && (i.renderer = w.a.install({
                    url: r.url
                  }), i.renderer.setRender(r.render));
                  e = $(n.mediaType, e, _.b.getConfig("mediaTypePriceGranularity")), e = Object(j.a)(i.cpm, "object" === x(e) ? e : _.b.getConfig("customPriceBucket"), _.b.getConfig("currency.granularityMultiplier"));
                  return i.pbLg = e.low, i.pbMg = e.med, i.pbHg = e.high, i.pbAg = e.auto, i.pbDg = e.dense, i.pbCg = e.custom, i;
                }({
                  adUnitCode: e,
                  bid: t,
                  bidderRequest: this,
                  auctionId: n.getAuctionId()
                })).mediaType ? function (e, t, n, r) {
                  var i = !0,
                      o = Object(C.getBidRequest)(t.requestId, [n]),
                      n = o && Object(C.deepAccess)(o, "mediaTypes.video"),
                      n = n && Object(C.deepAccess)(n, "context");
                  _.b.getConfig("cache.url") && n !== B.b && (t.videoCacheKey ? t.vastUrl || (N.logError("videoCacheKey specified but not required vastUrl for video bid"), i = !1) : (i = !1, Q(e, t, r, o)));
                  i && (Y(e, t), r());
                }(n, t, this, u) : (Y(n, t), u());
              },
              adapterDone: function adapterDone() {
                o.add(this), i = n.getBidRequests().every(function (e) {
                  return o.has(e);
                }), this.bids.forEach(function (e) {
                  a[e.bidId] || (n.addNoBid(e), P.emit(q.EVENTS.NO_BID, e));
                }), i && 0 === r && t();
              }
            });

            function u() {
              r--, i && 0 === r && t();
            }

            k.callBids(y, s, function () {
              for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
                t[n] = arguments[n];
              }

              H.apply({
                dispatch: c.addBidResponse,
                bidderRequest: this
              }, t);
            }, c.adapterDone, {
              request: function request(e, t) {
                p(F, t), p(f, e), z[e] || (z[e] = {
                  SRA: !0,
                  origin: t
                }), 1 < f[e] && (z[e].SRA = !1);
              },
              done: function done(e) {
                F[e]--, V[0] && l(V[0]) && V.shift();
              }
            }, h, O);
          }
        };

        function l(e) {
          var r = !0,
              i = _.b.getConfig("maxRequestsPerOrigin") || L;
          return e.bidRequests.some(function (e) {
            var t = 1,
                n = void 0 !== e.src && e.src === q.S2S.SRC ? "s2s" : e.bidderCode;
            return z[n] && (!1 === z[n].SRA && (t = Math.min(e.bids.length, i)), F[z[n].origin] + t > i && (r = !1)), !r;
          }), r && e.run(), r;
        }

        function p(e, t) {
          void 0 === e[t] ? e[t] = 1 : e[t]++;
        }

        l(e) || (N.logWarn("queueing auction due to limited endpoint capacity"), V.push(e));
      }

      return {
        addBidReceived: function addBidReceived(e) {
          d = d.concat(e);
        },
        addNoBid: function addNoBid(e) {
          f = f.concat(e);
        },
        executeCallback: E,
        callBids: function callBids() {
          g = M, t = Date.now();
          var e = k.makeBidRequests(y, t, l, h, u);
          N.logInfo("Bids Requested for Auction with id: ".concat(l), e), e.length < 1 ? (N.logWarn("No valid bid requests returned for auction"), T()) : K.call({
            dispatch: I,
            context: this
          }, e);
        },
        addWinningBid: function addWinningBid(e) {
          m = m.concat(e), k.callBidWonBidder(e.bidder, e, o);
        },
        setBidTargeting: function setBidTargeting(e) {
          k.callSetTargetingBidder(e.bidder, e);
        },
        getWinningBids: function getWinningBids() {
          return m;
        },
        getTimeout: function getTimeout() {
          return h;
        },
        getAuctionId: function getAuctionId() {
          return l;
        },
        getAuctionStatus: function getAuctionStatus() {
          return g;
        },
        getAdUnits: function getAdUnits() {
          return y;
        },
        getAdUnitCodes: function getAdUnitCodes() {
          return s;
        },
        getBidRequests: function getBidRequests() {
          return v;
        },
        getBidsReceived: function getBidsReceived() {
          return d;
        },
        getNoBids: function getNoBids() {
          return f;
        }
      };
    }, n.d(t, "c", function () {
      return H;
    }), n.d(t, "e", function () {
      return K;
    }), t.g = u, t.d = Y, n.d(t, "f", function () {
      return Q;
    }), n.d(t, "i", function () {
      return s;
    }), n.d(t, "h", function () {
      return d;
    }), t.j = f;

    var C = n(0),
        j = n(46),
        a = n(36),
        o = n(92),
        w = n(11),
        _ = n(3),
        r = n(45),
        i = n(13),
        t = n(10),
        R = n.n(t),
        B = n(33),
        c = n(2);

    function x(e) {
      return (x = "function" == typeof Symbol && "symbol" == (0, _typeof2.default)(Symbol.iterator) ? function (e) {
        return (0, _typeof2.default)(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : (0, _typeof2.default)(e);
      })(e);
    }

    function U() {
      return (U = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n,
              r = arguments[t];

          for (n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var D = r.a.syncUsers,
        N = n(0),
        k = n(7).default,
        P = n(9),
        q = n(5),
        M = "started",
        G = "inProgress",
        W = "completed";
    P.on(q.EVENTS.BID_ADJUSTMENT, function (e) {
      !function (e) {
        var t,
            n = e.bidderCode,
            r = e.cpm;
        if (pbjs.bidderSettings && (n && pbjs.bidderSettings[n] && "function" == typeof pbjs.bidderSettings[n].bidCpmAdjustment ? t = pbjs.bidderSettings[n].bidCpmAdjustment : pbjs.bidderSettings[q.JSON_MAPPING.BD_SETTING_STANDARD] && "function" == typeof pbjs.bidderSettings[q.JSON_MAPPING.BD_SETTING_STANDARD].bidCpmAdjustment && (t = pbjs.bidderSettings[q.JSON_MAPPING.BD_SETTING_STANDARD].bidCpmAdjustment), t)) try {
          r = t(e.cpm, U({}, e));
        } catch (e) {
          N.logError("Error during bid adjustment", "bidmanager.js", e);
        }
        0 <= r && (e.cpm = r);
      }(e);
    });
    var L = 4,
        F = {},
        z = {},
        V = [];
    var H = Object(i.b)("async", function (e, t) {
      this.dispatch.call(this.bidderRequest, e, t);
    }, "addBidResponse"),
        K = Object(i.b)("sync", function (e) {
      this.dispatch.call(this.context, e);
    }, "addBidderRequests"),
        J = Object(i.b)("async", function (e, t) {
      t && t();
    }, "bidsBackCallback");

    function u(e, t) {
      t.timeToRespond > e.getTimeout() + _.b.getConfig("timeoutBuffer") && e.executeCallback(!0);
    }

    function Y(e, t) {
      var n = e.getBidRequests(),
          n = R()(n, function (e) {
        return e.bidderCode === t.bidderCode;
      });
      !function (t, e) {
        {
          var n;
          t.bidderCode && (0 < t.cpm || t.dealId) && (n = R()(e.bids, function (e) {
            return e.adUnitCode === t.adUnitCode;
          }), n = function (e, t, n) {
            if (!t) return {};
            var r = {},
                i = pbjs.bidderSettings;
            {
              var o;
              i && (o = f(t.mediaType, e, n), l(r, o, t), e && i[e] && i[e][q.JSON_MAPPING.ADSERVER_TARGETING] && (l(r, i[e], t), t.sendStandardTargeting = i[e].sendStandardTargeting));
            }
            t.native && (r = U({}, r, Object(a.d)(t, n)));
            return r;
          }(t.bidderCode, t, n));
        }
        t.adserverTargeting = U(t.adserverTargeting || {}, n);
      }(t, n), P.emit(q.EVENTS.BID_RESPONSE, t), e.addBidReceived(t), u(e, t);
    }

    var Q = Object(i.b)("async", function (n, r, i, e) {
      Object(o.b)([r], function (e, t) {
        e ? (N.logWarn("Failed to save to the video cache: ".concat(e, ". Video bid must be discarded.")), u(n, r)) : "" === t[0].uuid ? (N.logWarn("Supplied video cache key was already in use by Prebid Cache; caching attempt was rejected. Video bid must be discarded."), u(n, r)) : (r.videoCacheKey = t[0].uuid, r.vastUrl || (r.vastUrl = Object(o.a)(r.videoCacheKey)), Y(n, r), i());
      }, e);
    }, "callPrebidCache");

    function $(e, t, n) {
      if (e && n) {
        if (e === c.d) {
          t = Object(C.deepAccess)(t, "mediaTypes.".concat(c.d, ".context"), "instream");
          if (n["".concat(c.d, "-").concat(t)]) return n["".concat(c.d, "-").concat(t)];
        }

        return n[e];
      }
    }

    var s = function s(e, t) {
      t = $(e, t, _.b.getConfig("mediaTypePriceGranularity"));
      return "string" == typeof e && t ? "string" == typeof t ? t : "custom" : _.b.getConfig("priceGranularity");
    },
        d = function d(t) {
      return function (e) {
        return t === q.GRANULARITY_OPTIONS.AUTO ? e.pbAg : t === q.GRANULARITY_OPTIONS.DENSE ? e.pbDg : t === q.GRANULARITY_OPTIONS.LOW ? e.pbLg : t === q.GRANULARITY_OPTIONS.MEDIUM ? e.pbMg : t === q.GRANULARITY_OPTIONS.HIGH ? e.pbHg : t === q.GRANULARITY_OPTIONS.CUSTOM ? e.pbCg : void 0;
      };
    };

    function f(e, t, n) {
      function r(e, t) {
        return {
          key: e,
          val: "function" == typeof t ? function (e) {
            return t(e);
          } : function (e) {
            return Object(C.getValue)(e, t);
          }
        };
      }

      var i,
          o,
          a = q.TARGETING_KEYS,
          c = s(e, n),
          n = pbjs.bidderSettings;
      return n[q.JSON_MAPPING.BD_SETTING_STANDARD] || (n[q.JSON_MAPPING.BD_SETTING_STANDARD] = {}), n[q.JSON_MAPPING.BD_SETTING_STANDARD][q.JSON_MAPPING.ADSERVER_TARGETING] || (n[q.JSON_MAPPING.BD_SETTING_STANDARD][q.JSON_MAPPING.ADSERVER_TARGETING] = [r(a.BIDDER, "bidderCode"), r(a.AD_ID, "adId"), r(a.PRICE_BUCKET, d(c)), r(a.SIZE, "size"), r(a.DEAL, "dealId"), r(a.SOURCE, "source"), r(a.FORMAT, "mediaType")]), "video" === e && (i = n[q.JSON_MAPPING.BD_SETTING_STANDARD][q.JSON_MAPPING.ADSERVER_TARGETING], [a.UUID, a.CACHE_ID].forEach(function (t) {
        void 0 === R()(i, function (e) {
          return e.key === t;
        }) && i.push(r(t, "videoCacheKey"));
      }), !_.b.getConfig("cache.url") || t && !1 === N.deepAccess(n, "".concat(t, ".sendStandardTargeting")) || (o = Object(C.parseUrl)(_.b.getConfig("cache.url")), void 0 === R()(i, function (e) {
        return e.key === a.CACHE_HOST;
      }) && i.push(r(a.CACHE_HOST, function (e) {
        return N.deepAccess(e, "adserverTargeting.".concat(a.CACHE_HOST)) ? e.adserverTargeting[a.CACHE_HOST] : o.hostname;
      })))), n[q.JSON_MAPPING.BD_SETTING_STANDARD];
    }

    function l(n, r, i) {
      var e = r[q.JSON_MAPPING.ADSERVER_TARGETING];
      return i.size = i.getSize(), N._each(e, function (e) {
        var t = e.key,
            e = e.val;
        if (n[t] && N.logWarn("The key: " + t + " is getting ovewritten"), N.isFn(e)) try {
          e = e(i);
        } catch (e) {
          N.logError("bidmanager", "ERROR", e);
        }
        (void 0 === r.suppressEmptyKeys || !0 !== r.suppressEmptyKeys) && t !== q.TARGETING_KEYS.DEAL || !N.isEmptyStr(e) && null != e ? n[t] = e : N.logInfo("suppressing empty key '" + t + "' from adserver targeting");
      }), n;
    }

    function X(e, t) {
      return e[t.adUnitCode] || (e[t.adUnitCode] = {
        bids: []
      }), e[t.adUnitCode].bids.push(t), e;
    }
  },
  42: function _(e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return I;
    });
    var l = n(0),
        p = n(3),
        g = n(36),
        r = n(26),
        i = n(90),
        o = n(2),
        t = n(12),
        b = n.n(t);

    function y() {
      return (y = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n,
              r = arguments[t];

          for (n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function v(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function h(e) {
      return function (e) {
        if (Array.isArray(e)) return a(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return a(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Map" === (n = "Object" === n && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function a(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var c = n(0),
        m = n(5),
        S = [],
        A = Object.keys(m.TARGETING_KEYS).map(function (e) {
      return m.TARGETING_KEYS[e];
    }),
        u = function u(e) {
      return e.responseTimestamp + 1e3 * e.ttl + 1e3 > Object(l.timestamp)();
    },
        s = function s(e) {
      return e && (e.status && !b()([m.BID_STATUS.RENDERED], e.status) || !e.status);
    };

    function E(e, r, t) {
      var i = 2 < arguments.length && void 0 !== t ? t : 0,
          o = [],
          a = p.b.getConfig("sendBidsControl.dealPrioritization"),
          c = Object(l.groupBy)(e, "adUnitCode");
      return Object.keys(c).forEach(function (e) {
        var t = [],
            n = Object(l.groupBy)(c[e], "bidderCode");
        Object.keys(n).forEach(function (e) {
          return t.push(n[e].reduce(r));
        }), 0 < i ? (t = a ? t.sort(T(!0)) : t.sort(function (e, t) {
          return t.cpm - e.cpm;
        }), o.push.apply(o, h(t.slice(0, i)))) : o.push.apply(o, h(t));
      }), o;
    }

    function T(e) {
      var n = 0 < arguments.length && void 0 !== e && e;
      return function (e, t) {
        return void 0 !== e.adserverTargeting.hb_deal && void 0 === t.adserverTargeting.hb_deal ? -1 : void 0 === e.adserverTargeting.hb_deal && void 0 !== t.adserverTargeting.hb_deal ? 1 : n ? t.cpm - e.cpm : t.adserverTargeting.hb_pb - e.adserverTargeting.hb_pb;
      };
    }

    var d,
        O,
        f,
        I = (d = r.a, f = {}, (O = {}).setLatestAuctionForAdUnit = function (e, t) {
      f[e] = t;
    }, O.resetPresetTargeting = function (e, t) {
      var n, i;
      Object(l.isGptPubadsDefined)() && (n = j(e), i = d.getAdUnits().filter(function (e) {
        return b()(n, e.code);
      }), window.googletag.pubads().getSlots().forEach(function (n) {
        var r = c.isFn(t) && t(n);
        S.forEach(function (t) {
          i.forEach(function (e) {
            (e.code === n.getAdUnitPath() || e.code === n.getSlotElementId() || c.isFn(r) && r(e.code)) && n.setTargeting(t, null);
          });
        });
      }));
    }, O.resetPresetTargetingAST = function (e) {
      j(e).forEach(function (e) {
        var t,
            n,
            r = window.apntag.getTag(e);
        r && r.keywords && (t = Object.keys(r.keywords), n = {}, t.forEach(function (e) {
          b()(S, e.toLowerCase()) || (n[e] = r.keywords[e]);
        }), window.apntag.modifyTag(e, {
          keywords: n
        }));
      });
    }, O.getAllTargeting = function (e) {
      var n,
          r,
          t,
          i,
          o,
          a = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : w(),
          c = j(e);
      (d = (i = c, e = a, e = O.getWinningBids(i, e), o = _(), (e = e.map(function (i) {
        return v({}, i.adUnitCode, Object.keys(i.adserverTargeting).filter(function (e) {
          return void 0 === i.sendStandardTargeting || i.sendStandardTargeting || -1 === o.indexOf(e);
        }).reduce(function (e, t) {
          var n = [i.adserverTargeting[t]],
              r = v({}, t.substring(0, 20), n);
          if (t !== m.TARGETING_KEYS.DEAL) return [].concat(h(e), [r]);
          n = v({}, "".concat(t, "_").concat(i.bidderCode).substring(0, 20), n);
          return [].concat(h(e), [r, n]);
        }, []));
      })).concat((t = c, a.filter(function (e) {
        return b()(t, e.adUnitCode);
      }).map(function (e) {
        return y({}, e);
      }).reduce(R, []).map(x).filter(function (e) {
        return e;
      }))).concat(p.b.getConfig("enableSendAllBids") ? (n = c, e = a, r = A.concat(g.a), f = p.b.getConfig("sendBidsControl.bidLimit"), E(e, l.getHighestCpm, f).map(function (t) {
        if (C(t, n)) return v({}, t.adUnitCode, U(t, r.filter(function (e) {
          return void 0 !== t.adserverTargeting[e];
        })));
      }).filter(function (e) {
        return e;
      })) : function (e, t) {
        if (!0 !== p.b.getConfig("targetingControls.alwaysIncludeDeals")) return [];
        var n = A.concat(g.a);
        return E(t, l.getHighestCpm).map(function (t) {
          if (t.dealId && C(t, e)) return v({}, t.adUnitCode, U(t, n.filter(function (e) {
            return void 0 !== t.adserverTargeting[e];
          })));
        }).filter(function (e) {
          return e;
        });
      }(c, a)))).map(function (t) {
        Object.keys(t).map(function (e) {
          t[e].map(function (e) {
            -1 === S.indexOf(Object.keys(e)[0]) && (S = Object.keys(e).concat(S));
          });
        });
      });
      var u,
          s,
          d = d.map(function (e) {
        return v({}, Object.keys(e)[0], e[Object.keys(e)[0]].map(function (e) {
          return v({}, Object.keys(e)[0], e[Object.keys(e)[0]].join(", "));
        }).reduce(function (e, t) {
          return y(t, e);
        }, {}));
      }).reduce(function (e, t) {
        var n = Object.keys(t)[0];
        return e[n] = y({}, e[n], t[n]), e;
      }, {}),
          f = p.b.getConfig("targetingControls.auctionKeyMaxChars");
      return f && (Object(l.logInfo)("Detected 'targetingControls.auctionKeyMaxChars' was active for this auction; set with a limit of ".concat(f, " characters.  Running checks on auction keys...")), a = d, u = f, s = Object(l.deepClone)(a), d = Object.keys(s).map(function (e) {
        return {
          adUnitCode: e,
          adserverTargeting: s[e]
        };
      }).sort(T()).reduce(function (e, t, n, r) {
        var i,
            o = (i = t.adserverTargeting, Object.keys(i).reduce(function (e, t) {
          return e + "".concat(t, "%3d").concat(encodeURIComponent(i[t]), "%26");
        }, ""));
        n + 1 === r.length && (o = o.slice(0, -3));
        t = t.adUnitCode, o = o.length;
        return o <= u ? (u -= o, Object(l.logInfo)("AdUnit '".concat(t, "' auction keys comprised of ").concat(o, " characters.  Deducted from running threshold; new limit is ").concat(u), s[t]), e[t] = s[t]) : Object(l.logWarn)("The following keys for adUnitCode '".concat(t, "' exceeded the current limit of the 'auctionKeyMaxChars' setting.\nThe key-set size was ").concat(o, ", the current allotted amount was ").concat(u, ".\n"), s[t]), n + 1 === r.length && 0 === Object.keys(e).length && Object(l.logError)("No auction targeting keys were permitted due to the setting in setConfig(targetingControls.auctionKeyMaxChars).  Please review setup and consider adjusting."), e;
      }, {})), c.forEach(function (e) {
        d[e] || (d[e] = {});
      }), d;
    }, O.setTargetingForGPT = function (i, e) {
      window.googletag.pubads().getSlots().forEach(function (r) {
        Object.keys(i).filter((e || Object(l.isAdUnitCodeMatchingSlot))(r)).forEach(function (n) {
          return Object.keys(i[n]).forEach(function (t) {
            var e = i[n][t];
            (e = 1 < (e = "string" == typeof e ? e.split(",") : e).length ? [e] : e).map(function (e) {
              return c.logMessage("Attempting to set key value for slot: ".concat(r.getSlotElementId(), " key: ").concat(t, " value: ").concat(e)), e;
            }).forEach(function (e) {
              r.setTargeting(t, e);
            });
          });
        });
      });
    }, O.getWinningBids = function (e) {
      var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : w(),
          t = j(e);
      return n.filter(function (e) {
        return b()(t, e.adUnitCode);
      }).filter(function (e) {
        return 0 < e.cpm;
      }).map(function (e) {
        return e.adUnitCode;
      }).filter(l.uniques).map(function (t) {
        return n.filter(function (e) {
          return e.adUnitCode === t ? e : null;
        }).reduce(l.getHighestCpm);
      });
    }, O.setTargetingForAst = function (e) {
      var r = O.getAllTargeting(e);

      try {
        O.resetPresetTargetingAST(e);
      } catch (e) {
        c.logError("unable to reset targeting for AST" + e);
      }

      Object.keys(r).forEach(function (n) {
        return Object.keys(r[n]).forEach(function (e) {
          var t;
          c.logMessage("Attempting to set targeting for targetId: ".concat(n, " key: ").concat(e, " value: ").concat(r[n][e])), (c.isStr(r[n][e]) || c.isArray(r[n][e])) && (t = {}, e.search(/pt[0-9]/) < 0 ? t[e.toUpperCase()] = r[n][e] : t[e] = r[n][e], window.apntag.setKeywords(n, t, {
            overrideKeyValue: !0
          }));
        });
      });
    }, O.isApntagDefined = function () {
      if (window.apntag && c.isFn(window.apntag.setKeywords)) return !0;
    }, O);

    function C(e, t) {
      return e.adserverTargeting && t && (c.isArray(t) && b()(t, e.adUnitCode) || "string" == typeof t && e.adUnitCode === t);
    }

    function j(e) {
      return "string" == typeof e ? [e] : c.isArray(e) ? e : d.getAdUnitCodes() || [];
    }

    function w() {
      var e = d.getBidsReceived();
      return E(e = (e = !p.b.getConfig("useBidCache") ? e.filter(function (e) {
        return f[e.adUnitCode] === e.auctionId;
      }) : e).filter(function (e) {
        return Object(l.deepAccess)(e, "video.context") !== o.a;
      }).filter(function (e) {
        return "banner" !== e.mediaType || Object(i.c)([e.width, e.height]);
      }).filter(s).filter(u), l.getOldestHighestCpmBid);
    }

    function _() {
      return d.getStandardBidderAdServerTargeting().map(function (e) {
        return e.key;
      }).concat(A).filter(l.uniques);
    }

    function R(r, i, e, t) {
      return Object.keys(i.adserverTargeting).filter(B()).forEach(function (e) {
        var t, n;
        r.length && r.filter((n = e, function (e) {
          return e.adUnitCode === i.adUnitCode && e.adserverTargeting[n];
        })).forEach((t = e, function (e) {
          c.isArray(e.adserverTargeting[t]) || (e.adserverTargeting[t] = [e.adserverTargeting[t]]), e.adserverTargeting[t] = e.adserverTargeting[t].concat(i.adserverTargeting[t]).filter(l.uniques), delete i.adserverTargeting[t];
        }));
      }), r.push(i), r;
    }

    function B() {
      var t = _().concat(g.a);

      return function (e) {
        return -1 === t.indexOf(e);
      };
    }

    function x(t) {
      return v({}, t.adUnitCode, Object.keys(t.adserverTargeting).filter(B()).map(function (e) {
        return v({}, e.substring(0, 20), [t.adserverTargeting[e]]);
      }));
    }

    function U(t, e) {
      return e.map(function (e) {
        return v({}, "".concat(e, "_").concat(t.bidderCode).substring(0, 20), [t.adserverTargeting[e]]);
      });
    }
  },
  43: function _(e, t) {
    var n = {}.toString;

    e.exports = function (e) {
      return n.call(e).slice(8, -1);
    };
  },
  44: function _(e, t) {
    e.exports = {};
  },
  45: function _(e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return y;
    });
    var i = n(0),
        r = n(3),
        t = n(12),
        o = n.n(t),
        n = n(8);

    function a(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              r = !0,
              i = !1,
              o = void 0;

          try {
            for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            i = !0, o = e;
          } finally {
            try {
              r || null == c.return || c.return();
            } finally {
              if (i) throw o;
            }
          }

          return n;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return c(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Map" === (n = "Object" === n && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? c(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function c(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    function u() {
      return (u = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n,
              r = arguments[t];

          for (n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    r.b.setDefaults({
      userSync: i.deepClone({
        syncEnabled: !0,
        filterSettings: {
          image: {
            bidders: "*",
            filter: "include"
          }
        },
        syncsPerBidder: 5,
        syncDelay: 3e3,
        auctionDelay: 0
      })
    });
    n = Object(n.a)("usersync");
    var s,
        d,
        f,
        l,
        p,
        g,
        b,
        n = !i.isSafariBrowser() && n.cookiesAreEnabled(),
        y = (s = {
      config: r.b.getConfig("userSync"),
      browserSupportsCookies: n
    }, d = {}, f = v(), l = new Set(), g = {
      image: !0,
      iframe: !(p = {})
    }, b = s.config, r.b.getConfig("userSync", function (e) {
      var t;
      e.userSync && (t = e.userSync.filterSettings, i.isPlainObject(t) && (t.image || t.all || (e.userSync.filterSettings.image = {
        bidders: "*",
        filter: "include"
      }))), b = u(b, e.userSync);
    }), d.registerSync = function (e, t, n) {
      return l.has(t) ? i.logMessage('already fired syncs for "'.concat(t, '", ignoring registerSync call')) : b.syncEnabled && i.isArray(f[e]) ? t ? 0 !== b.syncsPerBidder && Number(p[t]) >= b.syncsPerBidder ? i.logWarn('Number of user syncs exceeded for "'.concat(t, '"')) : d.canBidderRegisterSync(e, t) ? (f[e].push([t, n]), (r = p)[n = t] ? r[n] += 1 : r[n] = 1, void (p = r)) : i.logWarn('Bidder "'.concat(t, '" not permitted to register their "').concat(e, '" userSync pixels.')) : i.logWarn("Bidder is required for registering sync") : i.logWarn('User sync type "'.concat(e, '" not supported'));
      var r;
    }, d.syncUsers = function () {
      var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 0;
      if (e) return setTimeout(h, Number(e));
      h();
    }, d.triggerUserSyncs = function () {
      b.enableOverride && d.syncUsers();
    }, d.canBidderRegisterSync = function (e, t) {
      return !b.filterSettings || !S(e, t);
    }, d);

    function v() {
      return {
        image: [],
        iframe: []
      };
    }

    function h() {
      if (b.syncEnabled && s.browserSupportsCookies) {
        try {
          g.image && m(f.image, function (e) {
            var t = a(e, 2),
                e = t[0],
                t = t[1];
            i.logMessage("Invoking image pixel user sync for bidder: ".concat(e)), i.triggerPixel(t);
          }), g.iframe && m(f.iframe, function (e) {
            var t = a(e, 2),
                e = t[0],
                t = t[1];
            i.logMessage("Invoking iframe user sync for bidder: ".concat(e)), i.insertUserSyncIframe(t);
          });
        } catch (e) {
          return i.logError("Error firing user syncs", e);
        }

        f = v();
      }
    }

    function m(e, t) {
      i.shuffle(e).forEach(function (e) {
        t(e), l.add(e[0]);
      });
    }

    function S(e, t) {
      var n = b.filterSettings;

      if (function (e, t) {
        if (e.all && e[t]) return i.logWarn('Detected presence of the "filterSettings.all" and "filterSettings.'.concat(t, '" in userSync config.  You cannot mix "all" with "iframe/image" configs; they are mutually exclusive.')), !1;
        var n = e.all || e[t],
            e = e.all ? "all" : t;
        if (!n) return !1;
        t = n.filter, n = n.bidders;
        if (t && "include" !== t && "exclude" !== t) return i.logWarn('UserSync "filterSettings.'.concat(e, ".filter\" setting '").concat(t, "' is not a valid option; use either 'include' or 'exclude'.")), !1;
        return !!("*" === n || Array.isArray(n) && 0 < n.length && n.every(function (e) {
          return i.isStr(e) && "*" !== e;
        })) || (i.logWarn('Detected an invalid setup in userSync "filterSettings.'.concat(e, ".bidders\"; use either '*' (to represent all bidders) or an array of bidders.")), !1);
      }(n, e)) {
        g[e] = !0;
        n = n.all || n[e], e = "*" === n.bidders ? [t] : n.bidders;
        return {
          include: function include(e, t) {
            return !o()(e, t);
          },
          exclude: function exclude(e, t) {
            return o()(e, t);
          }
        }[n.filter || "include"](e, t);
      }
    }
  },
  46: function _(e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return s;
    }), n.d(t, "b", function () {
      return p;
    });
    var t = n(10),
        d = n.n(t),
        r = n(0),
        f = 2,
        i = {
      buckets: [{
        max: 5,
        increment: .5
      }]
    },
        o = {
      buckets: [{
        max: 20,
        increment: .1
      }]
    },
        a = {
      buckets: [{
        max: 20,
        increment: .01
      }]
    },
        c = {
      buckets: [{
        max: 3,
        increment: .01
      }, {
        max: 8,
        increment: .05
      }, {
        max: 20,
        increment: .5
      }]
    },
        u = {
      buckets: [{
        max: 5,
        increment: .05
      }, {
        max: 10,
        increment: .1
      }, {
        max: 20,
        increment: .5
      }]
    };

    function s(e, t) {
      var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 1,
          r = parseFloat(e);
      return {
        low: "" === (r = isNaN(r) ? "" : r) ? "" : l(e, i, n),
        med: "" === r ? "" : l(e, o, n),
        high: "" === r ? "" : l(e, a, n),
        auto: "" === r ? "" : l(e, u, n),
        dense: "" === r ? "" : l(e, c, n),
        custom: "" === r ? "" : l(e, t, n)
      };
    }

    function l(n, e, r) {
      var i = "";
      if (!p(e)) return i;
      var t,
          o,
          a,
          c = e.buckets.reduce(function (e, t) {
        return e.max > t.max ? e : t;
      }, {
        max: 0
      }),
          u = 0,
          s = d()(e.buckets, function (e) {
        if (n > c.max * r) {
          var t = e.precision;
          i = (e.max * r).toFixed(t = void 0 === t ? f : t);
        } else {
          if (n <= e.max * r && u * r <= n) return e.min = u, e;
          u = e.max;
        }
      });
      return s && (t = n, a = r, e = void 0 !== (o = s).precision ? o.precision : f, s = o.increment * a, o = o.min * a, a = Math.pow(10, e + 2), a = (t * a - o * a) / (s * a), o = Math.floor(a) * s + o, i = (o = Number(o.toFixed(10))).toFixed(e)), i;
    }

    function p(e) {
      if (r.isEmpty(e) || !e.buckets || !Array.isArray(e.buckets)) return !1;
      var t = !0;
      return e.buckets.forEach(function (e) {
        e.max && e.increment || (t = !1);
      }), t;
    }
  },
  47: function _(e, t) {
    e.exports = function (e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t
      };
    };
  },
  477: function _(e, t, n) {
    n = n(478);
    e.exports = n;
  },
  478: function _(e, t, n) {
    n(479);
    n = n(44);
    e.exports = n.Number.isInteger;
  },
  479: function _(e, t, n) {
    n(14)({
      target: "Number",
      stat: !0
    }, {
      isInteger: n(480)
    });
  },
  48: function _(e, t, n) {
    var r = n(70),
        i = n(49);

    e.exports = function (e) {
      return r(i(e));
    };
  },
  480: function _(e, t, n) {
    var r = n(24),
        i = Math.floor;

    e.exports = function (e) {
      return !r(e) && isFinite(e) && i(e) === e;
    };
  },
  49: function _(e, t) {
    e.exports = function (e) {
      if (null == e) throw TypeError("Can't call method on " + e);
      return e;
    };
  },
  5: function _(e, t) {
    e.exports = {
      JSON_MAPPING: {
        PL_CODE: "code",
        PL_SIZE: "sizes",
        PL_BIDS: "bids",
        BD_BIDDER: "bidder",
        BD_ID: "paramsd",
        BD_PL_ID: "placementId",
        ADSERVER_TARGETING: "adserverTargeting",
        BD_SETTING_STANDARD: "standard"
      },
      DEBUG_MODE: "pbjs_debug",
      STATUS: {
        GOOD: 1,
        NO_BID: 2
      },
      CB: {
        TYPE: {
          ALL_BIDS_BACK: "allRequestedBidsBack",
          AD_UNIT_BIDS_BACK: "adUnitBidsBack",
          BID_WON: "bidWon",
          REQUEST_BIDS: "requestBids"
        }
      },
      EVENTS: {
        AUCTION_INIT: "auctionInit",
        AUCTION_END: "auctionEnd",
        BID_ADJUSTMENT: "bidAdjustment",
        BID_TIMEOUT: "bidTimeout",
        BID_REQUESTED: "bidRequested",
        BID_RESPONSE: "bidResponse",
        NO_BID: "noBid",
        BID_WON: "bidWon",
        BIDDER_DONE: "bidderDone",
        SET_TARGETING: "setTargeting",
        BEFORE_REQUEST_BIDS: "beforeRequestBids",
        REQUEST_BIDS: "requestBids",
        ADD_AD_UNITS: "addAdUnits",
        AD_RENDER_FAILED: "adRenderFailed",
        TCF2_ENFORCEMENT: "tcf2Enforcement"
      },
      AD_RENDER_FAILED_REASON: {
        PREVENT_WRITING_ON_MAIN_DOCUMENT: "preventWritingOnMainDocuemnt",
        NO_AD: "noAd",
        EXCEPTION: "exception",
        CANNOT_FIND_AD: "cannotFindAd",
        MISSING_DOC_OR_ADID: "missingDocOrAdid"
      },
      EVENT_ID_PATHS: {
        bidWon: "adUnitCode"
      },
      GRANULARITY_OPTIONS: {
        LOW: "low",
        MEDIUM: "medium",
        HIGH: "high",
        AUTO: "auto",
        DENSE: "dense",
        CUSTOM: "custom"
      },
      TARGETING_KEYS: {
        BIDDER: "hb_bidder",
        AD_ID: "hb_adid",
        PRICE_BUCKET: "hb_pb",
        SIZE: "hb_size",
        DEAL: "hb_deal",
        SOURCE: "hb_source",
        FORMAT: "hb_format",
        UUID: "hb_uuid",
        CACHE_ID: "hb_cache_id",
        CACHE_HOST: "hb_cache_host"
      },
      NATIVE_KEYS: {
        title: "hb_native_title",
        body: "hb_native_body",
        body2: "hb_native_body2",
        privacyLink: "hb_native_privacy",
        privacyIcon: "hb_native_privicon",
        sponsoredBy: "hb_native_brand",
        image: "hb_native_image",
        icon: "hb_native_icon",
        clickUrl: "hb_native_linkurl",
        displayUrl: "hb_native_displayurl",
        cta: "hb_native_cta",
        rating: "hb_native_rating",
        address: "hb_native_address",
        downloads: "hb_native_downloads",
        likes: "hb_native_likes",
        phone: "hb_native_phone",
        price: "hb_native_price",
        salePrice: "hb_native_saleprice"
      },
      S2S: {
        SRC: "s2s",
        DEFAULT_ENDPOINT: "https://prebid.adnxs.com/pbs/v1/openrtb2/auction",
        SYNCED_BIDDERS_KEY: "pbjsSyncs"
      },
      BID_STATUS: {
        BID_TARGETING_SET: "targetingSet",
        RENDERED: "rendered",
        BID_REJECTED: "bidRejected"
      }
    };
  },
  50: function _(e, t, n) {
    var r = n(58),
        i = Math.min;

    e.exports = function (e) {
      return 0 < e ? i(r(e), 9007199254740991) : 0;
    };
  },
  51: function _(e, t) {
    e.exports = function () {};
  },
  52: function _(e, t, n) {
    n = n(23);
    e.exports = n;
  },
  53: function _(e, t) {
    e.exports = {};
  },
  54: function _(e, t, n) {
    var r,
        i,
        o,
        a,
        c,
        u,
        s,
        d,
        f = n(115),
        l = n(21),
        p = n(24),
        g = n(29),
        b = n(28),
        y = n(59),
        v = n(65),
        n = n(53),
        l = l.WeakMap;
    s = f ? (r = y.state || (y.state = new l()), i = r.get, o = r.has, a = r.set, c = function c(e, t) {
      return t.facade = e, a.call(r, e, t), t;
    }, u = function u(e) {
      return i.call(r, e) || {};
    }, function (e) {
      return o.call(r, e);
    }) : (n[d = v("state")] = !0, c = function c(e, t) {
      return t.facade = e, g(e, d, t), t;
    }, u = function u(e) {
      return b(e, d) ? e[d] : {};
    }, function (e) {
      return b(e, d);
    }), e.exports = {
      set: c,
      get: u,
      has: s,
      enforce: function enforce(e) {
        return s(e) ? u(e) : c(e, {});
      },
      getterFor: function getterFor(n) {
        return function (e) {
          var t;
          if (!p(e) || (t = u(e)).type !== n) throw TypeError("Incompatible receiver, " + n + " required");
          return t;
        };
      }
    };
  },
  55: function _(e, t, n) {
    var i = n(24);

    e.exports = function (e, t) {
      if (!i(e)) return e;
      var n, r;
      if (t && "function" == typeof (n = e.toString) && !i(r = n.call(e))) return r;
      if ("function" == typeof (n = e.valueOf) && !i(r = n.call(e))) return r;
      if (!t && "function" == typeof (n = e.toString) && !i(r = n.call(e))) return r;
      throw TypeError("Can't convert object to primitive value");
    };
  },
  56: function _(e, t, n) {
    var S = n(22),
        A = n(70),
        E = n(57),
        T = n(50),
        O = n(100),
        I = [].push,
        n = function n(l) {
      var p = 1 == l,
          g = 2 == l,
          b = 3 == l,
          y = 4 == l,
          v = 6 == l,
          h = 7 == l,
          m = 5 == l || v;
      return function (e, t, n, r) {
        for (var i, o, a = E(e), c = A(a), u = S(t, n, 3), s = T(c.length), d = 0, r = r || O, f = p ? r(e, s) : g || h ? r(e, 0) : void 0; d < s; d++) {
          if ((m || d in c) && (o = u(i = c[d], d, a), l)) if (p) f[d] = o;else if (o) switch (l) {
            case 3:
              return !0;

            case 5:
              return i;

            case 6:
              return d;

            case 2:
              I.call(f, i);
          } else switch (l) {
            case 4:
              return !1;

            case 7:
              I.call(f, i);
          }
        }

        return v ? -1 : b || y ? y : f;
      };
    };

    e.exports = {
      forEach: n(0),
      map: n(1),
      filter: n(2),
      some: n(3),
      every: n(4),
      find: n(5),
      findIndex: n(6),
      filterOut: n(7)
    };
  },
  57: function _(e, t, n) {
    var r = n(49);

    e.exports = function (e) {
      return Object(r(e));
    };
  },
  58: function _(e, t) {
    var n = Math.ceil,
        r = Math.floor;

    e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (0 < e ? r : n)(e);
    };
  },
  59: function _(e, t, n) {
    var r = n(21),
        i = n(102),
        n = "__core-js_shared__",
        n = r[n] || i(n, {});
    e.exports = n;
  },
  60: function _(e, t) {
    var n = 0,
        r = Math.random();

    e.exports = function (e) {
      return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++n + r).toString(36);
    };
  },
  61: function _(e, t, n) {
    var r = n(62),
        i = n(38),
        o = n(19)("iterator");

    e.exports = function (e) {
      if (null != e) return e[o] || e["@@iterator"] || i[r(e)];
    };
  },
  62: function _(e, t, n) {
    var r = n(63),
        i = n(43),
        o = n(19)("toStringTag"),
        a = "Arguments" == i(function () {
      return arguments;
    }());
    e.exports = r ? i : function (e) {
      var t;
      return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (e = function (e, t) {
        try {
          return e[t];
        } catch (e) {}
      }(t = Object(e), o)) ? e : a ? i(t) : "Object" == (e = i(t)) && "function" == typeof t.callee ? "Arguments" : e;
    };
  },
  63: function _(e, t, n) {
    var r = {};
    r[n(19)("toStringTag")] = "z", e.exports = "[object z]" === String(r);
  },
  64: function _(e, t, n) {
    var i = n(63),
        o = n(31).f,
        a = n(29),
        c = n(28),
        u = n(114),
        s = n(19)("toStringTag");

    e.exports = function (e, t, n, r) {
      e && (e = n ? e : e.prototype, c(e, s) || o(e, s, {
        configurable: !0,
        value: t
      }), r && !i && a(e, "toString", u));
    };
  },
  65: function _(e, t, n) {
    var r = n(73),
        i = n(60),
        o = r("keys");

    e.exports = function (e) {
      return o[e] || (o[e] = i(e));
    };
  },
  66: function _(e, t, n) {
    "use strict";

    function b() {
      return this;
    }

    var y = n(14),
        v = n(123),
        h = n(85),
        m = n(125),
        S = n(64),
        A = n(29),
        E = n(83),
        r = n(19),
        T = n(16),
        O = n(38),
        n = n(84),
        I = n.IteratorPrototype,
        C = n.BUGGY_SAFARI_ITERATORS,
        j = r("iterator"),
        w = "values",
        _ = "entries";

    e.exports = function (e, t, n, r, i, o, a) {
      v(n, t, r);

      function c(e) {
        if (e === i && g) return g;
        if (!C && e in l) return l[e];

        switch (e) {
          case "keys":
          case w:
          case _:
            return function () {
              return new n(this, e);
            };
        }

        return function () {
          return new n(this);
        };
      }

      var u,
          s,
          d = t + " Iterator",
          f = !1,
          l = e.prototype,
          p = l[j] || l["@@iterator"] || i && l[i],
          g = !C && p || c(i),
          r = "Array" == t && l.entries || p;
      if (r && (e = h(r.call(new e())), I !== Object.prototype && e.next && (T || h(e) === I || (m ? m(e, I) : "function" != typeof e[j] && A(e, j, b)), S(e, d, !0, !0), T && (O[d] = b))), i == w && p && p.name !== w && (f = !0, g = function g() {
        return p.call(this);
      }), T && !a || l[j] === g || A(l, j, g), O[t] = g, i) if (u = {
        values: c(w),
        keys: o ? g : c("keys"),
        entries: c(_)
      }, a) for (s in u) {
        !C && !f && s in l || E(l, s, u[s]);
      } else y({
        target: t,
        proto: !0,
        forced: C || f
      }, u);
      return u;
    };
  },
  67: function _(e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return a;
    });
    var r = n(0),
        i = {};

    function o(e, t, n) {
      n = n, e = i[e = e] = i[e] || {
        bidders: {}
      }, e = n ? e.bidders[n] = e.bidders[n] || {} : e;
      return e[t] = (e[t] || 0) + 1, e[t];
    }

    var a = {
      incrementRequestsCounter: function incrementRequestsCounter(e) {
        return o(e, "requestsCounter");
      },
      incrementBidderRequestsCounter: function incrementBidderRequestsCounter(e, t) {
        return o(e, "requestsCounter", t);
      },
      incrementBidderWinsCounter: function incrementBidderWinsCounter(e, t) {
        return o(e, "winsCounter", t);
      },
      getRequestsCounter: function getRequestsCounter(e) {
        return Object(r.deepAccess)(i, "".concat(e, ".requestsCounter")) || 0;
      },
      getBidderRequestsCounter: function getBidderRequestsCounter(e, t) {
        return Object(r.deepAccess)(i, "".concat(e, ".bidders.").concat(t, ".requestsCounter")) || 0;
      },
      getBidderWinsCounter: function getBidderWinsCounter(e, t) {
        return Object(r.deepAccess)(i, "".concat(e, ".bidders.").concat(t, ".winsCounter")) || 0;
      }
    };
  },
  68: function _(e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n.d(t, "adUnitSetupChecks", function () {
      return W;
    }), n.d(t, "checkAdUnitSetup", function () {
      return L;
    }), t.executeCallbacks = V;
    var r = n(20),
        i = n(0),
        o = n(226),
        a = n(45),
        c = n(3),
        y = n(26),
        u = n(42),
        s = n(13),
        d = n(227),
        f = n(12),
        l = n.n(f),
        p = n(67),
        v = n(11),
        g = n(32),
        b = n(8);

    function h(e) {
      return (h = "function" == typeof Symbol && "symbol" == (0, _typeof2.default)(Symbol.iterator) ? function (e) {
        return (0, _typeof2.default)(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : (0, _typeof2.default)(e);
      })(e);
    }

    function m() {
      return (m = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n,
              r = arguments[t];

          for (n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var S = Object(r.a)(),
        A = n(5),
        E = n(0),
        T = n(7).default,
        O = n(9),
        n = a.a.triggerUserSyncs,
        a = A.EVENTS,
        I = a.ADD_AD_UNITS,
        C = a.BID_WON,
        j = a.REQUEST_BIDS,
        w = a.SET_TARGETING,
        _ = a.AD_RENDER_FAILED,
        a = A.AD_RENDER_FAILED_REASON,
        R = a.PREVENT_WRITING_ON_MAIN_DOCUMENT,
        B = a.NO_AD,
        x = a.EXCEPTION,
        U = a.CANNOT_FIND_AD,
        D = a.MISSING_DOC_OR_ADID,
        N = {
      bidWon: function bidWon(e) {
        var t = y.a.getBidsRequested().map(function (e) {
          return e.bids.map(function (e) {
            return e.adUnitCode;
          });
        }).reduce(i.flatten).filter(i.uniques);
        if (E.contains(t, e)) return !0;
        E.logError('The "' + e + '" placement is not defined.');
      }
    };

    function k(e, t, n) {
      e.defaultView && e.defaultView.frameElement && (e.defaultView.frameElement.width = t, e.defaultView.frameElement.height = n);
    }

    function P(e, t) {
      var n = [];
      return E.isArray(e) && (t ? e.length === t : 0 < e.length) && (e.every(function (e) {
        return Object(i.isArrayOfNums)(e, 2);
      }) ? n = e : Object(i.isArrayOfNums)(e, 2) && n.push(e)), n;
    }

    function q(e) {
      var t = E.deepClone(e),
          n = t.mediaTypes.banner,
          e = P(n.sizes);
      return 0 < e.length ? (n.sizes = e, t.sizes = e) : (E.logError("Detected a mediaTypes.banner object without a proper sizes field.  Please ensure the sizes are listed like: [[300, 250], ...].  Removing invalid mediaTypes.banner object from request."), delete t.mediaTypes.banner), t;
    }

    function M(e) {
      var t,
          n = E.deepClone(e),
          r = n.mediaTypes.video;
      return r.playerSize && (t = "number" == typeof r.playerSize[0] ? 2 : 1, 0 < (e = P(r.playerSize, t)).length ? (2 == t && E.logInfo("Transforming video.playerSize from [640,480] to [[640,480]] so it's in the proper format."), r.playerSize = e, n.sizes = e) : (E.logError("Detected incorrect configuration of mediaTypes.video.playerSize.  Please specify only one set of dimensions in a format like: [[640, 480]]. Removing invalid mediaTypes.video.playerSize property from request."), delete n.mediaTypes.video.playerSize)), n;
    }

    function G(e) {
      var t = E.deepClone(e),
          e = t.mediaTypes.native;
      return e.image && e.image.sizes && !Array.isArray(e.image.sizes) && (E.logError("Please use an array of sizes for native.image.sizes field.  Removing invalid mediaTypes.native.image.sizes property from request."), delete t.mediaTypes.native.image.sizes), e.image && e.image.aspect_ratios && !Array.isArray(e.image.aspect_ratios) && (E.logError("Please use an array of sizes for native.image.aspect_ratios field.  Removing invalid mediaTypes.native.image.aspect_ratios property from request."), delete t.mediaTypes.native.image.aspect_ratios), e.icon && e.icon.sizes && !Array.isArray(e.icon.sizes) && (E.logError("Please use an array of sizes for native.icon.sizes field.  Removing invalid mediaTypes.native.icon.sizes property from request."), delete t.mediaTypes.native.icon.sizes), t;
    }

    Object(d.a)(), S.bidderSettings = S.bidderSettings || {}, S.libLoaded = !0, S.version = "v4.4.0", E.logInfo("Prebid.js v4.4.0 loaded"), S.adUnits = S.adUnits || [], S.triggerUserSyncs = n;
    var W = {
      validateBannerMediaType: q,
      validateVideoMediaType: M,
      validateNativeMediaType: G,
      validateSizes: P
    },
        L = Object(s.b)("sync", function (e) {
      var o = [];
      return e.forEach(function (e) {
        var t,
            n,
            r,
            i = e.mediaTypes;
        i && 0 !== Object.keys(i).length ? (r = m({}, t = i.banner ? q(e) : t, n = i.video ? M(t || e) : n, r = i.native ? G(n || t || e) : r), o.push(r)) : E.logError("Detected adUnit.code '".concat(e.code, "' did not have a 'mediaTypes' object defined.  This is a required field for the auction, so this adUnit has been removed."));
      }), o;
    }, "checkAdUnitSetup");

    function F(e) {
      var n = y.a[e]().filter(E.bind.call(i.adUnitsFilter, this, y.a.getAdUnitCodes())),
          r = y.a.getLastAuctionId();
      return n.map(function (e) {
        return e.adUnitCode;
      }).filter(i.uniques).map(function (t) {
        return n.filter(function (e) {
          return e.auctionId === r && e.adUnitCode === t;
        });
      }).filter(function (e) {
        return e && e[0] && e[0].adUnitCode;
      }).map(function (e) {
        return t = {}, n = e[0].adUnitCode, e = {
          bids: e
        }, n in t ? Object.defineProperty(t, n, {
          value: e,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[n] = e, t;
        var t, n;
      }).reduce(function (e, t) {
        return m(e, t);
      }, {});
    }

    function z(e) {
      var t = e.reason,
          n = e.message,
          r = e.bid,
          e = e.id,
          t = {
        reason: t,
        message: n
      };
      r && (t.bid = r), e && (t.adId = e), E.logError(n), O.emit(_, t);
    }

    function V(e, t) {
      function n(e) {
        for (var t; t = e.shift();) {
          t();
        }
      }

      n(b.c), n(H), e.call(this, t);
    }

    S.getAdserverTargetingForAdUnitCodeStr = function (e) {
      if (E.logInfo("Invoking pbjs.getAdserverTargetingForAdUnitCodeStr", arguments), e) {
        e = S.getAdserverTargetingForAdUnitCode(e);
        return E.transformAdServerTargetingObj(e);
      }

      E.logMessage("Need to call getAdserverTargetingForAdUnitCodeStr with adunitCode");
    }, S.getAdserverTargetingForAdUnitCode = function (e) {
      return S.getAdserverTargeting(e)[e];
    }, S.getAdserverTargeting = function (e) {
      return E.logInfo("Invoking pbjs.getAdserverTargeting", arguments), u.a.getAllTargeting(e);
    }, S.getNoBids = function () {
      return E.logInfo("Invoking pbjs.getNoBids", arguments), F("getNoBids");
    }, S.getBidResponses = function () {
      return E.logInfo("Invoking pbjs.getBidResponses", arguments), F("getBidsReceived");
    }, S.getBidResponsesForAdUnitCode = function (t) {
      return {
        bids: y.a.getBidsReceived().filter(function (e) {
          return e.adUnitCode === t;
        })
      };
    }, S.setTargetingForGPTAsync = function (e, t) {
      var n;
      E.logInfo("Invoking pbjs.setTargetingForGPTAsync", arguments), Object(i.isGptPubadsDefined)() ? (n = u.a.getAllTargeting(e), u.a.resetPresetTargeting(e, t), u.a.setTargetingForGPT(n, t), Object.keys(n).forEach(function (t) {
        Object.keys(n[t]).forEach(function (e) {
          "hb_adid" === e && y.a.setStatusForBids(n[t][e], A.BID_STATUS.BID_TARGETING_SET);
        });
      }), O.emit(w, n)) : E.logError("window.googletag is not defined on the page");
    }, S.setTargetingForAst = function (e) {
      E.logInfo("Invoking pbjs.setTargetingForAn", arguments), u.a.isApntagDefined() ? (u.a.setTargetingForAst(e), O.emit(w, u.a.getAllTargeting())) : E.logError("window.apntag is not defined on the page");
    }, S.renderAd = function (e, t) {
      if (E.logInfo("Invoking pbjs.renderAd", arguments), E.logMessage("Calling renderAd with adId :" + t), e && t) try {
        var n,
            r,
            i,
            o,
            a,
            c,
            u,
            s,
            d,
            f,
            l,
            p,
            g = y.a.findBidByAdId(t);
        g ? (g.ad = E.replaceAuctionPrice(g.ad, g.cpm), g.adUrl = E.replaceAuctionPrice(g.adUrl, g.cpm), y.a.addWinningBid(g), O.emit(C, g), n = g.height, r = g.width, i = g.ad, o = g.mediaType, a = g.adUrl, c = g.renderer, u = document.createComment("Creative ".concat(g.creativeId, " served by ").concat(g.bidder, " Prebid.js Header Bidding")), E.insertElement(u, e, "body"), Object(v.c)(c) ? Object(v.b)(c, g) : e === document && !E.inIframe() || "video" === o ? (s = "Error trying to write ad. Ad render call ad id ".concat(t, " was prevented from writing to the main document."), z({
          reason: R,
          message: s,
          bid: g,
          id: t
        })) : i ? (navigator.userAgent && -1 < navigator.userAgent.toLowerCase().indexOf("firefox/") && (d = navigator.userAgent.toLowerCase().match(/firefox\/([\d\.]+)/)[1]) && parseInt(d, 10) < 67 && e.open("text/html", "replace"), e.write(i), e.close(), k(e, r, n), E.callBurl(g)) : a ? ((f = E.createInvisibleIframe()).height = n, f.width = r, f.style.display = "inline", f.style.overflow = "hidden", f.src = a, E.insertElement(f, e, "body"), k(e, r, n), E.callBurl(g)) : (l = "Error trying to write ad. No ad for bid response id: ".concat(t), z({
          reason: B,
          message: l,
          bid: g,
          id: t
        }))) : (p = "Error trying to write ad. Cannot find ad by given id : ".concat(t), z({
          reason: U,
          message: p,
          id: t
        }));
      } catch (e) {
        var b = "Error trying to write ad Id :".concat(t, " to the page:").concat(e.message);
        z({
          reason: x,
          message: b,
          id: t
        });
      } else {
        b = "Error trying to write ad Id :".concat(t, " to the page. Missing document or adId");
        z({
          reason: D,
          message: b,
          id: t
        });
      }
    }, S.removeAdUnit = function (e) {
      E.logInfo("Invoking pbjs.removeAdUnit", arguments), e ? (E.isArray(e) ? e : [e]).forEach(function (e) {
        for (var t = S.adUnits.length - 1; 0 <= t; t--) {
          S.adUnits[t].code === e && S.adUnits.splice(t, 1);
        }
      }) : S.adUnits = [];
    }, S.requestBids = Object(s.b)("async", function () {
      var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.bidsBackHandler,
          n = e.timeout,
          r = e.adUnits,
          i = e.adUnitCodes,
          o = e.labels,
          e = e.auctionId;
      O.emit(j);
      n = n || c.b.getConfig("bidderTimeout"), r = r || S.adUnits;

      if (E.logInfo("Invoking pbjs.requestBids", arguments), r = L(r), i && i.length ? r = r.filter(function (e) {
        return l()(i, e.code);
      }) : i = r && r.map(function (e) {
        return e.code;
      }), r.forEach(function (r) {
        var i = Object.keys(r.mediaTypes || {
          banner: "banner"
        }),
            e = r.bids.map(function (e) {
          return e.bidder;
        }),
            o = T.bidderRegistry,
            t = c.b.getConfig("s2sConfig"),
            n = t && t.bidders,
            e = n ? e.filter(function (e) {
          return !l()(n, e);
        }) : e;
        r.transactionId = E.generateUUID(), e.forEach(function (t) {
          var e = o[t],
              e = e && e.getSpec && e.getSpec(),
              n = e && e.supportedMediaTypes || ["banner"];
          i.some(function (e) {
            return l()(n, e);
          }) ? p.a.incrementBidderRequestsCounter(r.code, t) : (E.logWarn(E.unsupportedBidderMessage(r, t)), r.bids = r.bids.filter(function (e) {
            return e.bidder !== t;
          }));
        }), p.a.incrementRequestsCounter(r.code);
      }), r && 0 !== r.length) {
        var a = y.a.createAuction({
          adUnits: r,
          adUnitCodes: i,
          callback: t,
          cbTimeout: n,
          labels: o,
          auctionId: e
        }),
            e = r.length;
        15 < e && E.logInfo("Current auction ".concat(a.getAuctionId(), " contains ").concat(e, " adUnits."), r), i.forEach(function (e) {
          return u.a.setLatestAuctionForAdUnit(e, a.getAuctionId());
        }), a.callBids();
      } else if (E.logMessage("No adUnits configured. No bids requested."), "function" == typeof t) try {
        t();
      } catch (e) {
        E.logError("Error executing bidsBackHandler", null, e);
      }
    }), S.requestBids.before(V, 49), S.addAdUnits = function (e) {
      E.logInfo("Invoking pbjs.addAdUnits", arguments), E.isArray(e) ? S.adUnits.push.apply(S.adUnits, e) : "object" === h(e) && S.adUnits.push(e), O.emit(I);
    }, S.onEvent = function (e, t, n) {
      E.logInfo("Invoking pbjs.onEvent", arguments), E.isFn(t) ? !n || N[e].call(null, n) ? O.on(e, t, n) : E.logError('The id provided is not valid for event "' + e + '" and no handler was set.') : E.logError('The event handler provided is not a function and was not set on event "' + e + '".');
    }, S.offEvent = function (e, t, n) {
      E.logInfo("Invoking pbjs.offEvent", arguments), n && !N[e].call(null, n) || O.off(e, t, n);
    }, S.registerBidAdapter = function (e, t) {
      E.logInfo("Invoking pbjs.registerBidAdapter", arguments);

      try {
        T.registerBidAdapter(e(), t);
      } catch (e) {
        E.logError("Error registering bidder adapter : " + e.message);
      }
    }, S.registerAnalyticsAdapter = function (e) {
      E.logInfo("Invoking pbjs.registerAnalyticsAdapter", arguments);

      try {
        T.registerAnalyticsAdapter(e);
      } catch (e) {
        E.logError("Error registering analytics adapter : " + e.message);
      }
    }, S.createBid = function (e) {
      return E.logInfo("Invoking pbjs.createBid", arguments), Object(g.a)(e);
    };
    var H = [],
        K = Object(s.b)("async", function (e) {
      e && !E.isEmpty(e) ? (E.logInfo("Invoking pbjs.enableAnalytics for: ", e), T.enableAnalytics(e)) : E.logError("pbjs.enableAnalytics should be called with option {}");
    }, "enableAnalyticsCb");

    function J(e) {
      e.forEach(function (e) {
        if (void 0 === e.called) try {
          e.call(), e.called = !0;
        } catch (e) {
          E.logError("Error processing command :", "prebid.js", e);
        }
      });
    }

    S.enableAnalytics = function (e) {
      H.push(K.bind(this, e));
    }, S.aliasBidder = function (e, t, n) {
      E.logInfo("Invoking pbjs.aliasBidder", arguments), e && t ? T.aliasBidAdapter(e, t, n) : E.logError("bidderCode and alias must be passed as arguments", "pbjs.aliasBidder");
    }, S.getAllWinningBids = function () {
      return y.a.getAllWinningBids();
    }, S.getAllPrebidWinningBids = function () {
      return y.a.getBidsReceived().filter(function (e) {
        return e.status === A.BID_STATUS.BID_TARGETING_SET;
      });
    }, S.getHighestCpmBids = function (e) {
      return u.a.getWinningBids(e);
    }, S.markWinningBidAsUsed = function (t) {
      var e = [];
      t.adUnitCode && t.adId ? e = y.a.getBidsReceived().filter(function (e) {
        return e.adId === t.adId && e.adUnitCode === t.adUnitCode;
      }) : t.adUnitCode ? e = u.a.getWinningBids(t.adUnitCode) : t.adId ? e = y.a.getBidsReceived().filter(function (e) {
        return e.adId === t.adId;
      }) : E.logWarn("Inproper usage of markWinningBidAsUsed. It'll need an adUnitCode and/or adId to function."), 0 < e.length && (e[0].status = A.BID_STATUS.RENDERED);
    }, S.getConfig = c.b.getConfig, S.setConfig = c.b.setConfig, S.setBidderConfig = c.b.setBidderConfig, S.que.push(function () {
      return Object(o.a)();
    }), S.cmd.push = function (e) {
      if ("function" == typeof e) try {
        e.call();
      } catch (e) {
        E.logError("Error processing command :", e.message, e.stack);
      } else E.logError("Commands written into pbjs.cmd.push must be wrapped in a function");
    }, S.que.push = S.cmd.push, S.processQueue = function () {
      s.b.ready(), J(S.que), J(S.cmd);
    }, t.default = S;
  },
  69: function _(e, t, n) {
    "use strict";

    t.a = function (t, n) {
      i.adServers = i.adServers || {}, i.adServers[t] = i.adServers[t] || {}, Object.keys(n).forEach(function (e) {
        i.adServers[t][e] ? Object(r.logWarn)("Attempting to add an already registered function property ".concat(e, " for AdServer ").concat(t, ".")) : i.adServers[t][e] = n[e];
      });
    };

    var t = n(20),
        r = n(0),
        i = Object(t.a)();
  },
  7: function _(e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n.d(t, "gdprDataHandler", function () {
      return x;
    }), n.d(t, "uspDataHandler", function () {
      return U;
    }), t.setS2STestingModule = function (e) {
      T = e;
    };
    var y = n(0),
        f = n(90),
        l = n(36),
        p = n(1),
        b = n(4),
        v = n(3),
        r = n(13),
        i = n(12),
        h = n.n(i),
        i = n(10),
        m = n.n(i),
        g = n(67),
        S = n(25);

    function A(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              r = !0,
              i = !1,
              o = void 0;

          try {
            for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            i = !0, o = e;
          } finally {
            try {
              r || null == c.return || c.return();
            } finally {
              if (i) throw o;
            }
          }

          return n;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return o(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Map" === (n = "Object" === n && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? o(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function o(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    function E() {
      return (E = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n,
              r = arguments[t];

          for (n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var T,
        O = n(0),
        I = n(5),
        C = n(9),
        j = {},
        w = j.bidderRegistry = {},
        _ = j.aliasRegistry = {},
        R = {};

    v.b.getConfig("s2sConfig", function (e) {
      R = e.s2sConfig;
    });
    var a = {};
    var B = Object(r.b)("sync", function (e) {
      var r = e.bidderCode,
          c = e.auctionId,
          u = e.bidderRequestId,
          t = e.adUnits,
          s = e.labels,
          d = e.src;
      return t.reduce(function (e, o) {
        var t = Object(f.b)(Object(f.a)(o, s), o.mediaTypes, o.sizes),
            n = t.active,
            a = t.mediaTypes,
            t = t.filterResults;
        return n ? t && O.logInfo('Size mapping filtered adUnit "'.concat(o.code, '" banner sizes from '), t.before, "to ", t.after) : O.logInfo('Size mapping disabled adUnit "'.concat(o.code, '"')), n && e.push(o.bids.filter(function (e) {
          return e.bidder === r;
        }).reduce(function (e, t) {
          var n = o.nativeParams || O.deepAccess(o, "mediaTypes.native");
          n && (t = E({}, t, {
            nativeParams: Object(l.g)(n)
          })), t = E({}, t, Object(y.getDefinedParams)(o, ["fpd", "mediaType", "renderer", "storedAuctionResponse"]));
          var r = Object(f.b)(Object(f.a)(t, s), a),
              i = r.active,
              n = r.mediaTypes,
              r = r.filterResults;
          return i ? r && O.logInfo('Size mapping filtered adUnit "'.concat(o.code, '" bidder "').concat(t.bidder, '" banner sizes from '), r.before, "to ", r.after) : O.logInfo('Size mapping deactivated adUnit "'.concat(o.code, '" bidder "').concat(t.bidder, '"')), O.isValidMediaTypes(n) ? t = E({}, t, {
            mediaTypes: n
          }) : O.logError("mediaTypes is not correctly configured for adunit ".concat(o.code)), i && e.push(E({}, t, {
            adUnitCode: o.code,
            transactionId: o.transactionId,
            sizes: O.deepAccess(n, "banner.sizes") || O.deepAccess(n, "video.playerSize") || [],
            bidId: t.bid_id || O.getUniqueIdentifierStr(),
            bidderRequestId: u,
            auctionId: c,
            src: d,
            bidRequestsCount: g.a.getRequestsCounter(o.code),
            bidderRequestsCount: g.a.getBidderRequestsCounter(o.code, t.bidder),
            bidderWinsCount: g.a.getBidderWinsCounter(o.code, t.bidder)
          })), e;
        }, [])), e;
      }, []).reduce(y.flatten, []).filter(function (e) {
        return "" !== e;
      });
    }, "getBids");
    var x = {
      consentData: null,
      setConsentData: function setConsentData(e) {
        x.consentData = e;
      },
      getConsentData: function getConsentData() {
        return x.consentData;
      }
    },
        U = {
      consentData: null,
      setConsentData: function setConsentData(e) {
        U.consentData = e;
      },
      getConsentData: function getConsentData() {
        return U.consentData;
      }
    };

    function D() {
      return R && R.enabled && R.testing && T;
    }

    function c(t, n, e) {
      try {
        var r = w[t].getSpec();
        r && r[n] && "function" == typeof r[n] && (O.logInfo("Invoking ".concat(t, ".").concat(n)), v.b.runWithBidder(t, y.bind.call(r[n], r, e)));
      } catch (e) {
        O.logWarn("Error calling ".concat(n, " of ").concat(t));
      }
    }

    j.makeBidRequests = Object(r.b)("sync", function (e, r, i, o, a) {
      C.emit(I.EVENTS.BEFORE_REQUEST_BIDS, e);
      var c = [],
          t = Object(y.getBidderCodes)(e);
      v.b.getConfig("bidderSequence") === v.a && (t = Object(y.shuffle)(t));
      var n,
          u,
          s,
          d,
          f,
          l = Object(S.a)(),
          p = t,
          g = [];
      R.enabled && (D() && (g = T.getSourceBidderMap(e)[T.CLIENT]), n = R.bidders, p = t.filter(function (e) {
        return !h()(n, e) || h()(g, e);
      }), Boolean(D() && R.testServerOnly) && (f = e, Boolean(m()(f, function (e) {
        return m()(e.bids, function (e) {
          return (e.bidSource || R.bidderControl && R.bidderControl[e.bidder]) && e.finalSource === T.SERVER;
        });
      }))) && (p.length = 0), t = e, d = R.bidders, (t = O.deepClone(t)).forEach(function (e) {
        e.bids = e.bids.filter(function (e) {
          return h()(d, e.bidder) && (!D() || e.finalSource !== T.CLIENT);
        }).map(function (e) {
          return e.bid_id = O.getUniqueIdentifierStr(), e;
        });
      }), u = t = t.filter(function (e) {
        return 0 !== e.bids.length;
      }), s = O.generateUUID(), n.forEach(function (e) {
        var t = O.getUniqueIdentifierStr(),
            t = {
          bidderCode: e,
          auctionId: i,
          bidderRequestId: t,
          tid: s,
          bids: B({
            bidderCode: e,
            auctionId: i,
            bidderRequestId: t,
            adUnits: O.deepClone(u),
            labels: a,
            src: I.S2S.SRC
          }),
          auctionStart: r,
          timeout: R.timeout,
          src: I.S2S.SRC,
          refererInfo: l
        };
        0 !== t.bids.length && c.push(t);
      }), u.forEach(function (e) {
        var t = e.bids.filter(function (t) {
          return m()(c, function (e) {
            return m()(e.bids, function (e) {
              return e.bidId === t.bid_id;
            });
          });
        });
        e.bids = t;
      }), c.forEach(function (e) {
        e.adUnitsS2SCopy = u.filter(function (e) {
          return 0 < e.bids.length;
        });
      }));
      var b = (e = e, (e = O.deepClone(e)).forEach(function (e) {
        e.bids = e.bids.filter(function (e) {
          return !D() || e.finalSource !== T.SERVER;
        });
      }), e = e.filter(function (e) {
        return 0 !== e.bids.length;
      }));
      return p.forEach(function (e) {
        var t = O.getUniqueIdentifierStr(),
            n = {
          bidderCode: e,
          auctionId: i,
          bidderRequestId: t,
          bids: B({
            bidderCode: e,
            auctionId: i,
            bidderRequestId: t,
            adUnits: O.deepClone(b),
            labels: a,
            src: "client"
          }),
          auctionStart: r,
          timeout: o,
          refererInfo: l
        },
            t = w[e];
        t || O.logError("Trying to make a request for bidder that does not exist: ".concat(e)), t && n.bids && 0 !== n.bids.length && c.push(n);
      }), x.getConsentData() && c.forEach(function (e) {
        e.gdprConsent = x.getConsentData();
      }), U.getConsentData() && c.forEach(function (e) {
        e.uspConsent = U.getConsentData();
      }), c;
    }, "makeBidRequests"), j.callBids = function (e, t, i, o, a, c, u) {
      var n, r, s, d, f, l, p, g;
      t.length ? (n = (l = A(t.reduce(function (e, t) {
        return e[Number(void 0 !== t.src && t.src === I.S2S.SRC)].push(t), e;
      }, [[], []]), 2))[0], (r = l[1]).length && (s = Object(b.b)(c, a ? {
        request: a.request.bind(null, "s2s"),
        done: a.done
      } : void 0), d = R.bidders, f = w[R.adapter], t = r[0].tid, l = r[0].adUnitsS2SCopy, f ? (l = {
        tid: t,
        ad_units: l
      }).ad_units.length && (p = r.map(function (e) {
        return e.start = Object(y.timestamp)(), o.bind(e);
      }), g = l.ad_units.reduce(function (e, t) {
        return e.concat((t.bids || []).reduce(function (e, t) {
          return e.concat(t.bidder);
        }, []));
      }, []), O.logMessage("CALLING S2S HEADER BIDDERS ==== ".concat(d.filter(function (e) {
        return h()(g, e);
      }).join(","))), r.forEach(function (e) {
        C.emit(I.EVENTS.BID_REQUESTED, e);
      }), f.callBids(l, r, function (e, t) {
        var n = Object(y.getBidderRequest)(r, t.bidderCode, e);
        n && i.call(n, e, t);
      }, function () {
        return p.forEach(function (e) {
          return e();
        });
      }, s)) : O.logError("missing " + R.adapter)), n.forEach(function (t) {
        t.start = Object(y.timestamp)();
        var e = w[t.bidderCode];
        O.logMessage("CALLING BIDDER ======= ".concat(t.bidderCode)), C.emit(I.EVENTS.BID_REQUESTED, t);
        var n = Object(b.b)(c, a ? {
          request: a.request.bind(null, t.bidderCode),
          done: a.done
        } : void 0),
            r = o.bind(t);

        try {
          v.b.runWithBidder(t.bidderCode, y.bind.call(e.callBids, e, t, i.bind(t), r, n, u, v.b.callbackWithBidder(t.bidderCode)));
        } catch (e) {
          O.logError("".concat(t.bidderCode, " Bid Adapter emitted an uncaught error when parsing their bidRequest"), {
            e: e,
            bidRequest: t
          }), r();
        }
      })) : O.logWarn("callBids executed with no bidRequests.  Were they filtered by labels or sizing?");
    }, j.videoAdapters = [], j.registerBidAdapter = function (e, t) {
      var n = (2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}).supportedMediaTypes,
          n = void 0 === n ? [] : n;
      e && t ? "function" == typeof e.callBids ? (w[t] = e, h()(n, "video") && j.videoAdapters.push(t), h()(n, "native") && l.e.push(t)) : O.logError("Bidder adaptor error for bidder code: " + t + "bidder must implement a callBids() function") : O.logError("bidAdaptor or bidderCode not specified");
    }, j.aliasBidAdapter = function (t, e, n) {
      var r, i;

      if (void 0 === w[e]) {
        var o = w[t];

        if (void 0 === o) {
          var a = v.b.getConfig("s2sConfig"),
              a = a && a.bidders;
          a && h()(a, e) ? _[e] = t : O.logError('bidderCode "' + t + '" is not an existing bidder.', "adapterManager.aliasBidAdapter");
        } else try {
          var c,
              u,
              s,
              d = (r = t, i = [], h()(j.videoAdapters, r) && i.push("video"), h()(l.e, r) && i.push("native"), i);
          o.constructor.prototype != Object.prototype ? (s = new o.constructor()).setBidderCode(e) : (c = o.getSpec(), u = n && n.gvlid, s = Object(p.newBidder)(E({}, c, {
            code: e,
            gvlid: u
          })), _[e] = t), j.registerBidAdapter(s, e, {
            supportedMediaTypes: d
          });
        } catch (e) {
          O.logError(t + " bidder does not currently support aliasing.", "adapterManager.aliasBidAdapter");
        }
      } else O.logMessage('alias name "' + e + '" has been already specified.');
    }, j.registerAnalyticsAdapter = function (e) {
      var t = e.adapter,
          n = e.code,
          e = e.gvlid;
      t && n ? "function" == typeof t.enableAnalytics ? (t.code = n, a[n] = {
        adapter: t,
        gvlid: e
      }) : O.logError('Prebid Error: Analytics adaptor error for analytics "'.concat(n, '"\n        analytics adapter must implement an enableAnalytics() function')) : O.logError("Prebid Error: analyticsAdapter or analyticsCode not specified");
    }, j.enableAnalytics = function (e) {
      O.isArray(e) || (e = [e]), O._each(e, function (e) {
        var t = a[e.provider].adapter;
        t ? t.enableAnalytics(e) : O.logError("Prebid Error: no analytics adapter found in registry for\n        ".concat(e.provider, "."));
      });
    }, j.getBidAdapter = function (e) {
      return w[e];
    }, j.getAnalyticsAdapter = function (e) {
      return a[e];
    }, j.callTimedOutBidders = function (t, n, r) {
      n = n.map(function (e) {
        return e.params = O.getUserConfiguredParams(t, e.adUnitCode, e.bidder), e.timeout = r, e;
      }), n = O.groupBy(n, "bidder"), Object.keys(n).forEach(function (e) {
        c(e, "onTimeout", n[e]);
      });
    }, j.callBidWonBidder = function (e, t, n) {
      t.params = O.getUserConfiguredParams(n, t.adUnitCode, t.bidder), g.a.incrementBidderWinsCounter(t.adUnitCode, t.bidder), c(e, "onBidWon", t);
    }, j.callSetTargetingBidder = function (e, t) {
      c(e, "onSetTargeting", t);
    }, t.default = j;
  },
  70: function _(e, t, n) {
    var r = n(27),
        i = n(43),
        o = "".split;
    e.exports = r(function () {
      return !Object("z").propertyIsEnumerable(0);
    }) ? function (e) {
      return "String" == i(e) ? o.call(e, "") : Object(e);
    } : Object;
  },
  71: function _(e, t, n) {
    var r = n(30),
        i = n(27),
        o = n(72);
    e.exports = !r && !i(function () {
      return 7 != Object.defineProperty(o("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  },
  72: function _(e, t, n) {
    var r = n(21),
        n = n(24),
        i = r.document,
        o = n(i) && n(i.createElement);

    e.exports = function (e) {
      return o ? i.createElement(e) : {};
    };
  },
  73: function _(e, t, n) {
    var r = n(16),
        i = n(59);
    (e.exports = function (e, t) {
      return i[e] || (i[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: "3.10.1",
      mode: r ? "pure" : "global",
      copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
    });
  },
  74: function _(e, t, n) {
    var r = n(103),
        i = n(104),
        n = n(27);
    e.exports = !!Object.getOwnPropertySymbols && !n(function () {
      return !Symbol.sham && (r ? 38 === i : 37 < i && i < 41);
    });
  },
  75: function _(e, t, n) {
    var u = n(48),
        s = n(50),
        d = n(109),
        n = function n(c) {
      return function (e, t, n) {
        var r,
            i = u(e),
            o = s(i.length),
            a = d(n, o);

        if (c && t != t) {
          for (; a < o;) {
            if ((r = i[a++]) != r) return !0;
          }
        } else for (; a < o; a++) {
          if ((c || a in i) && i[a] === t) return c || a || 0;
        }

        return !c && -1;
      };
    };

    e.exports = {
      includes: n(!0),
      indexOf: n(!1)
    };
  },
  76: function _(e, t, n) {
    var r = n(110);
    n(133), n(135), n(137), n(139), n(141), n(142), n(143), n(144), n(145), n(146), n(147), n(148), n(149), n(150), n(151), n(152), n(153), n(154), e.exports = r;
  },
  77: function _(e, t, n) {
    function r(e) {
      c(e, d, {
        value: {
          objectID: "O" + ++f,
          weakData: {}
        }
      });
    }

    var i = n(53),
        o = n(24),
        a = n(28),
        c = n(31).f,
        u = n(60),
        s = n(113),
        d = u("meta"),
        f = 0,
        l = Object.isExtensible || function () {
      return !0;
    },
        p = e.exports = {
      REQUIRED: !1,
      fastKey: function fastKey(e, t) {
        if (!o(e)) return "symbol" == (0, _typeof2.default)(e) ? e : ("string" == typeof e ? "S" : "P") + e;

        if (!a(e, d)) {
          if (!l(e)) return "F";
          if (!t) return "E";
          r(e);
        }

        return e[d].objectID;
      },
      getWeakData: function getWeakData(e, t) {
        if (!a(e, d)) {
          if (!l(e)) return !0;
          if (!t) return !1;
          r(e);
        }

        return e[d].weakData;
      },
      onFreeze: function onFreeze(e) {
        return s && p.REQUIRED && l(e) && !a(e, d) && r(e), e;
      }
    };

    i[d] = !0;
  },
  78: function _(e, t, n) {
    var r = n(19),
        i = n(38),
        o = r("iterator"),
        a = Array.prototype;

    e.exports = function (e) {
      return void 0 !== e && (i.Array === e || a[o] === e);
    };
  },
  79: function _(e, t, n) {
    var r = n(15);

    e.exports = function (e) {
      var t = e.return;
      if (void 0 !== t) return r(t.call(e)).value;
    };
  },
  8: function _(e, t, n) {
    "use strict";

    n.d(t, "c", function () {
      return d;
    }), n.d(t, "d", function () {
      return f;
    }), t.a = function (e) {
      return i({
        moduleName: e,
        moduleType: "core"
      });
    }, t.b = function (e, t) {
      return i({
        gvlid: e,
        moduleName: t
      });
    };
    var r = n(13),
        a = n(0),
        t = n(12),
        c = n.n(t),
        s = ["core", "prebid-module"],
        d = [];

    function i(e) {
      var e = 0 < arguments.length && void 0 !== e ? e : {},
          r = e.gvlid,
          i = e.moduleName,
          o = e.moduleType;

      function u(t) {
        if (c()(s, o)) return t({
          valid: !0
        });
        var n;
        return f(r, i, {
          hasEnforcementHook: !1
        }, function (e) {
          n = e && e.hasEnforcementHook ? t(e) : (e = {
            hasEnforcementHook: !1,
            valid: a.hasDeviceAccess()
          }, t(e));
        }), n;
      }

      return {
        setCookie: function setCookie(r, i, o, a, c, t) {
          function n(e) {
            var t, n;
            e && e.valid && (t = c && "" !== c ? " ;domain=".concat(encodeURIComponent(c)) : "", n = o && "" !== o ? " ;expires=".concat(o) : "", e = null != a && "none" == a.toLowerCase() ? "; Secure" : "", document.cookie = "".concat(r, "=").concat(encodeURIComponent(i)).concat(n, "; path=/").concat(t).concat(a ? "; SameSite=".concat(a) : "").concat(e));
          }

          if (!t || "function" != typeof t) return u(n);
          d.push(function () {
            var e = u(n);
            t(e);
          });
        },
        getCookie: function getCookie(t, n) {
          function r(e) {
            if (e && e.valid) {
              e = window.document.cookie.match("(^|;)\\s*" + t + "\\s*=\\s*([^;]*)\\s*(;|$)");
              return e ? decodeURIComponent(e[2]) : null;
            }

            return null;
          }

          if (!n || "function" != typeof n) return u(r);
          d.push(function () {
            var e = u(r);
            n(e);
          });
        },
        localStorageIsEnabled: function localStorageIsEnabled(t) {
          function n(e) {
            if (e && e.valid) try {
              return localStorage.setItem("prebid.cookieTest", "1"), "1" === localStorage.getItem("prebid.cookieTest");
            } catch (e) {}
            return !1;
          }

          if (!t || "function" != typeof t) return u(n);
          d.push(function () {
            var e = u(n);
            t(e);
          });
        },
        cookiesAreEnabled: function cookiesAreEnabled(t) {
          function n(e) {
            return !(!e || !e.valid) && (!!a.checkCookieSupport() || (window.document.cookie = "prebid.cookieTest", -1 !== window.document.cookie.indexOf("prebid.cookieTest")));
          }

          if (!t || "function" != typeof t) return u(n);
          d.push(function () {
            var e = u(n);
            t(e);
          });
        },
        setDataInLocalStorage: function setDataInLocalStorage(t, n, r) {
          function i(e) {
            e && e.valid && window.localStorage.setItem(t, n);
          }

          if (!r || "function" != typeof r) return u(i);
          d.push(function () {
            var e = u(i);
            r(e);
          });
        },
        getDataFromLocalStorage: function getDataFromLocalStorage(t, n) {
          function r(e) {
            return e && e.valid ? window.localStorage.getItem(t) : null;
          }

          if (!n || "function" != typeof n) return u(r);
          d.push(function () {
            var e = u(r);
            n(e);
          });
        },
        removeDataFromLocalStorage: function removeDataFromLocalStorage(t, n) {
          function r(e) {
            e && e.valid && window.localStorage.removeItem(t);
          }

          if (!n || "function" != typeof n) return u(r);
          d.push(function () {
            var e = u(r);
            n(e);
          });
        },
        hasLocalStorage: function hasLocalStorage(t) {
          function n(e) {
            if (e && e.valid) try {
              return !!window.localStorage;
            } catch (e) {
              a.logError("Local storage api disabled");
            }
            return !1;
          }

          if (!t || "function" != typeof t) return u(n);
          d.push(function () {
            var e = u(n);
            t(e);
          });
        },
        findSimilarCookies: function findSimilarCookies(o, t) {
          function n(e) {
            if (e && e.valid) {
              var t = [];
              if (a.hasDeviceAccess()) for (var n = document.cookie.split(";"); n.length;) {
                var r = n.pop(),
                    i = (i = r.indexOf("=")) < 0 ? r.length : i;
                0 <= decodeURIComponent(r.slice(0, i).replace(/^\s+/, "")).indexOf(o) && t.push(decodeURIComponent(r.slice(i + 1)));
              }
              return t;
            }
          }

          if (!t || "function" != typeof t) return u(n);
          d.push(function () {
            var e = u(n);
            t(e);
          });
        }
      };
    }

    var f = Object(r.b)("async", function (e, t, n, r) {
      r(n);
    }, "validateStorageEnforcement");
  },
  80: function _(e, t) {
    e.exports = function (e, t, n) {
      if (!(e instanceof t)) throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
      return e;
    };
  },
  81: function _(e, t, n) {
    function r() {}

    function i(e) {
      return "<script>" + e + "</" + p + ">";
    }

    var o,
        a = n(15),
        c = n(118),
        u = n(82),
        s = n(53),
        d = n(121),
        f = n(72),
        n = n(65),
        l = "prototype",
        p = "script",
        g = n("IE_PROTO"),
        _b = function b() {
      try {
        o = document.domain && new ActiveXObject("htmlfile");
      } catch (e) {}

      var e;
      _b = o ? function (e) {
        e.write(i("")), e.close();
        var t = e.parentWindow.Object;
        return e = null, t;
      }(o) : ((e = f("iframe")).style.display = "none", d.appendChild(e), e.src = String("javascript:"), (e = e.contentWindow.document).open(), e.write(i("document.F=Object")), e.close(), e.F);

      for (var t = u.length; t--;) {
        delete _b[l][u[t]];
      }

      return _b();
    };

    s[g] = !0, e.exports = Object.create || function (e, t) {
      var n;
      return null !== e ? (r[l] = a(e), n = new r(), r[l] = null, n[g] = e) : n = _b(), void 0 === t ? n : c(n, t);
    };
  },
  82: function _(e, t) {
    e.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
  },
  83: function _(e, t, n) {
    var i = n(29);

    e.exports = function (e, t, n, r) {
      r && r.enumerable ? e[t] = n : i(e, t, n);
    };
  },
  84: function _(e, t, n) {
    "use strict";

    var r,
        i = n(27),
        o = n(85),
        a = n(29),
        c = n(28),
        u = n(19),
        s = n(16),
        d = u("iterator"),
        n = !1;
    [].keys && ("next" in (u = [].keys()) ? (u = o(o(u))) !== Object.prototype && (r = u) : n = !0);
    i = null == r || i(function () {
      var e = {};
      return r[d].call(e) !== e;
    });
    i && (r = {}), s && !i || c(r, d) || a(r, d, function () {
      return this;
    }), e.exports = {
      IteratorPrototype: r,
      BUGGY_SAFARI_ITERATORS: n
    };
  },
  845: function _(e, t, n) {
    e.exports = n(68);
  },
  85: function _(e, t, n) {
    var r = n(28),
        i = n(57),
        o = n(65),
        n = n(124),
        a = o("IE_PROTO"),
        c = Object.prototype;
    e.exports = n ? Object.getPrototypeOf : function (e) {
      return e = i(e), r(e, a) ? e[a] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? c : null;
    };
  },
  86: function _(e, t, n) {
    "use strict";

    var r = n(129).charAt,
        i = n(54),
        n = n(66),
        o = "String Iterator",
        a = i.set,
        c = i.getterFor(o);
    n(String, "String", function (e) {
      a(this, {
        type: o,
        string: String(e),
        index: 0
      });
    }, function () {
      var e = c(this),
          t = e.string,
          n = e.index;
      return n >= t.length ? {
        value: void 0,
        done: !0
      } : (n = r(t, n), e.index += n.length, {
        value: n,
        done: !1
      });
    });
  },
  87: function _(e, t, n) {
    var r = n(15),
        i = n(61);

    e.exports = function (e) {
      var t = i(e);
      if ("function" != typeof t) throw TypeError(String(e) + " is not iterable");
      return r(t.call(e));
    };
  },
  88: function _(e, t, n) {
    n = n(155);
    e.exports = n;
  },
  89: function _(e, t, n) {
    "use strict";

    t.a = function (e) {
      var t = e;
      return {
        callBids: function callBids() {},
        setBidderCode: function setBidderCode(e) {
          t = e;
        },
        getBidderCode: function getBidderCode() {
          return t;
        }
      };
    };
  },
  9: function _(e, t, n) {
    function r() {
      return (r = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n,
              r = arguments[t];

          for (n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var c,
        u = n(0),
        n = n(5),
        i = Array.prototype.slice,
        s = Array.prototype.push,
        o = u._map(n.EVENTS, function (e) {
      return e;
    }),
        d = n.EVENT_ID_PATHS,
        f = [];

    e.exports = (c = {}, (e = {}).on = function (e, t, n) {
      var r;
      r = e, u.contains(o, r) ? (r = c[e] || {
        que: []
      }, n ? (r[n] = r[n] || {
        que: []
      }, r[n].que.push(t)) : r.que.push(t), c[e] = r) : u.logError("Wrong event name : " + e + " Valid event names :" + o);
    }, e.emit = function (e) {
      !function (e, t) {
        u.logMessage("Emitting event for: " + e);

        var n = t[0] || {},
            r = n[d[e]],
            i = c[e] || {
          que: []
        },
            o = u._map(i, function (e, t) {
          return t;
        }),
            a = [];

        f.push({
          eventType: e,
          args: n,
          id: r
        }), r && u.contains(o, r) && s.apply(a, i[r].que), s.apply(a, i.que), u._each(a, function (e) {
          if (e) try {
            e.apply(null, t);
          } catch (e) {
            u.logError("Error executing handler:", "events.js", e);
          }
        });
      }(e, i.call(arguments, 1));
    }, e.off = function (e, n, r) {
      var i = c[e];
      u.isEmpty(i) || u.isEmpty(i.que) && u.isEmpty(i[r]) || r && (u.isEmpty(i[r]) || u.isEmpty(i[r].que)) || (r ? u._each(i[r].que, function (e) {
        var t = i[r].que;
        e === n && t.splice(t.indexOf(e), 1);
      }) : u._each(i.que, function (e) {
        var t = i.que;
        e === n && t.splice(t.indexOf(e), 1);
      }), c[e] = i);
    }, e.get = function () {
      return c;
    }, e.getEvents = function () {
      var t = [];
      return u._each(f, function (e) {
        e = r({}, e);
        t.push(e);
      }), t;
    }, e);
  },
  90: function _(e, t, n) {
    "use strict";

    t.a = function (e, t) {
      if (e.labelAll) return {
        labelAll: !0,
        labels: e.labelAll,
        activeLabels: t
      };
      return {
        labelAll: !1,
        labels: e.labelAny,
        activeLabels: t
      };
    }, t.c = function (e) {
      var t = d(1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : s);
      return !t.shouldFilter || !!t.sizesSupported[e];
    }, t.b = function () {
      var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.labels,
          n = void 0 === t ? [] : t,
          r = e.labelAll,
          i = void 0 !== r && r,
          t = e.activeLabels,
          o = void 0 === t ? [] : t,
          r = 1 < arguments.length ? arguments[1] : void 0,
          e = 2 < arguments.length ? arguments[2] : void 0,
          a = d(3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : s);
      r = Object(c.isPlainObject)(r) ? Object(c.deepClone)(r) : e ? {
        banner: {
          sizes: e
        }
      } : {};
      t = Object(c.deepAccess)(r, "banner.sizes");
      a.shouldFilter && t && (r.banner.sizes = t.filter(function (e) {
        return a.sizesSupported[e];
      }));
      e = Object.keys(r), n = {
        active: e.every(function (e) {
          return "banner" !== e;
        }) || e.some(function (e) {
          return "banner" === e;
        }) && 0 < Object(c.deepAccess)(r, "banner.sizes.length") && (0 === n.length || !i && (n.some(function (e) {
          return a.labels[e];
        }) || n.some(function (e) {
          return u()(o, e);
        })) || i && n.reduce(function (e, t) {
          return e && (a.labels[t] || u()(o, t));
        }, !0)),
        mediaTypes: r
      };
      t && t.length !== r.banner.sizes.length && (n.filterResults = {
        before: t,
        after: r.banner.sizes
      });
      return n;
    };
    var r = n(3),
        c = n(0),
        t = n(12),
        u = n.n(t);

    function i(e) {
      return (i = "function" == typeof Symbol && "symbol" == (0, _typeof2.default)(Symbol.iterator) ? function (e) {
        return (0, _typeof2.default)(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : (0, _typeof2.default)(e);
      })(e);
    }

    var s = [];

    function d(e) {
      return e.reduce(function (n, r) {
        if ("object" === i(r) && "string" == typeof r.mediaQuery) {
          var t = !1;
          if ("" === r.mediaQuery) t = !0;else try {
            t = Object(c.getWindowTop)().matchMedia(r.mediaQuery).matches;
          } catch (e) {
            Object(c.logWarn)("Unfriendly iFrame blocks sizeConfig from being correctly evaluated"), t = matchMedia(r.mediaQuery).matches;
          }
          t && (Array.isArray(r.sizesSupported) && (n.shouldFilter = !0), ["labels", "sizesSupported"].forEach(function (t) {
            return (r[t] || []).forEach(function (e) {
              return n[t][e] = !0;
            });
          }));
        } else Object(c.logWarn)('sizeConfig rule missing required property "mediaQuery"');

        return n;
      }, {
        labels: {},
        sizesSupported: {},
        shouldFilter: !1
      });
    }

    r.b.getConfig("sizeConfig", function (e) {
      e = e.sizeConfig, s = e;
    });
  },
  91: function _(e, t, n) {
    n = n(218);
    e.exports = n;
  },
  92: function _(e, t, n) {
    "use strict";

    t.b = function (e, t, n) {
      n = {
        puts: e.map(a, n)
      };
      Object(r.a)(i.b.getConfig("cache.url"), function (n) {
        return {
          success: function success(e) {
            var t;

            try {
              t = JSON.parse(e).responses;
            } catch (e) {
              return void n(e, []);
            }

            t ? n(null, t) : n(new Error("The cache server didn't respond with a responses property."), []);
          },
          error: function error(e, t) {
            n(new Error("Error storing video ad in the cache: ".concat(e, ": ").concat(JSON.stringify(t))), []);
          }
        };
      }(t), JSON.stringify(n), {
        contentType: "text/plain",
        withCredentials: !0
      });
    }, t.a = function (e) {
      return "".concat(i.b.getConfig("cache.url"), "?uuid=").concat(e);
    };
    var r = n(4),
        i = n(3),
        o = n(0);

    function a(e) {
      var t,
          n = {
        type: "xml",
        value: e.vastXml || (t = e.vastUrl, n = (n = e.vastImpUrl) ? "<![CDATA[".concat(n, "]]>") : "", '<VAST version="3.0">\n    <Ad>\n      <Wrapper>\n        <AdSystem>prebid.org wrapper</AdSystem>\n        <VASTAdTagURI><![CDATA['.concat(t, "]]></VASTAdTagURI>\n        <Impression>").concat(n, "</Impression>\n        <Creatives></Creatives>\n      </Wrapper>\n    </Ad>\n  </VAST>")),
        ttlseconds: Number(e.ttl)
      };
      return i.b.getConfig("cache.vasttrack") && (n.bidder = e.bidder, n.bidid = e.requestId, o.isPlainObject(this) && this.hasOwnProperty("auctionStart") && (n.timestamp = this.auctionStart)), "string" == typeof e.customCacheKey && "" !== e.customCacheKey && (n.key = e.customCacheKey), n;
    }
  },
  95: function _(e, t, n) {
    n(96);
    n = n(52);
    e.exports = n("Array", "find");
  },
  96: function _(e, t, n) {
    "use strict";

    var r = n(14),
        i = n(56).find,
        n = n(51),
        o = !0;
    "find" in [] && Array(1).find(function () {
      o = !1;
    }), r({
      target: "Array",
      proto: !0,
      forced: o
    }, {
      find: function find(e) {
        return i(this, e, 1 < arguments.length ? arguments[1] : void 0);
      }
    }), n("find");
  },
  97: function _(e, t, n) {
    var r = n(30),
        i = n(98),
        o = n(47),
        a = n(48),
        c = n(55),
        u = n(28),
        s = n(71),
        d = Object.getOwnPropertyDescriptor;
    t.f = r ? d : function (e, t) {
      if (e = a(e), t = c(t, !0), s) try {
        return d(e, t);
      } catch (e) {}
      if (u(e, t)) return o(!i.f.call(e, t), e[t]);
    };
  },
  98: function _(e, t, n) {
    "use strict";

    var r = {}.propertyIsEnumerable,
        i = Object.getOwnPropertyDescriptor,
        o = i && !r.call({
      1: 2
    }, 1);
    t.f = o ? function (e) {
      e = i(this, e);
      return !!e && e.enumerable;
    } : r;
  },
  99: function _(e, t, n) {
    var r = n(27),
        i = /#|\.prototype\./,
        n = function n(e, t) {
      e = a[o(e)];
      return e == u || e != c && ("function" == typeof t ? r(t) : !!t);
    },
        o = n.normalize = function (e) {
      return String(e).replace(i, ".").toLowerCase();
    },
        a = n.data = {},
        c = n.NATIVE = "N",
        u = n.POLYFILL = "P";

    e.exports = n;
  }
});
pbjsChunk([291], {
  260: function _(e, t, r) {
    e.exports = r(261);
  },
  261: function _(e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r.d(t, "spec", function () {
      return P;
    });
    var s = r(0),
        t = r(1),
        r = r(2);

    function i() {
      return (i = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r,
              n = arguments[t];

          for (r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function n(e, t) {
      return t = t || e.slice(0), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(t)
        }
      }));
    }

    var a = {
      AOL: "aol",
      ONEMOBILE: "onemobile",
      ONEDISPLAY: "onedisplay"
    },
        o = {
      GET: "display-get"
    },
        c = {
      GET: "mobile-get",
      POST: "mobile-post"
    },
        d = {
      TAG: "iframe",
      TYPE: "iframe"
    },
        u = {
      TAG: "img",
      TYPE: "image"
    },
        p = v(n(["", "/pubapi/3.0/", "/", "/", "/", "/ADTECH;v=2;cmd=bid;cors=yes;alias=", ";misc=", ";", ""]), "host", "network", "placement", "pageid", "sizeid", "alias", "misc", "dynamicParams"),
        l = v(n(["", "/bidRequest?"]), "host"),
        m = v(n(["dcn=", "&pos=", "&cmd=bid", ""]), "dcn", "pos", "dynamicParams"),
        f = {
      us: "adserver-us.adtech.advertising.com",
      eu: "adserver-eu.adtech.advertising.com",
      as: "adserver-as.adtech.advertising.com"
    },
        b = "https",
        h = 1;

    function v(a) {
      for (var e = arguments.length, o = new Array(1 < e ? e - 1 : 0), t = 1; t < e; t++) {
        o[t - 1] = arguments[t];
      }

      return function () {
        for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++) {
          r[t] = arguments[t];
        }

        var n = r[r.length - 1] || {},
            i = [a[0]];
        return o.forEach(function (e, t) {
          e = (s.isInteger(e) ? r : n)[e];
          i.push(e, a[t + 1]);
        }), i.join("");
      };
    }

    function g(e) {
      return e === a.AOL || e === a.ONEMOBILE;
    }

    function O(e) {
      if (g(e.bidder) && e.params.id && e.params.imp && e.params.imp[0]) {
        e = e.params.imp[0];
        return e.id && e.tagid && (e.banner && e.banner.w && e.banner.h || e.video && e.video.mimes && e.video.minduration && e.video.maxduration);
      }
    }

    function y(e) {
      return g(e.bidder) && e.params.dcn && e.params.pos;
    }

    function E(e) {
      return ((t = e.bidder) === a.AOL || t === a.ONEDISPLAY) && e.params.placement && e.params.network;
      var t;
    }

    var P = {
      code: a.AOL,
      gvlid: 25,
      aliases: [a.ONEMOBILE, a.ONEDISPLAY],
      supportedMediaTypes: [r.b],
      isBidRequestValid: function isBidRequestValid(e) {
        return E(e) || y(e = e) || O(e);
      },
      buildRequests: function buildRequests(e, t) {
        var r = this,
            n = {};
        return t && (n.gdpr = t.gdprConsent, n.uspConsent = t.uspConsent), e.map(function (e) {
          var t,
              t = y(t = e) ? c.GET : O(t) ? c.POST : E(t) ? o.GET : void 0;
          if (t) return r.formatBidRequest(t, e, n);
        });
      },
      interpretResponse: function interpretResponse(e, t) {
        var r = e.body;

        if (r) {
          e = this._parseBidResponse(r, t);
          if (e) return e;
        } else s.logError("Empty bid response", t.bidderCode, r);
      },
      getUserSyncs: function getUserSyncs(e, t) {
        t = !s.isEmpty(t) && t[0].body;
        return t && t.ext && t.ext.pixels ? this.parsePixelItems(t.ext.pixels) : [];
      },
      formatBidRequest: function formatBidRequest(e, t, r) {
        var n;

        switch (e) {
          case o.GET:
            n = {
              url: this.buildMarketplaceUrl(t, r),
              method: "GET",
              ttl: 60
            };
            break;

          case c.GET:
            n = {
              url: this.buildOneMobileGetUrl(t, r),
              method: "GET",
              ttl: 3600
            };
            break;

          case c.POST:
            n = {
              url: this.buildOneMobileBaseUrl(t),
              method: "POST",
              ttl: 3600,
              data: this.buildOpenRtbRequestData(t, r),
              options: {
                contentType: "application/json",
                customHeaders: {
                  "x-openrtb-version": "2.2"
                }
              }
            };
        }

        return n.bidderCode = t.bidder, n.bidId = t.bidId, n.userSyncOn = t.params.userSyncOn, n;
      },
      buildMarketplaceUrl: function buildMarketplaceUrl(e, t) {
        var r = e.params,
            n = r.server,
            e = r.region || "us";
        return f.hasOwnProperty(e) || (s.logWarn("Unknown region '".concat(e, "' for AOL bidder.")), e = "us"), n = n || f[e], r.region = e, this.applyProtocol(p({
          host: n,
          network: r.network,
          placement: parseInt(r.placement),
          pageid: r.pageId || 0,
          sizeid: r.sizeId || 0,
          alias: r.alias || s.getUniqueIdentifierStr(),
          misc: new Date().getTime(),
          dynamicParams: this.formatMarketplaceDynamicParams(r, t)
        }));
      },
      buildOneMobileGetUrl: function buildOneMobileGetUrl(e, t) {
        var r = e.params,
            n = r.dcn,
            i = r.pos,
            r = r.ext,
            e = this.buildOneMobileBaseUrl(e);
        return n && i && (t = this.formatOneMobileDynamicParams(r, t), e += m({
          dcn: n,
          pos: i,
          dynamicParams: t
        })), e;
      },
      buildOneMobileBaseUrl: function buildOneMobileBaseUrl(e) {
        return this.applyProtocol(l({
          host: e.params.host || "c2shb.ssp.yahoo.com"
        }));
      },
      applyProtocol: function applyProtocol(e) {
        return /^https?:\/\//i.test(e) ? e : (0 === e.indexOf("//") ? "".concat(b, ":") : "".concat(b, "://")).concat(e);
      },
      formatMarketplaceDynamicParams: function formatMarketplaceDynamicParams() {
        var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
            t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
            r = {};
        e.bidFloor && (r.bidfloor = e.bidFloor), i(r, this.formatKeyValues(e.keyValues)), i(r, this.formatConsentData(t));
        var n = "";
        return s._each(r, function (e, t) {
          n += "".concat(t, "=").concat(encodeURIComponent(e), ";");
        }), n;
      },
      formatOneMobileDynamicParams: function formatOneMobileDynamicParams() {
        var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
            t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
        this.isSecureProtocol() && (e.secure = h), i(e, this.formatConsentData(t));
        var r = "";
        return s._each(e, function (e, t) {
          r += "&".concat(t, "=").concat(encodeURIComponent(e));
        }), r;
      },
      buildOpenRtbRequestData: function buildOpenRtbRequestData(e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
            e = {
          id: e.params.id,
          imp: e.params.imp
        };
        return this.isEUConsentRequired(t) && (s.deepSetValue(e, "regs.ext.gdpr", h), t.gdpr.consentString && s.deepSetValue(e, "user.ext.consent", t.gdpr.consentString)), t.uspConsent && s.deepSetValue(e, "regs.ext.us_privacy", t.uspConsent), e;
      },
      isEUConsentRequired: function isEUConsentRequired(e) {
        return !!(e && e.gdpr && e.gdpr.gdprApplies);
      },
      formatKeyValues: function formatKeyValues(e) {
        var r = {};
        return s._each(e, function (e, t) {
          r["kv".concat(t)] = e;
        }), r;
      },
      formatConsentData: function formatConsentData(e) {
        var t = {};
        return this.isEUConsentRequired(e) && (t.gdpr = h, e.gdpr.consentString && (t.euconsent = e.gdpr.consentString)), e.uspConsent && (t.us_privacy = e.uspConsent), t;
      },
      parsePixelItems: function parsePixelItems(e) {
        var r = /\w*(?=\s)/,
            n = /src=("|')(.*?)\1/,
            i = [];
        return !e || (e = e.match(/(img|iframe)[\s\S]*?src\s*=\s*("|')(.*?)\2/gi)) && e.forEach(function (e) {
          var t = e.match(r)[0],
              e = e.match(n)[2];
          t && t && i.push({
            type: (t === u.TAG ? u : d).TYPE,
            url: e
          });
        }), i;
      },
      _parseBidResponse: function _parseBidResponse(e, t) {
        var r, n;

        try {
          r = e.seatbid[0].bid[0];
        } catch (e) {
          return;
        }

        if (r.ext && r.ext.encp) n = r.ext.encp;else if (null === (n = r.price) || isNaN(n)) return void s.logError("Invalid price in bid response", a.AOL, r);
        return {
          bidderCode: t.bidderCode,
          requestId: t.bidId,
          ad: r.adm,
          cpm: n,
          width: r.w,
          height: r.h,
          creativeId: r.crid || 0,
          pubapiId: e.id,
          currency: e.cur || "USD",
          dealId: r.dealid,
          netRevenue: !0,
          ttl: t.ttl
        };
      },
      isOneMobileBidder: g,
      isSecureProtocol: function isSecureProtocol() {
        return "https:" === document.location.protocol;
      }
    };
    Object(t.registerBidder)(P);
  }
}, [260]);
pbjsChunk([254], {
  346: function _(n, t, e) {
    n.exports = e(347);
  },
  347: function _(n, t, e) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), e.d(t, "allowAuction", function () {
      return b;
    }), e.d(t, "userCMP", function () {
      return r;
    }), e.d(t, "consentTimeout", function () {
      return c;
    }), e.d(t, "gdprScope", function () {
      return l;
    }), e.d(t, "staticConsentData", function () {
      return f;
    }), t.requestBidsHook = D, t.resetConsentData = function () {
      p = void 0, r = void 0, v = 0, a.gdprDataHandler.setConsentData(null);
    }, t.setConsentConfig = P;
    var d = e(0),
        o = e(3),
        a = e(7),
        t = e(12),
        i = e.n(t),
        t = e(348),
        u = e.n(t);

    function s(n) {
      return (s = "function" == typeof Symbol && "symbol" == (0, _typeof2.default)(Symbol.iterator) ? function (n) {
        return (0, _typeof2.default)(n);
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : (0, _typeof2.default)(n);
      })(n);
    }

    var r,
        c,
        l,
        f,
        p,
        g = "iab",
        C = 1e4,
        m = !0,
        b = {
      value: m,
      definedInConfig: !1
    },
        v = 0,
        y = !1,
        w = {
      iab: function iab(o, e, i) {
        function n(n, t) {
          d.logInfo("Received a response from CMP", n), t ? (!1 === n.gdprApplies || "tcloaded" === n.eventStatus || "useractioncomplete" === n.eventStatus || "cmpuishown" === n.eventStatus && n.tcString && !0 === n.purposeOneTreatment) && o(n, i) : e("CMP unable to register callback function.  Please check CMP setup.", i);
        }

        var t = function () {
          var t = {};

          function e() {
            t.getConsentData && t.getVendorConsents && (d.logInfo("Received all requested responses from CMP", t), o(t, i));
          }

          return {
            consentDataCallback: function consentDataCallback(n) {
              t.getConsentData = n, e();
            },
            vendorConsentsCallback: function vendorConsentsCallback(n) {
              t.getVendorConsents = n, e();
            }
          };
        }(),
            c = {},
            a = function () {
          for (var n, t, e = window; !n;) {
            try {
              if ("function" == typeof e.__tcfapi || "function" == typeof e.__cmp) {
                t = "function" == typeof e.__tcfapi ? (v = 2, e.__tcfapi) : (v = 1, e.__cmp), n = e;
                break;
              }
            } catch (n) {}

            try {
              if (e.frames.__tcfapiLocator) {
                v = 2, n = e;
                break;
              }
            } catch (n) {}

            try {
              if (e.frames.__cmpLocator) {
                v = 1, n = e;
                break;
              }
            } catch (n) {}

            if (e === window.top) break;
            e = e.parent;
          }

          return {
            cmpFrame: n,
            cmpFunction: t
          };
        }(),
            s = a.cmpFrame,
            a = a.cmpFunction;

        if (!s) return e("CMP not found.", i);
        d.isFn(a) ? (d.logInfo("Detected CMP API is directly accessible, calling it now..."), 1 === v ? (a("getConsentData", null, t.consentDataCallback), a("getVendorConsents", null, t.vendorConsentsCallback)) : 2 === v && a("addEventListener", v, n)) : 1 === v && window.$sf && window.$sf.ext && "function" == typeof window.$sf.ext.cmp ? (d.logInfo("Detected Prebid.js is encased in a SafeFrame and CMP is registered, calling it now..."), r("getConsentData", t.consentDataCallback), r("getVendorConsents", t.vendorConsentsCallback)) : (d.logInfo("Detected CMP is outside the current iframe where Prebid.js is located, calling it now..."), 1 === v ? (l("getConsentData", s, t.consentDataCallback), l("getVendorConsents", s, t.vendorConsentsCallback)) : 2 === v && l("addEventListener", s, n));

        function r(e, o) {
          var n = i.adUnits,
              t = 1,
              a = 1;
          Array.isArray(n) && 0 < n.length && (t = (n = d.getAdUnitSizes(n[0]))[0][0], a = n[0][1]), window.$sf.ext.register(t, a, function (n, t) {
            "cmpReturn" === n && (t = "getConsentData" === e ? t.vendorConsentData : t.vendorConsents, o(t));
          }), window.$sf.ext.cmp(e);
        }

        function l(n, s, t) {
          var r = 2 === v ? "__tcfapi" : "__cmp";
          window[r] = function (n, t, e) {
            var o,
                a = Math.random() + "",
                i = "".concat(r, "Call"),
                t = (o = {
              command: n,
              parameter: t,
              callId: a
            }, (n = i) in (t = {}) ? Object.defineProperty(t, n, {
              value: o,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[n] = o, t);
            1 !== v && (t[i].version = v), c[a] = e, s.postMessage(t, "*");
          }, window.addEventListener("message", function (n) {
            var t = "".concat(r, "Return"),
                n = "string" == typeof n.data && u()(n.data, t) ? JSON.parse(n.data) : n.data;
            n[t] && n[t].callId && (t = n[t], void 0 !== c[t.callId] && c[t.callId](t.returnValue, t.success));
          }, !1), window[r](n, null, t);
        }
      },
      static: function _static(n, t, e) {
        n(f, e);
      }
    };

    function D(n, t) {
      t = {
        context: this,
        args: [t],
        nextFn: n,
        adUnits: t.adUnits || pbjs.adUnits,
        bidsBackHandler: t.bidsBackHandler,
        haveExited: !1,
        timer: null
      };
      return p ? (d.logInfo("User consent information already known.  Pulling internally stored information..."), A(null, t)) : i()(Object.keys(w), r) ? (w[r].call(this, k, h, t), void (t.haveExited || (0 === c ? k(void 0, t) : t.timer = setTimeout(function (n) {
        h("CMP workflow exceeded timeout threshold.", n);
      }.bind(null, t), c)))) : (d.logWarn("CMP framework (".concat(r, ") is not a supported framework.  Aborting consentManagement module and resuming auction.")), t.nextFn.apply(t.context, t.args));
    }

    function k(e, n) {
      "static" === r && 2 === (v = e.getConsentData ? 1 : e.getTCData ? 2 : 0) && (e = e.getTCData);
      var t = 1 === v ? function (n) {
        var t = n && n.getConsentData && n.getConsentData.gdprApplies;
        return !("boolean" == typeof t && (!0 !== t || d.isStr(n.getConsentData.consentData) && d.isPlainObject(n.getVendorConsents) && 1 < Object.keys(n.getVendorConsents).length));
      } : 2 === v ? function () {
        var n = e && "boolean" == typeof e.gdprApplies ? e.gdprApplies : l,
            t = e && e.tcString;
        return !("boolean" == typeof n && (!0 !== n || d.isStr(t)));
      } : null;
      b.definedInConfig && 2 === v ? d.logWarn("'allowAuctionWithoutConsent' ignored for TCF 2") : b.definedInConfig || 1 !== v || d.logInfo("'allowAuctionWithoutConsent' using system default: (".concat(m, ").")), d.isFn(t) ? t(e) ? h("CMP returned unexpected value during lookup process.", n, e) : (clearTimeout(n.timer), M(e), A(null, n)) : h("Unable to derive CMP version to process data.  Consent object does not conform to TCF v1 or v2 specs.", n, e);
    }

    function h(n, t, e) {
      clearTimeout(t.timer), b.value && 1 === v && M(void 0), A(n, t, e);
    }

    function M(n) {
      1 === v ? p = {
        consentString: n ? n.getConsentData.consentData : void 0,
        vendorData: n ? n.getVendorConsents : void 0,
        gdprApplies: n ? n.getConsentData.gdprApplies : l
      } : (p = {
        consentString: n ? n.tcString : void 0,
        vendorData: n || void 0,
        gdprApplies: n && "boolean" == typeof n.gdprApplies ? n.gdprApplies : l
      }, n.addtlConsent && d.isStr(n.addtlConsent) && (p.addtlConsent = n.addtlConsent)), p.apiVersion = v, a.gdprDataHandler.setConsentData(p);
    }

    function A(n, t, e) {
      var o, a, i;
      !1 === t.haveExited && (t.haveExited = !0, o = t.context, a = t.args, i = t.nextFn, n ? b.value && 1 === v ? (d.logWarn(n + " 'allowAuctionWithoutConsent' activated.", e), i.apply(o, a)) : (d.logError(n + " Canceling auction as per consentManagement config.", e), "function" == typeof t.bidsBackHandler ? t.bidsBackHandler() : d.logError("Error executing bidsBackHandler")) : i.apply(o, a));
    }

    function P(n) {
      (n = n.gdpr || n.usp ? n.gdpr : n) && "object" === s(n) ? (d.isStr(n.cmpApi) ? r = n.cmpApi : (r = g, d.logInfo("consentManagement config did not specify cmp.  Using system default setting (".concat(g, ")."))), d.isNumber(n.timeout) ? c = n.timeout : (c = C, d.logInfo("consentManagement config did not specify timeout.  Using system default setting (".concat(C, ")."))), "boolean" == typeof n.allowAuctionWithoutConsent && (b.value = n.allowAuctionWithoutConsent, b.definedInConfig = !0), l = !0 === n.defaultGdprScope, d.logInfo("consentManagement module has been activated..."), "static" === r && (d.isPlainObject(n.consentData) ? (f = n.consentData, c = 0) : d.logError("consentManagement config with cmpApi: 'static' did not specify consentData. No consents will be available to adapters.")), y || pbjs.requestBids.before(D, 50), y = !0) : d.logWarn("consentManagement config not defined, exiting consent manager");
    }

    o.b.getConfig("consentManagement", function (n) {
      return P(n.consentManagement);
    });
  }
}, [346]);
pbjsChunk([253], {
  354: function _(n, t, e) {
    n.exports = e(355);
  },
  355: function _(n, t, e) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), e.d(t, "consentAPI", function () {
      return s;
    }), e.d(t, "consentTimeout", function () {
      return c;
    }), e.d(t, "staticConsentData", function () {
      return r;
    }), t.requestBidsHook = g, t.resetConsentData = function () {
      u = void 0, s = void 0, a.uspDataHandler.setConsentData(null);
    }, t.setConsentConfig = y;
    var i = e(0),
        t = e(3),
        a = e(7);

    function o(n) {
      return (o = "function" == typeof Symbol && "symbol" == (0, _typeof2.default)(Symbol.iterator) ? function (n) {
        return (0, _typeof2.default)(n);
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : (0, _typeof2.default)(n);
      })(n);
    }

    var s,
        c,
        r,
        u,
        l = "iab",
        d = 50,
        p = !1,
        f = {
      iab: function iab(a, o, i) {
        var t,
            e = function () {
          var e = {};
          return {
            consentDataCallback: function consentDataCallback(n, t) {
              t && n.uspString && (e.usPrivacy = n.uspString), e.usPrivacy ? a(e, i) : o("Unable to get USP consent string.", i);
            }
          };
        }(),
            s = {};

        try {
          window.__uspapi("getUSPData", 1, e.consentDataCallback);
        } catch (n) {
          for (var c = window; !t;) {
            try {
              c.frames.__uspapiLocator && (t = c);
            } catch (n) {}

            if (c === window.top) break;
            c = c.parent;
          }

          if (!t) return o("USP CMP not found.", i);
          !function (n, o, e) {
            function a(n) {
              n = n && n.data && n.data.__uspapiReturn;
              n && n.callId && void 0 !== s[n.callId] && (s[n.callId](n.returnValue, n.success), delete s[n.callId]);
            }

            window.__uspapi = function (n, t, e) {
              var a = Math.random() + "",
                  t = {
                __uspapiCall: {
                  command: n,
                  version: t,
                  callId: a
                }
              };
              s[a] = e, o.postMessage(t, "*");
            }, window.addEventListener("message", a, !1), window.__uspapi(n, 1, function (n, t) {
              window.removeEventListener("message", a, !1), e(n, t);
            });
          }("getUSPData", t, e.consentDataCallback);
        }
      },
      static: function _static(n, t, e) {
        n(r, e);
      }
    };

    function g(n, t) {
      t = {
        context: this,
        args: [t],
        nextFn: n,
        adUnits: t.adUnits || pbjs.adUnits,
        bidsBackHandler: t.bidsBackHandler,
        haveExited: !1,
        timer: null
      };
      if (!f[s]) return i.logWarn("USP framework (".concat(s, ") is not a supported framework. Aborting consentManagement module and resuming auction.")), t.nextFn.apply(t.context, t.args);
      f[s].call(this, m, b, t), t.haveExited || (0 === c ? m(void 0, t) : t.timer = setTimeout(function (n) {
        b("USPAPI workflow exceeded timeout threshold.", n);
      }.bind(null, t), c));
    }

    function m(n, t) {
      var e;
      !n || !n.usPrivacy ? b("USPAPI returned unexpected value during lookup process.", t, n) : (clearTimeout(t.timer), (e = n) && e.usPrivacy && (u = e.usPrivacy, a.uspDataHandler.setConsentData(u)), v(null, t));
    }

    function b(n, t, e) {
      clearTimeout(t.timer), v(n, t, e);
    }

    function v(n, t, e) {
      var a, o;
      !1 === t.haveExited && (t.haveExited = !0, a = t.context, o = t.args, t = t.nextFn, n && i.logWarn(n + " Resuming auction without consent data as per consentManagement config.", e), t.apply(a, o));
    }

    function y(n) {
      (n = n.usp) && "object" === o(n) ? (i.isStr(n.cmpApi) ? s = n.cmpApi : (s = l, i.logInfo("consentManagement.usp config did not specify cmpApi. Using system default setting (".concat(l, ")."))), i.isNumber(n.timeout) ? c = n.timeout : (c = d, i.logInfo("consentManagement.usp config did not specify timeout. Using system default setting (".concat(d, ")."))), i.logInfo("USPAPI consentManagement module has been activated..."), "static" === s && (i.isPlainObject(n.consentData) && i.isPlainObject(n.consentData.getUSPData) ? (n.consentData.getUSPData.uspString && (r = {
        usPrivacy: n.consentData.getUSPData.uspString
      }), c = 0) : i.logError("consentManagement config with cmpApi: 'static' did not specify consentData. No consents will be available to adapters.")), p || pbjs.requestBids.before(g, 50), p = !0) : i.logWarn("consentManagement.usp config not defined, exiting usp consent manager");
    }

    t.b.getConfig("consentManagement", function (n) {
      return y(n.consentManagement);
    });
  }
}, [354]);
pbjsChunk([233], {
  401: function _(e, r, t) {
    e.exports = t(402);
  },
  402: function _(e, r, t) {
    "use strict";

    Object.defineProperty(r, "__esModule", {
      value: !0
    }), t.d(r, "emxAdapter", function () {
      return l;
    }), t.d(r, "spec", function () {
      return m;
    });
    var d = t(0),
        i = t(1),
        o = t(2),
        n = t(11),
        r = t(12),
        a = t.n(r),
        r = t(10),
        s = t.n(r),
        u = t(3);

    function p() {
      return (p = Object.assign || function (e) {
        for (var r = 1; r < arguments.length; r++) {
          var t,
              i = arguments[r];

          for (t in i) {
            Object.prototype.hasOwnProperty.call(i, t) && (e[t] = i[t]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var c = "emx_digital",
        g = "https://js.brealtime.com/outstream/1.30.0/bundle.js",
        l = {
      validateSizes: function validateSizes(e) {
        return d.isArray(e) && void 0 !== e[0] ? e.every(function (e) {
          return d.isArray(e) && 2 === e.length;
        }) : (d.logWarn(c + ": Sizes should be an array"), !1);
      },
      checkVideoContext: function checkVideoContext(e) {
        return e && e.mediaTypes && e.mediaTypes.video && e.mediaTypes.video.context && ("instream" === e.mediaTypes.video.context || "outstream" === e.mediaTypes.video.context);
      },
      buildBanner: function buildBanner(e) {
        var r = [],
            r = (e.mediaTypes && e.mediaTypes.banner && e.mediaTypes.banner.sizes ? e.mediaTypes.banner : e).sizes;
        return l.validateSizes(r) || (d.logWarn(c + ": could not detect mediaType banner sizes. Assigning to bid sizes instead"), r = e.sizes), {
          format: r.map(function (e) {
            return {
              w: e[0],
              h: e[1]
            };
          }),
          w: r[0][0],
          h: r[0][1]
        };
      },
      formatVideoResponse: function formatVideoResponse(r, e, t) {
        return r.vastXml = e.adm, t.bidderRequest && t.bidderRequest.bids && 0 < t.bidderRequest.bids.length && s()(t.bidderRequest.bids, function (e) {
          return r.requestId && e.bidId && r.requestId === e.bidId && e.mediaTypes && e.mediaTypes.video && "outstream" === e.mediaTypes.video.context;
        }) && (r.renderer = l.createRenderer(r, {
          id: e.id,
          url: g
        })), r;
      },
      isMobile: function isMobile() {
        return /(ios|ipod|ipad|iphone|android)/i.test(navigator.userAgent);
      },
      isConnectedTV: function isConnectedTV() {
        return /(smart[-]?tv|hbbtv|appletv|googletv|hdmi|netcast\.tv|viera|nettv|roku|\bdtv\b|sonydtv|inettvbrowser|\btv\b)/i.test(navigator.userAgent);
      },
      getDevice: function getDevice() {
        return {
          ua: navigator.userAgent,
          js: 1,
          dnt: "yes" === navigator.doNotTrack || "1" === navigator.doNotTrack || "1" === navigator.msDoNotTrack ? 1 : 0,
          h: screen.height,
          w: screen.width,
          devicetype: l.isMobile() ? 1 : l.isConnectedTV() ? 3 : 2,
          language: navigator.language || navigator.browserLanguage || navigator.userLanguage || navigator.systemLanguage
        };
      },
      cleanProtocols: function cleanProtocols(e) {
        return e.protocols && a()(e.protocols, 7) && (d.logWarn(c + ": VAST 4.0 is currently not supported. This protocol has been filtered out of the request."), e.protocols = e.protocols.filter(function (e) {
          return 7 !== e;
        })), e;
      },
      outstreamRender: function outstreamRender(r) {
        r.renderer.push(function () {
          var e = r && r.params && r.params[0] && r.params[0].video ? r.params[0].video : {};
          window.emxVideoQueue = window.emxVideoQueue || [], window.queueEmxVideo({
            id: r.adUnitCode,
            adsResponses: r.vastXml,
            options: e
          }), window.emxVideoReady && window.videojs && window.emxVideoReady();
        });
      },
      createRenderer: function createRenderer(e, r) {
        r = n.a.install({
          id: r.id,
          url: g,
          loaded: !1
        });

        try {
          r.setRender(l.outstreamRender);
        } catch (e) {
          d.logWarn("Prebid Error calling setRender on renderer", e);
        }

        return r;
      },
      buildVideo: function buildVideo(e) {
        var r = p(e.mediaTypes.video, e.params.video);
        return d.isArray(e.mediaTypes.video.playerSize[0]) ? (r.w = e.mediaTypes.video.playerSize[0][0], r.h = e.mediaTypes.video.playerSize[0][1]) : (r.w = e.mediaTypes.video.playerSize[0], r.h = e.mediaTypes.video.playerSize[1]), l.cleanProtocols(r);
      },
      parseResponse: function parseResponse(e) {
        try {
          return decodeURIComponent(e.replace(/%(?![0-9][0-9a-fA-F]+)/g, "%25"));
        } catch (e) {
          d.logError("emx_digitalBidAdapter", "error", e);
        }
      },
      getReferrer: function getReferrer() {
        try {
          return u.b.getConfig("pageUrl") || window.location.href;
        } catch (e) {
          return "";
        }
      },
      getSite: function getSite(e) {
        return {
          domain: d.parseUrl(e.referer).hostname,
          page: e.referer,
          ref: l.getReferrer()
        };
      },
      getGdpr: function getGdpr(e, r) {
        return e.gdprConsent && (r.regs = {
          ext: {
            gdpr: !0 === e.gdprConsent.gdprApplies ? 1 : 0
          }
        }), e.gdprConsent && e.gdprConsent.gdprApplies && (r.user = {
          ext: {
            consent: e.gdprConsent.consentString
          }
        }), r;
      }
    },
        m = {
      code: c,
      gvlid: 183,
      supportedMediaTypes: [o.b, o.d],
      isBidRequestValid: function isBidRequestValid(e) {
        if (!e || !e.params) return d.logWarn(c + ": Missing bid or bid params."), !1;
        if (e.bidder !== c) return d.logWarn(c + ': Must use "emx_digital" as bidder code.'), !1;
        if (!e.params.tagid || !d.isStr(e.params.tagid)) return d.logWarn(c + ": Missing tagid param or tagid present and not type String."), !1;

        if (e.mediaTypes && e.mediaTypes.banner) {
          var r = e.mediaTypes.banner.sizes || e.sizes;
          if (!l.validateSizes(r)) return d.logWarn(c + ": Missing sizes in bid"), !1;
        } else if (e.mediaTypes && e.mediaTypes.video) {
          if (!l.checkVideoContext(e)) return d.logWarn(c + ": Missing video context: instream or outstream"), !1;
          if (!e.mediaTypes.video.playerSize) return d.logWarn(c + ": Missing video playerSize"), !1;
        }

        return !0;
      },
      buildRequests: function buildRequests(e, r) {
        var n = [],
            t = "https://hb.emxdgt.com?t=" + (r.timeout || "") + "&ts=" + Date.now() + "&src=pbjs",
            o = -1 < location.protocol.indexOf("https") ? 1 : 0,
            i = l.getDevice(),
            a = l.getSite(r.refererInfo);

        d._each(e, function (e) {
          var r = d.getBidIdParameter("tagid", e.params),
              t = parseFloat(d.getBidIdParameter("bidfloor", e.params)) || 0,
              i = !!e.mediaTypes.video,
              t = p({
            id: e.bidId,
            tid: e.transactionId,
            tagid: r,
            secure: o
          }, i ? {
            video: l.buildVideo(e)
          } : {
            banner: l.buildBanner(e)
          }, 0 < t ? {
            bidfloor: t,
            bidfloorcur: "USD"
          } : {});
          n.push(t);
        });

        a = {
          id: r.auctionId,
          imp: n,
          device: i,
          site: a,
          cur: "USD",
          version: "1.5.1"
        }, a = l.getGdpr(r, p({}, a));
        return r && r.uspConsent && (a.us_privacy = r.uspConsent), {
          method: "POST",
          url: t,
          data: JSON.stringify(a),
          options: {
            withCredentials: !0
          },
          bidderRequest: r
        };
      },
      interpretResponse: function interpretResponse(e, i) {
        var n = [],
            e = e.body || {};
        return e.seatbid && 0 < e.seatbid.length && e.seatbid[0].bid && e.seatbid.forEach(function (e) {
          e = e.bid[0];
          var r = !1,
              t = l.parseResponse(e.adm) || "",
              t = {
            requestId: e.id,
            cpm: e.price,
            width: e.w,
            height: e.h,
            creativeId: e.crid || e.id,
            dealId: e.dealid || null,
            currency: "USD",
            netRevenue: !0,
            ttl: e.ttl,
            ad: t
          };
          e.adm && -1 < e.adm.indexOf("<?xml version=") && (r = !0, t = l.formatVideoResponse(t, p({}, e), i)), t.mediaType = r ? o.d : o.b, n.push(t);
        }), n;
      },
      getUserSyncs: function getUserSyncs(e, r, t, i) {
        var n = [];
        return e.iframeEnabled && (e = "https://biddr.brealtime.com/check.html", t && "string" == typeof t.consentString && ("boolean" == typeof t.gdprApplies ? e += "?gdpr=".concat(Number(t.gdprApplies), "&gdpr_consent=").concat(t.consentString) : e += "?gdpr_consent=".concat(t.consentString)), n.push({
          type: "iframe",
          url: e
        })), n;
      }
    };
    Object(i.registerBidder)(m);
  }
}, [401]);
pbjsChunk([156], {
  582: function _(e, t, n) {
    e.exports = n(583);
  },
  583: function _(e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n.d(t, "USER_ID_CODE_TO_QUERY_ARG", function () {
      return u;
    }), n.d(t, "spec", function () {
      return m;
    });
    var o = n(3),
        t = n(1),
        c = n(0),
        d = n(2);

    function i(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              r = !0,
              i = !1,
              a = void 0;

          try {
            for (var s, o = e[Symbol.iterator](); !(r = (s = o.next()).done) && (n.push(s.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            i = !0, a = e;
          } finally {
            try {
              r || null == o.return || o.return();
            } finally {
              if (i) throw a;
            }
          }

          return n;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return r(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Map" === (n = "Object" === n && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function r(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var n = [d.b, d.d],
        a = "hb_pb",
        s = "3.0.3",
        p = "USD",
        u = {
      britepoolid: "britepoolid",
      criteoId: "criteoid",
      digitrustid: "digitrustid",
      id5id: "id5id",
      idl_env: "lre",
      lipb: "lipbid",
      netId: "netid",
      parrableId: "parrableid",
      pubcid: "pubcid",
      tdid: "ttduuid"
    },
        m = {
      code: "openx",
      gvlid: 69,
      supportedMediaTypes: n,
      isBidRequestValid: function isBidRequestValid(e) {
        var t = e.params.delDomain || e.params.platform;
        return c.deepAccess(e, "mediaTypes.banner") && t ? !!e.params.unit || 0 < c.deepAccess(e, "mediaTypes.banner.sizes.length") : !(!e.params.unit || !t);
      },
      buildRequests: function buildRequests(e, t) {
        if (0 === e.length) return [];
        var n = [],
            r = i(e.reduce(function (e, t) {
          var n;
          return n = t, (c.deepAccess(n, "mediaTypes.video") && !c.deepAccess(n, "mediaTypes.banner") || n.mediaType === d.d ? e[0] : e[1]).push(t), e;
        }, [[], []]), 2),
            e = r[0],
            r = r[1];
        return 0 < r.length && n.push(function (e, t) {
          var n = [],
              r = !1,
              i = l(e, t),
              t = c._map(e, function (e) {
            return e.params.unit;
          });

          i.aus = c._map(e, function (e) {
            return c.parseSizesInput(e.mediaTypes.banner.sizes).join(",");
          }).join("|"), i.divIds = c._map(e, function (e) {
            return encodeURIComponent(e.adUnitCode);
          }).join(","), t.some(function (e) {
            return e;
          }) && (i.auid = t.join(","));
          e.some(function (e) {
            return e.params.doNotTrack;
          }) && (i.ns = 1);
          !0 !== o.b.getConfig("coppa") && !e.some(function (e) {
            return e.params.coppa;
          }) || (i.tfcd = 1);
          e.forEach(function (t) {
            var e;
            t.params.customParams ? (e = c._map(Object.keys(t.params.customParams), function (e) {
              return function (e, t) {
                t = t[e];
                c.isArray(t) && (t = t.join(","));
                return (e.toLowerCase() + "=" + t.toLowerCase()).replace("+", ".").replace("/", "_");
              }(e, t.params.customParams);
            }), e = window.btoa(e.join("&")), r = !0, n.push(e)) : n.push("");
          }), r && (i.tps = n.join(","));
          var a = [],
              s = !1;
          e.forEach(function (e) {
            e = function (e, t) {
              var n = {},
                  r = o.b.getConfig("currency.adServerCurrency") || p;
              "function" == typeof e.getFloor && (n = e.getFloor({
                currency: r,
                mediaType: t,
                size: "*"
              }));
              e = n.floor || e.params.customFloor || 0;
              return Math.round(1e3 * e);
            }(e, d.b);

            e ? (a.push(e), s = !0) : a.push(0);
          }), s && (i.aumfs = a.join(","));
          return {
            method: "GET",
            url: i.ph ? "https://u.openx.net/w/1.0/arj" : "https://".concat(e[0].params.delDomain, "/w/1.0/arj"),
            data: i,
            payload: {
              bids: e,
              startTime: new Date()
            }
          };
        }(r, t)), 0 < e.length && e.forEach(function (e) {
          n.push(function (e, t) {
            t = function (e, t) {
              var n,
                  r,
                  i = l([e], t),
                  a = c.deepAccess(e, "params.video") || {},
                  s = c.deepAccess(e, "mediaTypes.video.context"),
                  t = c.deepAccess(e, "mediaTypes.video.playerSize");
              c.isArray(e.sizes) && 2 === e.sizes.length && !c.isArray(e.sizes[0]) ? (n = parseInt(e.sizes[0], 10), r = parseInt(e.sizes[1], 10)) : c.isArray(e.sizes) && c.isArray(e.sizes[0]) && 2 === e.sizes[0].length ? (n = parseInt(e.sizes[0][0], 10), r = parseInt(e.sizes[0][1], 10)) : c.isArray(t) && 2 === t.length && (n = parseInt(t[0], 10), r = parseInt(t[1], 10));
              Object.keys(a).forEach(function (e) {
                "openrtb" === e ? (a[e].w = n || a[e].w, a[e].v = r || a[e].v, i[e] = JSON.stringify(a[e])) : e in i || "url" === e || (i[e] = a[e]);
              }), i.auid = e.params.unit, i.vwd = n || a.vwd, i.vht = r || a.vht, "outstream" === s && (i.vos = "101");
              a.mimes && (i.vmimes = a.mimes);
              e.params.test && (i.vtest = 1);
              return i;
            }(e, t);

            return {
              method: "GET",
              url: t.ph ? "https://u.openx.net/v/1.0/avjp" : "https://".concat(e.params.delDomain, "/v/1.0/avjp"),
              data: t,
              payload: {
                bid: e,
                startTime: new Date()
              }
            };
          }(e, t));
        }), n;
      },
      interpretResponse: function interpretResponse(e, t) {
        e = e.body;
        return ((/avjp$/.test(t.url) ? d.d : d.b) === d.d ? function (e, t) {
          var n = t.bid,
              r = (t.startTime, []);
          {
            var i;
            void 0 !== e && "" !== e.vastUrl && 0 < e.pub_rev && (i = c.parseUrl(e.vastUrl).search || {}, (t = {}).requestId = n.bidId, t.ttl = 300, t.netRevenue = !0, t.currency = e.currency, t.cpm = parseInt(e.pub_rev, 10) / 1e3, t.width = parseInt(e.width, 10), t.height = parseInt(e.height, 10), t.creativeId = e.adid, t.vastUrl = e.vastUrl, t.mediaType = d.d, e.ph = i.ph, e.colo = i.colo, e.ts = i.ts, r.push(t));
          }
          return r;
        } : function (e, t) {
          for (var n = t.bids, r = (t.startTime, e.ads.ad), i = [], a = 0; a < r.length; a++) {
            var s = r[a],
                o = parseInt(s.idx, 10),
                c = {};
            c.requestId = n[o].bidId, s.pub_rev && (c.cpm = Number(s.pub_rev) / 1e3, (o = s.creative[0]) && (c.width = o.width, c.height = o.height), c.creativeId = o.id, c.ad = s.html, s.deal_id && (c.dealId = s.deal_id), c.ttl = 300, c.netRevenue = !0, c.currency = s.currency, s.tbd && (c.tbd = s.tbd), c.ts = s.ts, c.meta = {}, s.brand_id && (c.meta.brandId = s.brand_id), s.adv_id && (c.meta.dspid = s.adv_id), i.push(c));
          }

          return i;
        })(e, t.payload);
      },
      getUserSyncs: function getUserSyncs(e, t, n, r) {
        if (e.iframeEnabled || e.pixelEnabled) return [{
          type: e.iframeEnabled ? "iframe" : "image",
          url: c.deepAccess(t, "0.body.ads.pixels") || c.deepAccess(t, "0.body.pixels") || function (e, t) {
            var n = [];
            e && (n.push("gdpr=" + (e.gdprApplies ? 1 : 0)), n.push("gdpr_consent=" + encodeURIComponent(e.consentString || "")));
            t && n.push("us_privacy=" + encodeURIComponent(t));
            return "".concat("https://u.openx.net/w/1.0/pd").concat(0 < n.length ? "?" + n.join("&") : "");
          }(n, r)
        }];
      },
      transformBidParams: function transformBidParams(e, t) {
        return c.convertTypes({
          unit: "string",
          customFloor: "number"
        }, e);
      }
    };

    function l(e, t) {
      var r,
          n = c.inIframe(),
          i = {
        ju: o.b.getConfig("pageUrl") || t.refererInfo.referer,
        ch: document.charSet || document.characterSet,
        res: "".concat(screen.width, "x").concat(screen.height, "x").concat(screen.colorDepth),
        ifr: n,
        tz: new Date().getTimezoneOffset(),
        tws: function (e) {
          var t,
              n,
              r = window,
              i = document,
              a = i.documentElement;

          if (e) {
            try {
              r = window.top, i = window.top.document;
            } catch (e) {
              return;
            }

            a = i.documentElement, n = i.body, t = r.innerWidth || a.clientWidth || n.clientWidth, n = r.innerHeight || a.clientHeight || n.clientHeight;
          } else a = i.documentElement, t = r.innerWidth || a.clientWidth, n = r.innerHeight || a.clientHeight;

          return "".concat(t, "x").concat(n);
        }(n),
        be: 1,
        bc: e[0].params.bc || "".concat(a, "_").concat(s),
        dddid: c._map(e, function (e) {
          return e.transactionId;
        }).join(","),
        nocache: new Date().getTime()
      };
      return e[0].params.platform && (i.ph = e[0].params.platform), t.gdprConsent && (void 0 !== (n = t.gdprConsent).consentString && (i.gdpr_consent = n.consentString), void 0 !== n.gdprApplies && (i.gdpr = n.gdprApplies ? 1 : 0), "iab" === o.b.getConfig("consentManagement.cmpApi") && (i.x_gdpr_f = 1)), t && t.uspConsent && (i.us_privacy = t.uspConsent), c.deepAccess(e[0], "crumbs.pubcid") && c.deepSetValue(e[0], "userId.pubcid", c.deepAccess(e[0], "crumbs.pubcid")), r = i, t = e[0].userId, c._each(t, function (e, t) {
        var n = u[t];
        if (u.hasOwnProperty(t)) switch (t) {
          case "digitrustid":
            r[n] = c.deepAccess(e, "data.id");
            break;

          case "lipb":
            r[n] = e.lipbid;
            break;

          case "parrableId":
            r[n] = e.eid;
            break;

          default:
            r[n] = e;
        }
      }), i = r, e[0].schain && (i.schain = (e = e[0].schain, "".concat(e.ver, ",").concat(e.complete, "!").concat(function (e) {
        var n = ["asi", "sid", "hp", "rid", "name", "domain"];
        return e.map(function (t) {
          return n.map(function (e) {
            return t[e] || "";
          }).join(",");
        }).join("!");
      }(e.nodes)))), i;
    }

    Object(t.registerBidder)(m);
  }
}, [582]);
pbjsChunk([137], {
  635: function _(e, r, t) {
    e.exports = t(636);
  },
  636: function _(e, r, t) {
    "use strict";

    Object.defineProperty(r, "__esModule", {
      value: !0
    }), t.d(r, "spec", function () {
      return n;
    });
    var d = t(0),
        r = t(1),
        u = t(11),
        a = t(3);

    function s() {
      return (s = Object.assign || function (e) {
        for (var r = 1; r < arguments.length; r++) {
          var t,
              n = arguments[r];

          for (t in n) {
            Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var o = {
      TITLE_LEN: 100,
      DESCR_LEN: 200,
      SPONSORED_BY_LEN: 50,
      IMG_MIN: 150,
      ICON_MIN: 50
    },
        c = ["cp", "ct", "cf", "video", "battr", "bcat", "badv", "bidfloor"],
        n = {
      code: "pulsepoint",
      gvlid: 81,
      aliases: ["pulseLite", "pulsepointLite"],
      supportedMediaTypes: ["banner", "native", "video"],
      isBidRequestValid: function isBidRequestValid(e) {
        return !!(e && e.params && e.params.cp && e.params.ct);
      },
      buildRequests: function buildRequests(e, r) {
        var t, n, i;
        return {
          method: "POST",
          url: "https://bid.contextweb.com/header/ortb?src=prebid",
          data: {
            id: e[0].bidderRequestId,
            imp: e.map(function (e) {
              return {
                id: (e = e).bidId,
                banner: function (e) {
                  var r = function (e) {
                    e = d.deepAccess(e, "mediaTypes.banner.sizes");
                    if (e && d.isArray(e)) return e.filter(function (e) {
                      return d.isArray(e) && 2 === e.length;
                    }).map(function (e) {
                      return {
                        w: e[0],
                        h: e[1]
                      };
                    });
                    return null;
                  }(e),
                      t = function (e, r) {
                    {
                      if (e.params.cf) {
                        var t = e.params.cf.toUpperCase().split("X"),
                            n = parseInt(e.params.cw || t[0], 10),
                            t = parseInt(e.params.ch || t[1], 10);
                        return [n, t];
                      }

                      if (r && 0 < r.length) return [r[0].w, r[0].h];
                    }
                    return [1, 1];
                  }(e, r);

                  return e.nativeParams || e.params.video ? null : {
                    w: t[0],
                    h: t[1],
                    battr: e.params.battr,
                    format: r
                  };
                }(e),
                native: function (e) {
                  if (e.nativeParams) {
                    var r = [];
                    return p(r, function (e, r, t) {
                      if (r) return {
                        id: e,
                        required: r.required ? 1 : 0,
                        title: {
                          len: r.len || t
                        }
                      };
                      return null;
                    }(r.length + 1, e.nativeParams.title, o.TITLE_LEN)), p(r, f(r.length + 1, e.nativeParams.body, 2, o.DESCR_LEN)), p(r, f(r.length + 1, e.nativeParams.sponsoredBy, 1, o.SPONSORED_BY_LEN)), p(r, l(r.length + 1, e.nativeParams.icon, 1, o.ICON_MIN, o.ICON_MIN)), p(r, l(r.length + 1, e.nativeParams.image, 3, o.IMG_MIN, o.IMG_MIN)), {
                      request: JSON.stringify({
                        assets: r
                      }),
                      ver: "1.1",
                      battr: e.params.battr
                    };
                  }

                  return null;
                }(e),
                tagid: e.params.ct.toString(),
                video: function (e) {
                  if (e.params.video) return s({}, e.params.video, {
                    battr: e.params.battr
                  });
                  return null;
                }(e),
                bidfloor: e.params.bidfloor,
                ext: function (r) {
                  var t = {},
                      n = {};
                  return c.forEach(function (e) {
                    return n[e] = 1;
                  }), Object.keys(r.params).forEach(function (e) {
                    n[e] || (t[e] = r.params[e]);
                  }), 0 < Object.keys(t).length ? {
                    prebid: t
                  } : null;
                }(e)
              };
            }),
            site: (n = r, i = (t = e) && 0 < t.length ? t[0].params.cp : "0", t[0].params.app ? null : {
              publisher: {
                id: i.toString()
              },
              ref: function () {
                try {
                  return a.b.getConfig("pageUrl") || window.location.href;
                } catch (e) {
                  return "";
                }
              }(),
              page: n && n.refererInfo ? n.refererInfo.referer : ""
            }),
            app: function (e) {
              var r = e && 0 < e.length ? e[0].params.cp : "0",
                  e = e[0].params.app;
              if (e) return {
                publisher: {
                  id: r.toString()
                },
                bundle: e.bundle,
                storeurl: e.storeUrl,
                domain: e.domain
              };
              return null;
            }(e),
            device: {
              ua: navigator.userAgent,
              language: navigator.language || navigator.browserLanguage || navigator.userLanguage || navigator.systemLanguage
            },
            bcat: e[0].params.bcat,
            badv: e[0].params.badv,
            user: function (e, r) {
              var t = {};
              r && r.gdprConsent && (t.consent = r.gdprConsent.consentString);
              e && e.userId && (t.eids = [], m(t.eids, e.userId.pubcid, "pubcommon"), m(t.eids, e.userId.britepoolid, "britepool.com"), m(t.eids, e.userId.criteoId, "criteo"), m(t.eids, e.userId.idl_env, "identityLink"), m(t.eids, e.userId.id5id, "id5-sync.com"), m(t.eids, d.deepAccess(e, "userId.parrableId.eid"), "parrable.com"), e.userId.lipb && e.userId.lipb.lipbid && m(t.eids, e.userId.lipb.lipbid, "liveintent.com"), m(t.eids, e.userId.tdid, "adserver.org", {
                rtiPartner: "TDID"
              }), (r = e.userId.digitrustid) && r.data && (e = {}, r.data.id && (e.id = r.data.id), r.data.keyv && (e.keyv = r.data.keyv), t.digitrust = e));
              return {
                ext: t
              };
            }(e[0], r),
            regs: function (e) {
              if (e.gdprConsent || e.uspConsent) {
                var r = {};
                return e.gdprConsent && (r.gdpr = e.gdprConsent.gdprApplies ? 1 : 0), e.uspConsent && (r.us_privacy = e.uspConsent), {
                  ext: r
                };
              }

              return null;
            }(r),
            source: function (e) {
              if (e) return {
                ext: {
                  schain: e
                }
              };
              return null;
            }(e[0].schain)
          },
          bidderRequest: r
        };
      },
      interpretResponse: function interpretResponse(e, r) {
        return function (e, r) {
          var t = {},
              n = {},
              i = {},
              a = r.body;
          e.data.imp.forEach(function (e) {
            t[e.id] = e;
          }), a && a.seatbid.forEach(function (e) {
            return e.bid.forEach(function (e) {
              n[e.impid] = e;
            });
          });
          e.bidderRequest && e.bidderRequest.bids && e.bidderRequest.bids.forEach(function (e) {
            i[e.bidId] = e;
          });
          var s = [];
          return Object.keys(t).forEach(function (e) {
            var r;
            n[e] && (r = {
              requestId: e,
              cpm: n[e].price,
              creative_id: n[e].crid,
              creativeId: n[e].crid,
              adId: e,
              ttl: n[e].exp || 20,
              netRevenue: !0,
              currency: a.cur || "USD"
            }, t[e].native ? (r.native = function (e, r) {
              if (e.native) {
                var r = function (e) {
                  try {
                    if (e) return JSON.parse(e);
                  } catch (e) {
                    d.logError("pulsepointLite.safeParse", "ERROR", e);
                  }

                  return null;
                }(r.adm),
                    t = {};

                if (r && r.native && r.native.assets) return r.native.assets.forEach(function (e) {
                  t.title = e.title ? e.title.text : t.title, t.body = e.data && 2 === e.data.type ? e.data.value : t.body, t.sponsoredBy = e.data && 1 === e.data.type ? e.data.value : t.sponsoredBy, t.image = e.img && 3 === e.img.type ? e.img.url : t.image, t.icon = e.img && 1 === e.img.type ? e.img.url : t.icon;
                }), r.native.link && (t.clickUrl = encodeURIComponent(r.native.link.url)), t.impressionTrackers = r.native.imptrackers, t;
              }

              return null;
            }(t[e], n[e]), r.mediaType = "native") : t[e].video ? (i[e] && "outstream" === d.deepAccess(i[e], "mediaTypes.video.context") && (r.renderer = function (t, e) {
              e = u.a.install({
                url: e.rendererUrl,
                config: {
                  defaultOptions: e.config,
                  rendererOptions: t,
                  type: e.type
                },
                loaded: !1
              });
              return e.setRender(function (r) {
                r.renderer.push(function () {
                  var e = r.renderer.getConfig();
                  new window.PulsePointOutstreamRenderer().render({
                    adUnitCode: r.adUnitCode,
                    vastXml: r.vastXml,
                    type: e.type,
                    defaultOptions: e.defaultOptions,
                    rendererOptions: t
                  });
                });
              }), e;
            }(d.deepAccess(i[e], "renderer.options"), d.deepAccess(n[e], "ext.outstream"))), r.vastXml = n[e].adm, r.mediaType = "video", r.width = n[e].w, r.height = n[e].h) : (r.ad = n[e].adm, r.width = n[e].w || t[e].banner.w, r.height = n[e].h || t[e].banner.h), s.push(r));
          }), s;
        }(r, e);
      },
      getUserSyncs: function getUserSyncs(e) {
        return e.iframeEnabled ? [{
          type: "iframe",
          url: "https://bh.contextweb.com/visitormatch"
        }] : e.pixelEnabled ? [{
          type: "image",
          url: "https://bh.contextweb.com/visitormatch/prebid"
        }] : void 0;
      },
      transformBidParams: function transformBidParams(e, r) {
        return d.convertTypes({
          cf: "string",
          cp: "number",
          ct: "number"
        }, e);
      }
    };

    function p(e, r) {
      r && e.push(r);
    }

    function l(e, r, t, n, i) {
      return r ? {
        id: e,
        required: r.required ? 1 : 0,
        img: {
          type: t,
          wmin: r.wmin || n,
          hmin: r.hmin || i
        }
      } : null;
    }

    function f(e, r, t, n) {
      return r ? {
        id: e,
        required: r.required ? 1 : 0,
        data: {
          type: t,
          len: r.len || n
        }
      } : null;
    }

    function m(e, r, t, n) {
      r && (r = {
        id: r
      }, n && (r.ext = n), e.push({
        source: t,
        uids: [r]
      }));
    }

    Object(r.registerBidder)(n);
  }
}, [635]);
pbjsChunk([125], {
  661: function _(e, r, a) {
    e.exports = a(662);
  },
  662: function _(e, r, a) {
    "use strict";

    Object.defineProperty(r, "__esModule", {
      value: !0
    }), a.d(r, "spec", function () {
      return s;
    });
    var f = a(0),
        r = a(1),
        t = a(2);
    var s = new function () {
      this.code = "rhythmone", this.supportedMediaTypes = [t.d, t.b];
      var p = [2, 3, 5, 6],
          o = ["video/mp4"],
          c = [1, 2, 3, 4],
          m = [1],
          l = [1, 2, 5],
          u = {},
          h = this;

      function i(e, r) {
        var a,
            t = [],
            s = 0;
        r && r.refererInfo && r.refererInfo.stack.length && ((a = document.createElement("a")).href = r.refererInfo.stack[0], s = "https:" == a.protocol ? 1 : 0);

        for (var i = 0; i < e.length; i++) {
          u[e[i].adUnitCode] = e[i];
          var n,
              d = {};
          d.id = e[i].adUnitCode, d.bidfloor = parseFloat(f.deepAccess(e[i], "params.floor")) || 0, d.secure = s, !f.deepAccess(e[i], "mediaTypes.banner") && "banner" !== f.deepAccess(e[i], "mediaType") || (n = function (e) {
            var r = e.sizes;
            e.mediaTypes && e.mediaTypes.banner && (r = e.mediaTypes.banner.sizes);
            var r = f.parseSizesInput(r),
                a = [];
            if (r.forEach(function (e) {
              !e || (e = v(e.split("x"))) && a.push({
                w: e[0],
                h: e[1]
              });
            }), a.length) return {
              format: a
            };
            return !1;
          }(e[i])) && (d.banner = n), !f.deepAccess(e[i], "mediaTypes.video") && "video" !== f.deepAccess(e[i], "mediaType") || (d.video = function (e) {
            var r = [];
            {
              var a;
              f.deepAccess(e, "mediaTypes.video.playerSize") && (a = e.mediaTypes.video.playerSize, (a = v(a = f.isArray(e.mediaTypes.video.playerSize[0]) ? e.mediaTypes.video.playerSize[0] : a)) && (r = a));
            }
            return {
              mimes: f.deepAccess(e, "mediaTypes.video.mimes") || o,
              protocols: f.deepAccess(e, "mediaTypes.video.protocols") || p,
              w: r[0],
              h: r[1],
              startdelay: f.deepAccess(e, "mediaTypes.video.startdelay") || 0,
              skip: f.deepAccess(e, "mediaTypes.video.skip") || 0,
              playbackmethod: f.deepAccess(e, "mediaTypes.video.playbackmethod") || c,
              delivery: f.deepAccess(e, "mediaTypes.video.delivery") || m,
              api: f.deepAccess(e, "mediaTypes.video.api") || l
            };
          }(e[i])), (d.banner || d.video) && (d.ext = {
            bidder: {
              placementId: (n = e[i]).params.placementId,
              zone: n.params && n.params.zone ? n.params.zone : "1r",
              path: n.params && n.params.path ? n.params.path : "mvo"
            }
          }, t.push(d));
        }

        return t;
      }

      function v(e) {
        var r = parseInt(e[0]),
            e = parseInt(e[1]);
        return r == r && e == e && [r, e];
      }

      function n(e, r) {
        var a,
            t,
            s,
            r = {
          id: e[0].bidderRequestId,
          imp: i(e, r),
          site: (s = {
            domain: "",
            page: "",
            ref: ""
          }, (a = r) && a.refererInfo && (t = a.refererInfo, s.ref = t.referer, t.stack.length && (s.page = t.stack[t.stack.length - 1], (a = document.createElement("a")).href = t.stack[0], s.domain = a.hostname)), s),
          device: {
            ua: navigator.userAgent,
            ip: "",
            dnt: f.getDNT() ? 1 : 0
          },
          user: {
            ext: {
              consent: f.deepAccess(r, "gdprConsent.gdprApplies") ? r.gdprConsent.consentString : ""
            }
          },
          at: 1,
          tmax: 1e3,
          regs: {
            ext: {
              gdpr: !!f.deepAccess(r, "gdprConsent.gdprApplies") && Boolean(1 & r.gdprConsent.gdprApplies)
            }
          }
        };
        return e[0].schain && (r.source = {
          ext: {
            schain: e[0].schain
          }
        }), r;
      }

      function d(e, r) {
        for (var a = 0; a < r.length; a++) {
          if (r[a].params && r[a].params[e]) return r[a].params[e];
        }
      }

      this.isBidRequestValid = function (e) {
        return !(!e.params || !e.params.placementId);
      }, this.getUserSyncs = function (e, r, a) {
        return [];
      }, this.buildRequests = function (e, r) {
        var a = d("placementId", e);
        if (void 0 === a || e.length < 1) return [];
        var t = d("endpoint", e) || "https://tag.1rx.io/rmp/{placementId}/0/{path}?z={zone}",
            s = d("zone", e) || "1r",
            i = d("path", e) || "mvo";
        t = (t = (t = t.replace(/\{placementId\}/i, a)).replace(/\{zone\}/i, s)).replace(/\{path\}/i, i);
        i = /(^v|(\.0)+$)/gi;
        t += "&hbv=" + "4.4.0".replace(i, "") + "," + "2.1".replace(i, "");
        r = n(e, r);
        return r.imp.length ? {
          method: "POST",
          url: t,
          data: JSON.stringify(r)
        } : {};
      }, this.interpretResponse = function (e) {
        var r = e.body || [],
            a = [],
            t = 0;

        if (r.seatbid) {
          for (var s = [], t = 0; t < r.seatbid.length; t++) {
            for (var i = 0; i < r.seatbid[t].bid.length; i++) {
              s.push(r.seatbid[t].bid[i]);
            }
          }

          r = s;
        }

        for (t = 0; t < r.length; t++) {
          var n = r[t],
              d = u[n.impid],
              p = {
            requestId: d.bidId,
            bidderCode: h.code,
            cpm: parseFloat(n.price),
            width: n.w,
            height: n.h,
            creativeId: n.crid,
            currency: "USD",
            netRevenue: !0,
            ttl: 350
          };
          d.mediaTypes && d.mediaTypes.video ? (p.vastUrl = n.nurl, p.mediaType = "video", p.ttl = 600) : p.ad = n.adm, a.push(p);
        }

        return a;
      };
    }();
    Object(r.registerBidder)(s);
  }
}, [661]);
pbjsChunk([99], {
  729: function _(e, t, r) {
    e.exports = r(730);
  },
  730: function _(e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r.d(t, "spec", function () {
      return f;
    }), r.d(t, "_isInbounds", function () {
      return g;
    }), t._getPlatform = h;
    var n = r(1),
        p = r(0),
        t = r(2),
        s = r(3),
        b = r(11),
        o = r(45);

    function l(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var r = [],
              n = !0,
              i = !1,
              s = void 0;

          try {
            for (var o, a = e[Symbol.iterator](); !(n = (o = a.next()).done) && (r.push(o.value), !t || r.length !== t); n = !0) {
              ;
            }
          } catch (e) {
            i = !0, s = e;
          } finally {
            try {
              n || null == a.return || a.return();
            } finally {
              if (i) throw s;
            }
          }

          return r;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return i(e, t);
          var r = Object.prototype.toString.call(e).slice(8, -1);
          return "Map" === (r = "Object" === r && e.constructor ? e.constructor.name : r) || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? i(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function i(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }

      return n;
    }

    function a() {
      return (a = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r,
              n = arguments[t];

          for (r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function c(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    var d = "sonobi",
        u = Object(p.generateUUID)(),
        f = {
      code: d,
      supportedMediaTypes: [t.b, t.d],
      isBidRequestValid: function isBidRequestValid(e) {
        if (!e.params) return !1;
        if (!e.params.ad_unit && !e.params.placement_id) return !1;
        if (!Object(p.deepAccess)(e, "mediaTypes.banner") && !Object(p.deepAccess)(e, "mediaTypes.video")) return !1;

        if (Object(p.deepAccess)(e, "mediaTypes.banner")) {
          if (!Object(p.deepAccess)(e, "mediaTypes.banner.sizes") && !e.params.sizes) return !1;
        } else if (Object(p.deepAccess)(e, "mediaTypes.video")) {
          if ("outstream" === Object(p.deepAccess)(e, "mediaTypes.video.context") && !e.params.sizes) return !1;
          if ("instream" === Object(p.deepAccess)(e, "mediaTypes.video.context") && !Object(p.deepAccess)(e, "mediaTypes.video.playerSize")) return !1;
        }

        return !0;
      },
      buildRequests: function buildRequests(e, t) {
        var r = e.map(function (e) {
          var t = function (e) {
            if (e.params.ad_unit) return e.params.ad_unit;
            return e.params.placement_id;
          }(e);

          return /^[\/]?[\d]+[[\/].+[\/]?]?$/.test(t) ? (t = "/" === t.charAt(0) ? t : "/" + t, c({}, "".concat(t, "|").concat(e.bidId), "".concat(m(e)).concat(v(e)))) : /^[0-9a-fA-F]{20}$/.test(t) && 20 === t.length ? c({}, e.bidId, "".concat(t, "|").concat(m(e)).concat(v(e))) : void Object(p.logError)("The ad unit code or Sonobi Placement id for slot ".concat(e.bidId, " is invalid"));
        }),
            n = {};
        r.forEach(function (e) {
          a(n, e);
        });
        var i = {
          key_maker: JSON.stringify(n),
          ref: t.refererInfo.referer,
          s: Object(p.generateUUID)(),
          pv: u,
          vp: h(),
          lib_name: "prebid",
          lib_v: "4.4.0",
          us: 0
        };
        s.b.getConfig("userSync") && s.b.getConfig("userSync").syncsPerBidder && (i.us = s.b.getConfig("userSync").syncsPerBidder), o.a.canBidderRegisterSync("iframe", d) ? i.ius = 1 : i.ius = 0, Object(p.deepAccess)(e[0], "params.hfa") && (i.hfa = Object(p.deepAccess)(e[0], "params.hfa")), e[0].params.referrer && (i.ref = e[0].params.referrer), t && t.gdprConsent && (i.gdpr = t.gdprConsent.gdprApplies ? "true" : "false", t.gdprConsent.consentString && (i.consent_string = t.gdprConsent.consentString)), e[0].schain && (i.schain = JSON.stringify(e[0].schain)), Object(p.deepAccess)(e[0], "userId") && 0 < Object.keys(e[0].userId).length && (i.userid = JSON.stringify(e[0].userId));
        r = e[0].params.keywords;
        if (r && (i.kw = r), t && t.uspConsent && (i.us_privacy = t.uspConsent), Object(p.isEmpty)(n)) return null;
        t = "https://apex.go.sonobi.com/trinity.json";
        return {
          method: "GET",
          url: t = Object(p.deepAccess)(e[0], "params.bid_request_url") ? Object(p.deepAccess)(e[0], "params.bid_request_url") : t,
          withCredentials: !0,
          data: i,
          bidderRequests: e
        };
      },
      interpretResponse: function interpretResponse(e, a) {
        var c = e.body,
            d = [],
            u = a.data.ref;
        return 0 === Object.keys(c.slots).length || Object.keys(c.slots).forEach(function (e) {
          var t = c.slots[e],
              r = e.split("|").slice(-1)[0],
              n = function (e, t) {
            for (var r = 0; r < e.length; r++) {
              if (e[r].bidId === t) return e[r];
            }
          }(a.bidderRequests, r),
              i = null;

          "video" === t.sbi_ct && (i = "video", "outstream" === Object(p.deepAccess)(n, "mediaTypes.video.context") && (i = "outstream"));
          var s,
              o = y(i, u);
          t.sbi_aid && t.sbi_mouse && t.sbi_size && (e = void 0 === (e = (s = l(t.sbi_size.split("x"), 2))[0]) ? 1 : e, s = void 0 === (s = s[1]) ? 1 : s, s = {
            requestId: r,
            cpm: Number(t.sbi_mouse),
            width: Number(e),
            height: Number(s),
            ad: o(c.sbi_dc, t.sbi_aid),
            ttl: 500,
            creativeId: t.sbi_crid || t.sbi_aid,
            aid: t.sbi_aid,
            netRevenue: !0,
            currency: "USD"
          }, t.sbi_dozer && (s.dealId = t.sbi_dozer), "video" === i ? (s.mediaType = "video", s.vastUrl = o(c.sbi_dc, t.sbi_aid), delete s.ad, delete s.width, delete s.height) : "outstream" === i && n && (s.mediaType = "video", s.vastUrl = o(c.sbi_dc, t.sbi_aid), s.renderer = function (e, t) {
            var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
                e = b.a.install({
              id: t.aid,
              url: "https://mtrx.go.sonobi.com/sbi_outstream_renderer.js",
              config: r,
              loaded: !1,
              adUnitCode: e
            });

            try {
              e.setRender(j);
            } catch (e) {
              Object(p.logWarn)("Prebid Error calling setRender on renderer", e);
            }

            return e.setEventHandlers({
              impression: function impression() {
                return Object(p.logMessage)("Sonobi outstream video impression event");
              },
              loaded: function loaded() {
                return Object(p.logMessage)("Sonobi outstream video loaded event");
              },
              ended: function ended() {
                Object(p.logMessage)("Sonobi outstream renderer video event");
              }
            }), e;
          }(n.adUnitCode, s, Object(p.deepAccess)(n, "renderer.options")), n = Object(p.deepAccess)(n, "params.sizes"), (n = Array.isArray(n) && Array.isArray(n[0]) ? n[0] : n) && (s.width = n[0], s.height = n[1])), d.push(s));
        }), d;
      },
      getUserSyncs: function getUserSyncs(e, t, r, n) {
        var i = [];

        try {
          e.pixelEnabled && t[0].body.sbi_px.forEach(function (e) {
            i.push({
              type: e.type,
              url: e.url
            });
          });
        } catch (e) {}

        return i;
      }
    };

    function m(e) {
      return Object(p.deepAccess)(e, "mediaTypes.video") ? "" : e.params.sizes ? Object(p.parseSizesInput)(e.params.sizes).join(",") : Object(p.deepAccess)(e, "mediaTypes.banner.sizes") ? Object(p.parseSizesInput)(Object(p.deepAccess)(e, "mediaTypes.banner.sizes")).join(",") : e.sizes ? Object(p.parseSizesInput)(e.sizes).join(",") : void 0;
    }

    function v(e) {
      return e.params.floor ? "|f=".concat(e.params.floor) : "";
    }

    var y = function y(i, s) {
      return function (e, t) {
        return "video" === i || "outstream" === i ? (r = t, n = s, "https://".concat(e, "apex.go.sonobi.com/vast.xml?vid=").concat(r, "&ref=").concat(encodeURIComponent(n))) : '<script type="text/javascript" src="' + "https://".concat(e, "apex.go.sonobi.com/sbi.js?aid=").concat(t, "&as=null&ref=").concat(encodeURIComponent(s)) + '"><\/script>';
        var r, n;
      };
    };

    var g = function g() {
      var r = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : window;
      return function () {
        var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 0,
            t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : Number.MAX_SAFE_INTEGER;
        return r.innerWidth >= e && r.innerWidth < t;
      };
    };

    function h() {
      var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : window,
          t = g(e),
          r = 992,
          e = 768;
      return t(0, 768) ? "mobile" : t(e, r) ? "tablet" : "desktop";
    }

    function j(n) {
      n.renderer.push(function () {
        var e = l(n.getSize().split("x"), 2),
            t = e[0],
            r = e[1],
            e = new window.SbiOutstreamRenderer();
        e.init({
          vastUrl: n.vastUrl,
          height: r,
          width: t
        }), e.setRootElement(n.adUnitCode);
      });
    }

    Object(n.registerBidder)(f);
  }
}, [729]);
pbjsChunk([97], {
  737: function _(e, r, t) {
    e.exports = t(738);
  },
  738: function _(e, r, t) {
    "use strict";

    Object.defineProperty(r, "__esModule", {
      value: !0
    }), t.d(r, "spec", function () {
      return i;
    });
    var c = t(0),
        r = t(1),
        n = t(2),
        i = {
      code: "sovrn",
      supportedMediaTypes: [n.b],
      isBidRequestValid: function isBidRequestValid(e) {
        return !(!e.params.tagid || isNaN(parseFloat(e.params.tagid)) || !isFinite(e.params.tagid));
      },
      buildRequests: function buildRequests(e, r) {
        try {
          var t,
              n,
              i,
              s = [];

          c._each(e, function (e) {
            i = i || c.deepAccess(e, "userId.tdid"), e.schain && (n = n || e.schain), t = t || c.getBidIdParameter("iv", e.params);
            var r = e.mediaTypes && e.mediaTypes.banner && e.mediaTypes.banner.sizes || e.sizes,
                r = (r = (r = c.isArray(r) && c.isArray(r[0]) ? r : [r]).filter(function (e) {
              return c.isArray(e);
            })).map(function (e) {
              return {
                w: parseInt(e[0], 10),
                h: parseInt(e[1], 10)
              };
            });
            s.push({
              adunitcode: e.adUnitCode,
              id: e.bidId,
              banner: {
                format: r,
                w: 1,
                h: 1
              },
              tagid: String(c.getBidIdParameter("tagid", e.params)),
              bidfloor: c.getBidIdParameter("bidfloor", e.params)
            });
          });

          var a,
              d = r.refererInfo.referer,
              o = c.parseUrl(d).hostname,
              p = {
            id: c.getUniqueIdentifierStr(),
            imp: s,
            site: {
              page: d,
              domain: o
            }
          };
          n && (p.source = {
            ext: {
              schain: n
            }
          }), r.gdprConsent && (c.deepSetValue(p, "regs.ext.gdpr", +r.gdprConsent.gdprApplies), c.deepSetValue(p, "user.ext.consent", r.gdprConsent.consentString)), r.uspConsent && c.deepSetValue(p, "regs.ext.us_privacy", r.uspConsent), i && (a = [{
            source: "adserver.org",
            uids: [{
              id: i,
              ext: {
                rtiPartner: "TDID"
              }
            }]
          }], c.deepSetValue(p, "user.ext.eids", a));
          var u = "https://ap.lijit.com/rtb/bid?src=prebid_prebid_4.4.0";
          return t && (u += "&iv=".concat(t)), {
            method: "POST",
            url: u,
            data: JSON.stringify(p),
            options: {
              contentType: "text/plain"
            }
          };
        } catch (e) {
          c.logError("Could not build bidrequest, error deatils:", e);
        }
      },
      interpretResponse: function interpretResponse(e) {
        var r = e.body,
            e = r.id,
            r = r.seatbid;

        try {
          var t = [];
          return e && r && 0 < r.length && r[0].bid && 0 < r[0].bid.length && r[0].bid.map(function (e) {
            t.push({
              requestId: e.impid,
              cpm: parseFloat(e.price),
              width: parseInt(e.w),
              height: parseInt(e.h),
              creativeId: e.crid || e.id,
              dealId: e.dealid || null,
              currency: "USD",
              netRevenue: !0,
              mediaType: n.b,
              ad: decodeURIComponent("".concat(e.adm, '<img src="').concat(e.nurl, '">')),
              ttl: 60
            });
          }), t;
        } catch (e) {
          c.logError("Could not intrepret bidresponse, error deatils:", e);
        }
      },
      getUserSyncs: function getUserSyncs(e, r, t, n) {
        try {
          var i,
              s,
              a = [];
          return r && 0 !== r.length && (e.iframeEnabled && (i = r.filter(function (e) {
            return c.deepAccess(e, "body.ext.iid");
          }).map(function (e) {
            return e.body.ext.iid;
          }), s = [], t && t.gdprApplies && "string" == typeof t.consentString && s.push(["gdpr_consent", t.consentString]), n && s.push(["us_privacy", n]), i[0] && (s.push(["informer", i[0]]), a.push({
            type: "iframe",
            url: "https://ap.lijit.com/beacon?" + s.map(function (e) {
              return e.join("=");
            }).join("&")
          }))), e.pixelEnabled && r.filter(function (e) {
            return c.deepAccess(e, "body.ext.sync.pixels");
          }).reduce(function (e, r) {
            return e.concat(r.body.ext.sync.pixels);
          }, []).map(function (e) {
            return e.url;
          }).forEach(function (e) {
            return a.push({
              type: "image",
              url: e
            });
          })), a;
        } catch (e) {
          return [];
        }
      }
    };
    Object(r.registerBidder)(i);
  }
}, [737]);
pbjs.processQueue();